import React, { useState, useEffect, useRef } from 'react';
import { Wallet, IndianRupee } from "lucide-react";
import { ArrowLeft, Download, Loader, Upload, X, RefreshCw, MapPin, FileText, Printer, Send, Plus, Save, Edit2, Filter, ChevronDown, ChevronUp, Globe } from 'lucide-react';
import LandAcquisitionNotice from './CompensationNotices';
import { toast } from 'react-toastify';
import FinalAwardNotice from './FinalAwardNotice';
import html2pdf from 'html2pdf.js';
import { useLanguage } from '../StoreContext/LanguageContext';
import apiService from '../config';
import { useSignature } from '../DigitalSignature/UseSignatue';
import SignaturePad from '../DigitalSignature/SignaturePad';

const CompensationTable = ({ onBack, setSubComponent, subComponent }) => {
    const { language, translations } = useLanguage();
    // Location data states
    const [districts, setDistricts] = useState([]);
    const [availableTalukas, setAvailableTalukas] = useState([]);
    const [availableVillages, setAvailableVillages] = useState([]);

    const [currentLaoId, setCurrentLaoId] = useState([]);
    // const [selectedOwners, setSelectedOwners] = useState([]);
    const [isFinalAwardButtonDisabled, setIsFinalAwardButtonDisabled] = useState(false);

    // Filter states
    const [selectedDistrict, setSelectedDistrict] = useState('');
    const [selectedTaluka, setSelectedTaluka] = useState('');
    const [selectedVillage, setSelectedVillage] = useState('');

    // NEW: Filter mode and panel states
    const [filterMode, setFilterMode] = useState('all');
    const [showFilterPanel, setShowFilterPanel] = useState(false);

    // Data states
    const [compensationData, setCompensationData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loadingDistricts, setLoadingDistricts] = useState(false);
    const [loadingTalukas, setLoadingTalukas] = useState(false);
    const [loadingVillages, setLoadingVillages] = useState(false);

    // UI states
    const [error, setError] = useState(null);
    const [downloading, setDownloading] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);
    const [showNotice, setShowNotice] = useState(false);

    // Edit Compensation Modal states
    const [showEditModal, setShowEditModal] = useState(false);
    const [editingCompensation, setEditingCompensation] = useState(false);
    const [editError, setEditError] = useState(null);
    const [editSuccess, setEditSuccess] = useState(false);
    const [currentEditRecord, setCurrentEditRecord] = useState(null);

    // Current project info
    const [currentProjectId, setCurrentProjectId] = useState('');
    const [currentProjectName, setCurrentProjectName] = useState('');
    const [currentProposalId, setCurrentProposalId] = useState(null);

    const [sendingToCoordination, setSendingToCoordination] = useState(false);
    const [selectedOwnerIds, setSelectedOwnerIds] = useState([]);

    const [usersLAO, setusersLAO] = useState([]);

    // Extract LAO details
    const laoName = usersLAO?.[0]?.full_name || 'N/A';
    const laoDesi = usersLAO?.[0]?.designation || 'N/A';

    const [previewUrl, setPreviewUrl] = useState(null);
    const [showSignaturePad, setShowSignaturePad] = useState(false);
    const [pdfForSigning, setPdfForSigning] = useState(null);
    const { signDocument } = useSignature();


    // Asset Property 
    // Tree
    const [updatingTrees, setUpdatingTrees] = useState({});
    const [treeUpdateErrors, setTreeUpdateErrors] = useState({});
    // Home
    const [updatingHomes, setUpdatingHomes] = useState({});
    const [homeUpdateErrors, setHomeUpdateErrors] = useState({});
    // Tinshed
    const [updatingTinshed, setUpdatingTinshed] = useState({});
    const [TinshedUpdateErrors, setTinshedUpdateErrors] = useState({});
    // Wirefencing
    const [updatingWirefencing, setUpdatingWirefencing] = useState({});
    const [wirefencingUpdateErrors, setWirefencingUpdateErrors] = useState({});
    // farmpond
    const [updatingFarmpond, setUpdatingFarmpond] = useState({});
    const [farmpondUpdateErrors, setFarmpondUpdateErrors] = useState({});
    // well
    const [updatingWell, setUpdatingWell] = useState({});
    const [wellUpdateErrors, setWellUpdateErrors] = useState({});
    // pipeline
    const [updatingPipeline, setUpdatingPipeline] = useState({});
    const [pipelineUpdateErrors, setPipelineUpdateErrors] = useState({});
    // borewell
    const [updatingBoreWell, setUpdatingBoreWell] = useState({});
    const [boreWellUpdateErrors, setBoreWellUpdateErrors] = useState({});
    // other
    const [updatingOther, setUpdatingOther] = useState({});
    const [otherUpdateErrors, setOtherUpdateErrors] = useState({});

    // const [noticeRecord, setNoticeRecord] = useState(null);
    const [noticeTargetId, setNoticeTargetId] = useState(null);

    // Edit Compensation Form Data
    const [editCompensationForm, setEditCompensationForm] = useState({
        // Land details
        landRate: '',
        landAmount: '',
        landMultiplied: '',
        // Land Calculation Fields
        totalLandArea: '',
        acquiredLandArea: '',
        landRatePerUnit: '',
        // advance amount
        advanceAmount: '',
        advanceDate: '',
        govtRecovery: '',
        // Structure details
        structureCount: '',
        structureRate: '',
        structureAmount: '',
        // Tree details
        no_of_tree: '',
        treeRate: '',
        treeAmount: '',
        // Crop details
        cropCount: '',
        cropRate: '',
        cropAmount: '',
        // Water body details
        waterBodyCount: '',
        waterBodyRate: '',
        waterBodyAmount: '',
        // Borewell details
        borewellCount: '',
        borewellRate: '',
        borewellAmount: '',
        // Home details
        homeCount: '',
        homeRate: '',
        homeAmount: '',
        // Pipeline details
        pipelineCount: '',
        pipelineRate: '',
        pipelineAmount: '',
        // Wire details
        wireCount: '',
        wireRate: '',
        wireAmount: '',
        // Other asset details
        otherAssetCount: '',
        otherAssetRate: '',
        otherAssetAmount: '',
        // Solatium details
        solatiumPercentage: '30',
        solatiumAmount: '',
        // Interest details with date range
        interestRate: '12',
        interestFromDate: '',
        interestToDate: '',
        interestAmount: '',
        interestDays: '',
        advanceInterestAmount: '',
        // Additional compensation
        additionalCompensation: '',
        additionalCompensationReason: '',
        // Total compensation
        allTotal: '',
        totalCompensation: '',
        // Currency and status
        currency: 'INR',
        compensationStatus: '',
        // Dates
        valuationDate: new Date().toISOString().split('T')[0],
        interestFromDate: new Date().toISOString().split('T')[0],
        interestToDate: new Date().toISOString().split('T')[0],

        compensationApprovalDate: new Date().toISOString().split('T')[0],
        // Approval details
        compensationApprovalAuthority: '',
        compensationApprovalReference: '',
        // Image file
        image: null
    });

    // Success message
    const [showSuccess, setShowSuccess] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [showSendToLAOModal, setShowSendToLAOModal] = useState(false);
    const [users, setUsers] = useState([]);
    const [selectedUser, setSelectedUser] = useState('');
    const [remarks, setRemarks] = useState('Approved');
    const [loadingUsers, setLoadingUsers] = useState(false);
    const [sendingToLAO, setSendingToLAO] = useState(false);
    const [selectedDocument, setSelectedDocument] = useState(null);
    const [tableData, setTableData] = useState([]);

    const [showConfirmationModal, setShowConfirmationModal] = useState(false);
    const [onConfirmAction, setOnConfirmAction] = useState(null);

    const [collectorSection11Date, setCollectorSection11Date] = useState(null);

    const [userRole, setUserRole] = useState(null);
    useEffect(() => {
        const userData = localStorage.getItem("userData");
        if (userData) {
            try {
                const user = JSON.parse(userData);
                setUserRole(user.user_role || user.user_role_name); // Prefer numeric role ID
            } catch (e) {
                console.error("Failed to parse user data", e);
            }
        }
    }, []);

    // Proposal location states
    const [proposalData, setProposalData] = useState(null);

    useEffect(() => {
        // if (currentProjectId && currentProposalId) {
        //     fetchFinalAwardButtonStatus();
        // }
        fetchProposalData();
    }, [currentProjectId, currentProposalId]);

    const tableRef = useRef(null);

    const handlePrint = () => {
        const printContents = tableRef.current.innerHTML;
        const win = window.open("", "_blank");
        win.document.write(`
<!DOCTYPE html>
<html>
<head>
  <meta charset="UTF-8">
  <title>प्रपत्र इ - दुरुस्ती</title>
  <style>
    @page { size: A3 landscape; margin: 3mm; }
    * { margin: 0; padding: 0; box-sizing: border-box; }
    body { padding: 3mm; font-family: Arial, sans-serif; }
    table { width: 100% !important; border-collapse: collapse !important; }
    th, td { border: 0.5px solid #000 !important; padding: 2px !important; font-size: 7px !important; text-align: center !important; }
    th { background: #f3f4f6 !important; font-weight: bold !important; }
    .bg-blue-50 { background: #eff6ff !important; }
    .bg-green-100 { background: #dcfce7 !important; }
    .no-print { display: none !important; }
    .header { text-align: center; margin-bottom: 3mm; }
    .header p { margin: 1mm 0; font-size: 10pt; }
    .signature-section { margin-top: 5mm; text-align: right; padding-right: 10mm; }
    @media print {
      body { padding: 2mm; }
      table { font-size: 6px !important; }
      th, td { font-size: 6px !important; }
    }
  </style>
</head>
<body>
  <div class="header">
    <p><strong>${currentProjectName}</strong></p>
    <p><strong>भूसंपादन प्रकरण क्रमांक ${proposalData.section_11_bhusampadan_no}</strong></p>
    <p>गाव- <strong>${proposalData.village_name || ''}</strong> तालुका- <strong>${proposalData.taluka_name || ''}</strong> जिल्हा- <strong>${proposalData.dist_name || ''}</strong></p>
  </div>
  ${printContents}
  <div class="signature-section">
    <div><strong>(${laoName})</strong></div>
    <div><strong>${laoDesi}</strong></div>
  </div>
  <script>
    window.onload = function() {
      setTimeout(() => { window.focus(); window.print(); }, 300);
    }
  </script>
</body>
</html>
`);
        win.document.close();
    };

    const handleUploadedFile = (e) => {
        const file = e.target.files[0];

        if (!file) return;

        // ✅ open uploaded file in signature modal
        setPdfForSigning(file);
        setShowSignaturePad(true);
    };


    // ProposalData
    const fetchProposalData = () => {
        try {
            const storedProposal = JSON.parse(localStorage.getItem('selectedProposal') || '{}');
            setProposalData(storedProposal || {});
        } catch (error) {

        }
    };

    // NEW: Helper functions for filter logic
    const hasValidLocationSelection = selectedDistrict && selectedTaluka && selectedVillage;
    const canShowData = filterMode === 'all' || (filterMode === 'location' && hasValidLocationSelection);

    // Helper function to get current location description
    const getCurrentLocationDescription = () => {
        if (filterMode === 'all') {
            return 'All Locations';
        }

        if (selectedDistrict && selectedTaluka && selectedVillage) {
            return `Village: ${selectedVillage}, ${selectedTaluka}, ${selectedDistrict}`;
        } else if (selectedDistrict && selectedTaluka) {
            return `Taluka: ${selectedTaluka}, ${selectedDistrict}`;
        } else if (selectedDistrict) {
            return `District: ${selectedDistrict}`;
        } else {
            return 'No location selected';
        }
    };

    // Helper function to calculate days between two dates
    const calculateDaysBetweenDates = (fromDate, toDate) => {
        if (!fromDate || !toDate) return 0;
        const startDate = new Date(fromDate);
        const endDate = new Date(toDate);
        const timeDifference = endDate.getTime() - startDate.getTime();
        const daysDifference = Math.ceil(timeDifference / (1000 * 3600 * 24));
        return daysDifference > 0 ? daysDifference : 0;
    };

    // Helper function to calculate interest amount based on date range
    const calculateInterestAmount = (principal, rate, fromDate, toDate) => {
        if (!principal || !rate || !fromDate || !toDate) return 0;
        const days = calculateDaysBetweenDates(fromDate, toDate);
        if (days <= 0) return 0;
        const years = days / 365;
        const interestAmount = (principal * rate * years) / 100;
        return Math.round(interestAmount * 100) / 100;
    };

    // const fetchFinalAwardButtonStatus = async () => {
    //     try {
    //         if (currentProjectId && currentProposalId) {
    //             const response = await apiService.getFinalAwardButton(currentProjectId, currentProposalId, 'finalAward');
    //             console.log("Final Award Button Status:", response.buttonDisable);
    //             setIsFinalAwardButtonDisabled(!response.buttonDisable); // invert if true means disabled
    //         }
    //     } catch (error) {
    //         console.error("Error fetching button state:", error);
    //     }
    // };

    const handleSendToFinalAwards = async () => {
        // if (selectedOwners.length === 0) {
        //   alert('Please select at least one owner by checking the checkboxes.');
        //   return;
        // }
        if (!compensationData.length) {
            alert('No compensation records found.');
            return;
        }

        if (!currentProjectId || !currentProposalId) {
            alert('Project ID and Proposal ID are required.');
            return;
        }

        const ownerIds = compensationData.map(o => o.landOwnerId || o.id || o.compId).filter(id => !!id).join(',');
        const remarks = "Compensation to final award!";
        // const ownerIds = selectedOwners.join(','); // Convert array to comma-separated string

        // Here Completed or pending
        const allCompleted = compensationData.every(
            (record) => record.compensationStatus === 'Completed'
        );

        if (!allCompleted) {
            alert(translations[language]?.PleaseCompleteAllRecordsBeforeSendingToFinalAward || 'Please complete all records before sending to Final Award.');
            return;
        }

        try {
            setSendingToCoordination(true);

            const formData = new FormData();
            formData.append('project_id', currentProjectId);
            formData.append('proposal_id', currentProposalId);
            formData.append('remarks', remarks);
            formData.append('usr_id', currentLaoId);
            formData.append('owner_id', ownerIds); // Send comma-separated string

            const response = await apiService.postTrackingfinalAward(formData);
            console.log('Send to Payment response:', response);

            if (response.status === 200) {
                alert(translations[language]?.SuccessfullySentToFinalAwards || `Successfully sent to FinalAwards!`);

                setIsFinalAwardButtonDisabled(true);

                // Navigate to payment screen - you can implement this based on your routing
                if (onBack) {
                    onBack('FinalReward');
                }
                // Or use your routing method here
            } else {
                alert('Failed to send to Final Award. Please try again.');
            }
        } catch (error) {
            console.error('Error sending to Final Award:', error);
            alert('Failed to send to Final Award. Please try again.');
        } finally {
            setSendingToCoordination(false);
        }
    };

    // Get selected project from localStorage
    useEffect(() => {
        const getSelectedProject = () => {
            try {
                const storedProject = localStorage.getItem('selectedProject');
                if (storedProject) {
                    const project = JSON.parse(storedProject);
                    const projectIdFromStorage = project.id || project.project_id;
                    const projectName = project.project_name || '';

                    if (projectIdFromStorage && projectIdFromStorage !== currentProjectId) {
                        setCurrentProjectId(projectIdFromStorage);
                        setCurrentProjectName(projectName);
                    }
                }
            } catch (error) {
                console.error('Error reading selected project:', error);
            }
        };

        getSelectedProject();
        window.addEventListener('storage', getSelectedProject);
        return () => window.removeEventListener('storage', getSelectedProject);
    }, [currentProjectId]);

    // Load districts on component mount
    useEffect(() => {
        loadDistricts();
    }, []);

    // Proposal id
    useEffect(() => {
        const getProposalInfo = () => {
            const currentProposal = JSON.parse(localStorage.getItem('userData') || '{}');

            if (currentProposal) {
                try {
                    const proposalId = currentProposal?.data?.default_proposal ||
                        currentProposal?.data?.proposal_id ||
                        currentProposal?.default_proposal ||
                        currentProposal?.proposal_id ||
                        null;

                    const laoUserId = currentProposal?.data?.usr_id || currentProposal?.usr_id;

                    setCurrentLaoId(laoUserId);
                    console.log("Current LAO User ID:", laoUserId);

                    return { proposalId };
                } catch (e) {
                    console.error('Error parsing current project data (getProposalInfo):', e);
                }
            }
            return { proposalId: null };
        };

        const proposalInfo = getProposalInfo();
        setCurrentProposalId(proposalInfo.proposalId);
        console.log('Current Project-Proposal Info:', proposalInfo);
    }, []);

    // Load districts
    const loadDistricts = async () => {
        try {
            setLoadingDistricts(true);
            const response = await apiService.getDistricts();
            const districtsData = response.data || response || [];
            const districtsArray = Array.isArray(districtsData) ? districtsData : [];
            setDistricts(districtsArray);

            // if (districtsArray.length > 0 && !selectedDistrict) {
            //   const defaultDistrict = getDistrictDisplayName(districtsArray[0]);
            //   setSelectedDistrict(defaultDistrict);
            // }
        } catch (error) {
            console.error('Error loading districts:', error);
            setDistricts([]);
        } finally {
            setLoadingDistricts(false);
        }
    };

    // Load talukas when district changes
    useEffect(() => {
        if (selectedDistrict) {
            loadTalukas();
        } else {
            setAvailableTalukas([]);
            setSelectedTaluka('');
            setSelectedVillage('');
            setAvailableVillages([]);
        }
    }, [selectedDistrict]);

    // Load talukas
    const loadTalukas = async () => {
        try {
            setLoadingTalukas(true);
            const selectedDistrictObj = districts.find(d =>
                d.name === selectedDistrict || d.dist_name === selectedDistrict
            );

            if (!selectedDistrictObj) return;

            const distNo = selectedDistrictObj.dist_name;
            const response = await apiService.getTalukas(distNo);
            const talukasData = response.data || response || [];
            const talukasArray = Array.isArray(talukasData) ? talukasData : [];
            setAvailableTalukas(talukasArray);

            // if (talukasArray.length > 0 && !selectedTaluka) {
            //   const defaultTaluka = getTalukaDisplayName(talukasArray[0]);
            //   setSelectedTaluka(defaultTaluka);
            // }
        } catch (error) {
            console.error('Error loading talukas:', error);
            setAvailableTalukas([]);
        } finally {
            setLoadingTalukas(false);
        }
    };

    // Load villages when taluka changes
    useEffect(() => {
        if (selectedTaluka && selectedDistrict) {
            loadVillages();
        } else {
            setAvailableVillages([]);
            setSelectedVillage('');
        }
    }, [selectedTaluka, selectedDistrict]);

    // Load villages
    const loadVillages = async () => {
        try {
            setLoadingVillages(true);
            const selectedDistrictObj = districts.find(d =>
                d.name === selectedDistrict || d.dist_name === selectedDistrict
            );
            const selectedTalukaObj = availableTalukas.find(t =>
                t.name === selectedTaluka || t.taluka_name === selectedTaluka || t.tehsil_name === selectedTaluka
            );

            if (!selectedDistrictObj || !selectedTalukaObj) return;

            const distNo = selectedDistrictObj.dist_name;
            const tehsilNo = selectedTalukaObj.taluka_name;

            const response = await apiService.getVillages(distNo, tehsilNo);
            const villagesData = response.data || response || [];
            const villagesArray = Array.isArray(villagesData) ? villagesData : [];
            setAvailableVillages(villagesArray);

            // if (villagesArray.length > 0 && !selectedVillage) {
            //   const defaultVillage = getVillageDisplayName(villagesArray[0]);
            //   setSelectedVillage(defaultVillage);
            // }
        } catch (error) {
            console.error('Error loading villages:', error);
            setAvailableVillages([]);
        } finally {
            setLoadingVillages(false);
        }
    };

    // UPDATED: Load compensation data based on filter mode
    useEffect(() => {
        if (filterMode === 'all' && currentProjectId && currentProposalId) {
            loadCompensationDataForAll();
        }
    }, [filterMode, currentProjectId, currentProposalId]);

    // Fetch LAO users
    useEffect(() => {
        const fetchusersLAO = async () => {
            const role = 3;
            try {
                const response = await apiService.getAssignLAO(role, currentProjectId, currentProposalId);
                console.log('LAO users:', response);
                if (response.status === 200 && response.data) {
                    setusersLAO(Array.isArray(response.data) ? response.data : []);
                } else {
                    setusersLAO([]);
                }
            } catch (error) {
                console.error('Error fetching LAO users:', error);
                setusersLAO([]);
            }
        };

        if (currentProjectId && currentProposalId) {
            fetchusersLAO();
        }
    }, [currentProjectId, currentProposalId]);

    useEffect(() => {
        if (filterMode === 'location' && selectedDistrict && selectedTaluka && selectedVillage && currentProjectId && currentProposalId) {
            loadCompensationData();
        } else if (filterMode === 'location') {
            setCompensationData([]);
            setTableData([]);
        }
    }, [filterMode, selectedDistrict, selectedTaluka, selectedVillage, currentProjectId, currentProposalId]);

    const roundTo = (num, decimals = 2) =>
        Math.round(num * Math.pow(10, decimals)) / Math.pow(10, decimals);

    // Transform backend data to component structure
    const transformBackendData = (backendData) => {
        return backendData.map(item => {
            console.log('🔍 Backend item for transformation:', {
                land_owner_id: item.land_owner_id,
                owner_name: item.owner_name,
                survey_no: item.survey_no,
                dist_name: item.dist_name,
                land_rate: item.land_rate,
                land_amount_multiplied: item.land_amount_multiplied,

                // Asset Property
                treeData: item.tree,
                homeData: item.home,
                tinshedData: item["tinshed/godown"],
                wireFencingData: item.wirefencing,
                farmpondData: item.farmpond,
                wellData: item.well,
                pipelineData: item.pipeline,
                borewellData: item.borewell,
                otherData: item.other,
                owner_aqr_area_land_rate: item.owner_aqr_area_land_rate,
                owner_aqr_area: item.owner_aqr_area,

            });

            const ownerId = item.land_owner_id;

            if (!ownerId) {
                console.warn('⚠️ No land_owner_id found for item:', item);
            }

            // FIX: Use correct field names from API
            const structureCount = parseInt(item.no_of_structure ?? 0) || 0;
            const treeCount = parseInt(item.no_of_tree ?? 0) || 0;
            const cropCount = parseInt(item.no_of_crop ?? 0) || 0;
            const waterBodyCount = parseInt(item.no_of_water_body ?? 0) || 0;
            const borewellCount = parseInt(item.no_of_borewell ?? 0) || 0;
            const homeCount = parseInt(item.no_of_home ?? 0) || 0;
            const pipelineCount = parseInt(item.no_of_pipeline ?? 0) || 0;
            const tinshedCount = parseInt(item.no_of_tinshed ?? 0) || 0;
            const wireCount = parseInt(item.no_of_wirefencing ?? 0) || 0;
            const otherAssetCount = parseInt(item.no_of_other_asset ?? 0) || 0;

            // Get actual compensation amounts
            const structureCompensationAmount = parseFloat(item.structure_amount ?? 0) || 0;
            const treeCompensationAmount = parseFloat(item.tree_amount ?? 0) || 0;
            const forestTreeCompensationAmount = parseFloat(item.forest_tree_amount ?? 0) || 0;
            const totalTreeCompensationAmount = parseFloat((item.tree_amount ?? 0) + (item.forest_tree_amount ?? 0)) || 0;
            const cropCompensationAmount = parseFloat(item.crop_amount ?? 0) || 0;
            const waterBodyCompensationAmount = parseFloat(item.water_body_amount ?? 0) || 0;
            const borewellCompensationAmount = parseFloat(item.borewell_amount ?? 0) || 0;
            const homeCompensationAmount = parseFloat(item.home_amount ?? 0) || 0;
            const pipelineCompensationAmount = parseFloat(item.pipeline_amount ?? 0) || 0;
            const tinshedCompensationAmount = parseFloat(item.tinshed_amount ?? 0) || 0;
            const wireCompensationAmount = parseFloat(item.wire_amount ?? 0) || 0;
            const otherAssetCompensationAmount = parseFloat(item.other_asset_amount ?? 0) || 0;
            const solatiumAmount = Number(item.solatium_compensation_amount ?? 0).toFixed(2);
            const interestAmount = parseFloat(item.interest_amount ?? 0) || 0;
            const advanceInterestAmount = parseFloat(item.advance_payment_interest_amount ?? 0) || 0;
            const additionalCompensation = parseFloat(item.additional_compensation ?? 0) || 0;
            const totalCompensation = parseFloat(item.total_compensation ?? 0) || 0;
            const bothInterestTotal = (Number(interestAmount || 0) + Number(advanceInterestAmount || 0)).toFixed(2);

            // Use owner_aqr_area for acquired area
            const acquiredAreaValue = parseFloat(item.owner_aqr_area ?? 0) || 0;

            // Calculate land compensation from API data
            // const landRatePerUnit = parseFloat(item.owner_aqr_area_land_rate ?? 0) || 0;
            const landRate = parseFloat(item.land_rate ?? 0) || 0;
            const landValueTotal = parseFloat(item.land_amount ?? 0) || 0;
            const landRateFinalAmount = (acquiredAreaValue * landRate).toFixed(2);

            // Interest Date
            const interestFromDate = formatDate(item.intrest_start_dt);
            const interestToDate = formatDate(item.intrest_end_dt);
            const advanceAmount = parseFloat(item.advance_amount ?? 0) || 0;
            const govtRecovery = parseFloat(item.govt_recovery ?? 0) || 0;

            // Calculate base compensation total
            const baseCompensationTotal = landValueTotal + structureCompensationAmount + treeCompensationAmount + forestTreeCompensationAmount + cropCompensationAmount + waterBodyCompensationAmount + borewellCompensationAmount + homeCompensationAmount + pipelineCompensationAmount + tinshedCompensationAmount + wireCompensationAmount + otherAssetCompensationAmount;

            const compensationStatus = item.COMPENSATION_STATUS || 'Pending';

            // Convert acquired area to hectare/are/sq_meter format
            const totalSqMeters = acquiredAreaValue;
            const hectares = Math.floor(totalSqMeters / 10000);
            const remainingAfterHectares = totalSqMeters % 10000;
            const ares = Math.floor(remainingAfterHectares / 100);
            const sqMeters = remainingAfterHectares % 100;

            // Calculate totals step by step
            // First Total: Land + Tree + Home + Tinshed + Water Body + Borewell + Structure
            const firstTotal = Number(
                (
                    (Number(landValueTotal) || 0) +
                    (Number(treeCompensationAmount) || 0) +
                    (Number(forestTreeCompensationAmount) || 0) +
                    (Number(homeCompensationAmount) || 0) +
                    (Number(tinshedCompensationAmount) || 0) +
                    (Number(waterBodyCompensationAmount) || 0) +
                    (Number(borewellCompensationAmount) || 0) +
                    (Number(structureCompensationAmount) || 0) +
                    (Number(cropCompensationAmount) || 0) +
                    (Number(wireCompensationAmount) || 0) +
                    (Number(otherAssetCompensationAmount) || 0)
                ).toFixed(2)
            );

            // Second Total: First Total + Solatium + Interest + Pipeline + Other compensations
            const secondTotal = Number(
                (
                    (Number(firstTotal) || 0) +
                    // (Number(interestAmount) || 0) +
                    (Number(bothInterestTotal) || 0) +
                    (Number(pipelineCompensationAmount) || 0) +
                    (Number(solatiumAmount) || 0)
                ).toFixed(2)
            );

            // Third Total: Use total compensation from API or calculated second total
            // const thirdTotal = parseFloat(secondTotal - advanceAmount - advanceInterestAmount);
            const thirdTotal = Number(
                (
                    (Number(secondTotal) || 0) -
                    (Number(govtRecovery) || 0) -
                    (Number(advanceAmount) || 0)
                ).toFixed(2)
            );

            // const thirdTotal = Number(
            //     (
            //         (Number(secondTotal) || 0) -
            //         (Number(govtRecovery) || 0) -
            //         (Number(advanceAmount) || 0) -
            //         (Number(advanceInterestAmount) || 0)
            //     ).toFixed(2)
            // );

            return {
                id: ownerId,
                compId: ownerId,
                landOwnerId: ownerId,
                owner_name: item.owner_name,
                surveyNo: item.survey_no || 'N/A',
                dist_name: item.dist_name,
                taluka_name: item.taluka_name,
                village_name: item.village_name,

                irrigableArea: item.owner_irrigable_area,
                nonIrrigableArea: item.owner_non_irrigable_area,
                ownerAquareArea: item.owner_aqr_area,
                ownerTotalArea: item.owner_total_area,
                natureOfOwner: item.nature_of_owner,
                actualOccupant: item.actual_occupant,

                // Advance amount
                advanceAmount: item.advance_amount,
                advanceDate: item.advance_date,
                govtRecovery: item.govt_recovery,

                // Area information
                area: {
                    hectare: hectares,
                    are: ares,
                    sq_meter: sqMeters
                },

                totalArea: {
                    hectare: hectares,
                    are: ares,
                    sq_meter: totalSqMeters
                },

                // Store complete raw backend data for editing
                rawData: item,

                // Acquired area
                acquiredArea: acquiredAreaValue,

                // Land rate and amount
                landMultiplied: item.land_amount_multiplied,
                landRate: parseFloat(item.land_rate),
                landAmount: landValueTotal, // Fixed: use landValueTotal instead of item.land_amount
                landRateFinalAmount: landRateFinalAmount, // Fixed: use landValueTotal instead of item.land_amount
                advanceAmount: advanceAmount,

                // Asset counts
                structureCount: structureCount,
                treeCount: treeCount,
                cropCount: cropCount,
                waterBodyCount: waterBodyCount,
                borewellCount: borewellCount,
                homeCount: homeCount,
                pipelineCount: pipelineCount,
                tinshedCount: tinshedCount,
                wireCount: wireCount,
                otherAssetCount: otherAssetCount,

                // Compensation presence flags
                landCount: (landValueTotal && landValueTotal > 0) ? 1 : 0,
                structureCompensationExists: (structureCompensationAmount && structureCompensationAmount > 0) ? 1 : 0,
                treeCompensationExists: (treeCompensationAmount && treeCompensationAmount > 0) ? 1 : 0,
                forestTreeCompensationExists: (forestTreeCompensationAmount && forestTreeCompensationAmount > 0) ? 1 : 0,
                totalTreeCompensationExists: (totalTreeCompensationAmount && totalTreeCompensationAmount > 0) ? 1 : 0,
                otherCompensationExists: ((cropCompensationAmount && cropCompensationAmount > 0) ? 1 : 0) +
                    ((waterBodyCompensationAmount && waterBodyCompensationAmount > 0) ? 1 : 0) +
                    ((borewellCompensationAmount && borewellCompensationAmount > 0) ? 1 : 0) +
                    ((homeCompensationAmount && homeCompensationAmount > 0) ? 1 : 0) +
                    ((pipelineCompensationAmount && pipelineCompensationAmount > 0) ? 1 : 0) +
                    ((tinshedCompensationAmount && tinshedCompensationAmount > 0) ? 1 : 0) +
                    ((wireCompensationAmount && wireCompensationAmount > 0) ? 1 : 0) +
                    ((otherAssetCompensationAmount && otherAssetCompensationAmount > 0) ? 1 : 0),

                // Add otherCount for proper calculation
                otherCount: cropCount + waterBodyCount + borewellCount + homeCount + pipelineCount + tinshedCount + wireCount + otherAssetCount,

                // Compensation amounts
                landCompensation: landValueTotal,
                structureCompensation: structureCompensationAmount,
                treeCompensation: treeCompensationAmount,
                forestTreeCompensation: forestTreeCompensationAmount,
                totalTreeCompensation: totalTreeCompensationAmount,
                cropCompensation: cropCompensationAmount,
                waterBodyCompensation: waterBodyCompensationAmount,
                borewellCompensation: borewellCompensationAmount,
                homeCompensation: homeCompensationAmount,
                pipelineCompensation: pipelineCompensationAmount,
                tinshedCompensation: tinshedCompensationAmount,
                wireCompensation: wireCompensationAmount,
                otherAssetCompensation: otherAssetCompensationAmount,

                // Combined other compensation
                otherCompensation: cropCompensationAmount + waterBodyCompensationAmount + borewellCompensationAmount + homeCompensationAmount + pipelineCompensationAmount + tinshedCompensationAmount + wireCompensationAmount + otherAssetCompensationAmount,

                // Base compensation total
                baseCompensationTotal: baseCompensationTotal,

                // Final amounts from API
                solatium30: solatiumAmount,
                interestAward: interestAmount,
                additionalCompensation: additionalCompensation,
                totalFinalAward: totalCompensation,

                interestFromDate: interestFromDate,
                interestToDate: interestToDate,
                advanceInterestAmount: advanceInterestAmount,

                bothInterestTotal: bothInterestTotal,

                // Add location info for all records view (but won't show in table)
                district: item.dist_name || (typeof selectedDistrict !== 'undefined' ? selectedDistrict : ''),
                taluka: item.taluka_name || (typeof selectedTaluka !== 'undefined' ? selectedTaluka : ''),
                village: item.village_name || (typeof selectedVillage !== 'undefined' ? selectedVillage : ''),

                // Remarks
                remarks: item.remarks || '',

                // Corrected totals calculation
                firstTotal: firstTotal,
                secondTotal: secondTotal,
                thirdTotal: thirdTotal,

                compensationStatus: compensationStatus,

                // Asset Property
                treeData: item.tree,
                homeData: item.home,
                tinshedData: item["tinshed/godown"],
                wireFencingData: item.wirefencing,
                farmpondData: item.farmpond,
                wellData: item.well,
                pipelineData: item.pipeline,
                borewellData: item.borewell,
                otherData: item.other,
            };
        });
    };

    // Load compensation data for specific location (original behavior)
    const loadCompensationData = async () => {
        try {
            setLoading(true);
            setError(null);

            console.log('🔄 Loading compensation data for:', {
                distName: selectedDistrict,
                talukaName: selectedTaluka,
                villName: selectedVillage,
                projectId: currentProjectId,
                proposalId: currentProposalId
            });

            const response = await apiService.getOwnerCompensation(
                selectedDistrict,
                selectedTaluka,
                selectedVillage,
                currentProjectId,
                currentProposalId
            );

            console.log('🔄 Raw API response:', response);

            if (response && (response.status === 200 || response.data)) {
                let dataArray = [];

                if (response.data && response.data.data && Array.isArray(response.data.data)) {
                    dataArray = response.data.data;
                } else if (response.data && Array.isArray(response.data)) {
                    dataArray = response.data;
                } else if (Array.isArray(response)) {
                    dataArray = response;
                } else if (response.data && !Array.isArray(response.data)) {
                    dataArray = [response.data];
                } else if (response && !response.data) {
                    dataArray = [response];
                }

                console.log('🔄 Data array for transformation:', dataArray);

                const transformedData = transformBackendData(dataArray);
                setCompensationData(transformedData);
                setTableData(transformedData);

                console.log('✅ Compensation data loaded successfully:', transformedData.length, 'records');
                console.log('✅ Compensation data loaded successfully:', transformedData);

            } else {
                setCompensationData([]);
                setTableData([]);
                setError('Invalid response structure from server');
            }
        } catch (error) {
            console.error('❌ Error loading compensation data:', error);
            setCompensationData([]);
            setTableData([]);

            if (error.message.includes('404') || error.message.includes('Not Found')) {
                setError(`No compensation records found for the selected location (${selectedVillage}, ${selectedTaluka}, ${selectedDistrict}) under Project ID: ${currentProjectId}, Proposal ID: ${currentProposalId}`);
            } else {
                setError('Failed to load compensation data: ' + error.message);
            }
        } finally {
            setLoading(false);
        }
    };

    // NEW: Load compensation data for all locations
    const loadCompensationDataForAll = async () => {
        try {
            setLoading(true);
            setError(null);

            console.log('🔍 Loading ALL compensation data for project:', currentProjectId, 'proposal:', currentProposalId);

            const response = await apiService.getOwnerCompensation(selectedDistrict, selectedTaluka, selectedVillage, currentProjectId, currentProposalId);

            if (response && (response.status === 200 || response.data)) {
                let dataArray = [];

                if (response.data && response.data.data && Array.isArray(response.data.data)) {
                    dataArray = response.data.data;
                } else if (response.data && Array.isArray(response.data)) {
                    dataArray = response.data;
                } else if (Array.isArray(response)) {
                    dataArray = response;
                } else if (response.data && !Array.isArray(response.data)) {
                    dataArray = [response.data];
                } else if (response && !response.data) {
                    dataArray = [response];
                }

                const transformedData = transformBackendData(dataArray);
                setCompensationData(transformedData);
                setTableData(transformedData);
                console.log('✅ All compensation data loaded successfully:', transformedData.length, 'records');
                console.log('✅ All compensation data loaded successfully:', transformedData);

            } else {
                setCompensationData([]);
                setTableData([]);
                setError('Invalid response structure from server');
            }
        } catch (error) {
            console.error('Error loading all compensation data:', error);
            setCompensationData([]);
            setTableData([]);

            if (error.message.includes('404') || error.message.includes('Not Found')) {
                setError(`No compensation records found for Project ID: ${currentProjectId}, Proposal ID: ${currentProposalId}`);
            } else {
                setError('Failed to load compensation data: ' + error.message);
            }
        } finally {
            setLoading(false);
        }
    };

    // Auto-calculation functions
    const calculateAmount = (count, rate) => {
        const countVal = parseFloat(count) || 0;
        const rateVal = parseFloat(rate) || 0;
        return countVal * rateVal;
    };

    const formatDate = (dateValue) => {
        if (!dateValue) return null;
        if (typeof dateValue === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(dateValue)) return dateValue;

        const dateObj = new Date(dateValue);
        if (isNaN(dateObj)) return null;

        return dateObj.toISOString().split('T')[0]; // returns YYYY-MM-DD
    };

    // Handle Edit Compensation Form Changes with auto-calculation
    const handleEditFormChange = (field, value) => {
        setEditCompensationForm(prev => {
            const updated = { ...prev, [field]: value };

            // Auto-calculate land amount when land calculation fields change
            // if (field === 'totalLandArea' || field === 'acquiredLandArea' || field === 'landRatePerUnit') {
            //     const acquiredLand = parseFloat(updated.acquiredLandArea || 0);
            //     const ratePerUnit = parseFloat(updated.landRatePerUnit || 0);

            //     const calculatedLandAmount = acquiredLand * ratePerUnit;
            //     updated.landAmount = calculatedLandAmount;

            //     // if (acquiredLand > 0) {
            //     //     updated.landRate = ratePerUnit;
            //     // }
            // }

            if (field === "landMultiplied") {
                const multiplied = parseFloat(value) || 0;
                const rate = parseFloat(prev.landRateFinalAmount) || 0;
                updated.landAmount = (multiplied * rate).toFixed(2);
            }

            // Auto-calculate amounts when count or rate changes
            if (field === 'structureCount' || field === 'structureRate') {
                updated.structureAmount = calculateAmount(updated.structureCount, updated.structureRate);
            }
            if (field === 'treeCount' || field === 'treeRate') {
                updated.treeAmount = calculateAmount(updated.treeCount, updated.treeRate);
            }
            if (field === 'cropCount' || field === 'cropRate') {
                updated.cropAmount = calculateAmount(updated.cropCount, updated.cropRate);
            }
            if (field === 'waterBodyCount' || field === 'waterBodyRate') {
                updated.waterBodyAmount = calculateAmount(updated.waterBodyCount, updated.waterBodyRate);
            }
            if (field === 'borewellCount' || field === 'borewellRate') {
                updated.borewellAmount = calculateAmount(updated.borewellCount, updated.borewellRate);
            }
            if (field === 'homeCount' || field === 'homeRate') {
                updated.homeAmount = calculateAmount(updated.homeCount, updated.homeRate);
            }
            if (field === 'pipelineCount' || field === 'pipelineRate') {
                updated.pipelineAmount = calculateAmount(updated.pipelineCount, updated.pipelineRate);
            }
            if (field === 'wireCount' || field === 'wireRate') {
                updated.wireAmount = calculateAmount(updated.wireCount, updated.wireRate);
            }
            if (field === 'otherAssetCount' || field === 'otherAssetRate') {
                updated.otherAssetAmount = calculateAmount(updated.otherAssetCount, updated.otherAssetRate);
            }

            // Auto-calculate solatium
            // const solatiumPercentage = parseFloat(updated.solatiumPercentage || 30);
            // updated.solatiumAmount = (baseCompensation * solatiumPercentage) / 100;
            const baseForSolatium =
                parseFloat(updated.landAmount || 0) +
                parseFloat(updated.structureAmount || 0) +
                parseFloat(updated.treeAmount || 0) +
                parseFloat(updated.cropAmount || 0) +
                parseFloat(updated.waterBodyAmount || 0) +
                parseFloat(updated.borewellAmount || 0) +
                parseFloat(updated.homeAmount || 0) +
                parseFloat(updated.tinshedAmount || 0) +
                parseFloat(updated.wireAmount || 0) +
                parseFloat(updated.otherAssetAmount || 0);

            updated.solatiumAmount = baseForSolatium;

            // Calculate interest based on date range
            // if (field === 'interestRate' || field === 'interestFromDate' || field === 'interestToDate' ||
            //     baseCompensation !== parseFloat(prev.landAmount || 0) + parseFloat(prev.structureAmount || 0) +
            //     parseFloat(prev.treeAmount || 0) + parseFloat(prev.cropAmount || 0) + parseFloat(prev.waterBodyAmount || 0) +
            //     parseFloat(prev.borewellAmount || 0) + parseFloat(prev.homeAmount || 0) + parseFloat(prev.pipelineAmount || 0) +
            //     parseFloat(prev.wireAmount || 0) + parseFloat(prev.otherAssetAmount || 0)) {

            //     const principal = baseCompensation + updated.solatiumAmount;
            //     const interestRate = parseFloat(updated.interestRate || 12);
            //     const fromDate = updated.interestFromDate;
            //     const toDate = updated.interestToDate;

            //     // Calculate days between dates
            //     updated.interestDays = calculateDaysBetweenDates(fromDate, toDate);

            //     // Calculate interest amount based on date range
            //     updated.interestAmount = calculateInterestAmount(principal, interestRate, fromDate, toDate);
            // }


            // Calculate base compensation
            const rate = parseFloat(prev.landRateFinalAmount) || 0;
            const baseCompensation = rate;

            // Calculate interest based on date range with advance payment logic
            if (field === 'interestRate' || field === 'interestFromDate' || field === 'interestToDate' ||
                field === 'advanceAmount' || field === 'advanceDate') {

                const principal = baseCompensation;
                const interestRate = parseFloat(updated.interestRate || 12);
                const fromDate = updated.interestFromDate;
                const toDate = updated.interestToDate;
                const advanceAmount = parseFloat(updated.advanceAmount || 0);
                const advanceDate = updated.advanceDate;

                // Calculate total days for display
                updated.interestDays = calculateDaysBetweenDates(fromDate, toDate);

                // Calculate interest with reducing balance logic
                if (advanceAmount > 0 && advanceDate && fromDate && toDate) {
                    // Period 1: From start date to day before advance payment
                    const period1Days = calculateDaysBetweenDates(fromDate, advanceDate);
                    const period1Interest = calculateInterestAmount(principal, interestRate, fromDate, advanceDate);

                    // Period 2: From advance payment date to end date (on reduced principal)
                    const remainingPrincipal = principal - advanceAmount;
                    const period2Interest = calculateInterestAmount(remainingPrincipal, interestRate, advanceDate, toDate);

                    // Total interest is sum of both periods
                    updated.interestAmount = calculateInterestAmount(remainingPrincipal, interestRate, fromDate, toDate);
                    updated.advanceInterestAmount = period1Interest + period2Interest;

                    // Store breakdown for reference
                    // updated.period1Interest = period1Interest;
                    // updated.period2Interest = period2Interest;
                    // updated.period1Days = period1Days;
                    // updated.period2Days = calculateDaysBetweenDates(advanceDate, toDate);
                } else {
                    // No advance payment - calculate normally on full principal
                    updated.interestAmount = calculateInterestAmount(principal, interestRate, fromDate, toDate);
                }
            }

            // Calculate total compensation
            const allTotal =
                parseFloat(updated.landAmount || 0) +
                parseFloat(updated.structureAmount || 0) +
                parseFloat(updated.treeAmount || 0) +
                parseFloat(updated.cropAmount || 0) +
                parseFloat(updated.waterBodyAmount || 0) +
                parseFloat(updated.borewellAmount || 0) +
                parseFloat(updated.homeAmount || 0) +
                parseFloat(updated.pipelineAmount || 0) +
                parseFloat(updated.wireAmount || 0) +
                parseFloat(updated.otherAssetAmount || 0) +
                parseFloat(updated.interestAmount || 0) +
                parseFloat(updated.advanceInterestAmount || 0) +
                updated.solatiumAmount;

            // Third Total (Final Total Compensation): Second Total - Advance Amount - Advance Interest
            updated.totalCompensation = Number((
                allTotal -
                parseFloat(updated.govtRecovery || 0) -
                parseFloat(updated.advanceAmount || 0)
            ).toFixed(2));

            return updated;
        });

        if (editError) {
            setEditError(null);
        }
    };

    // Open Edit Modal
    const handleEditClick = (record) => {
        console.log('🔍 Opening edit modal for record:', record);

        const editId = record.compId || record.rawData?.compensation_id;
        const landOwnerId = record.landOwnerId || record.rawData?.land_owner_id;

        if (!landOwnerId) {
            setEditError(`Unable to edit this record: No land_owner_id found.`);
            return;
        }

        const recordWithEditId = {
            ...record,
            compId: editId,
            editId: editId,
            landOwnerId: landOwnerId
        };

        setCurrentEditRecord(recordWithEditId);

        const rawData = record.rawData || {};

        // Helper function to calculate amount
        const calculateAmount = (count, rate) => {
            const countVal = parseFloat(count) || 0;
            const rateVal = parseFloat(rate) || 0;
            return countVal * rateVal;
        };

        // Get initial values
        const totalLandArea = rawData.owner_total_area || record.totalArea?.sq_meter || '';
        const acquiredLandArea = rawData.owner_aqr_area || record.acquiredArea || '';
        const landRatePerUnit = rawData.owner_aqr_area_land_rate || rawData.land_rate || record.landRate || '';
        const landRateFinalAmount = (acquiredLandArea * landRatePerUnit).toFixed(2);

        // Calculate land amount
        const landMultiplied = parseFloat(rawData.land_amount_multiplied || record.landMultiplied || 0);
        const calculatedLandAmount = (landRateFinalAmount * landMultiplied).toFixed(2);

        // Advance Amount
        const advanceAmount = rawData.advance_amount || '';
        const advanceDate = rawData.advance_date || '';
        const govtRecovery = rawData.govt_recovery || '';

        // Get asset counts and rates
        const structureCount = rawData.no_of_structure || record.structureCount || '';
        const structureRate = rawData.no_of_structure_rate || rawData.structure_rate || '';
        const calculatedStructureAmount = calculateAmount(structureCount, structureRate) || parseFloat(rawData.structure_amount || record.structureCompensation || 0);

        const treeCount = rawData.no_of_tree || record.treeCount || '';
        const treeRate = rawData.no_of_tree_rate || rawData.tree_rate || '';
        const calculatedTreeAmount = calculateAmount(treeCount, treeRate) || parseFloat(rawData.tree_amount || record.treeCompensation || 0);

        const cropCount = rawData.no_of_crop || record.cropCount || '';
        const cropRate = rawData.no_of_crop_rate || rawData.crop_rate || '';
        const calculatedCropAmount = calculateAmount(cropCount, cropRate) || parseFloat(rawData.crop_amount || record.cropCompensation || 0);

        const waterBodyCount = rawData.no_of_water_body || record.waterBodyCount || '';
        const waterBodyRate = rawData.no_of_water_body_rate || rawData.water_body_rate || '';
        const calculatedWaterBodyAmount = calculateAmount(waterBodyCount, waterBodyRate) || parseFloat(rawData.water_body_amount || record.waterBodyCompensation || 0);

        const borewellCount = rawData.no_of_borewell || record.borewellCount || '';
        const borewellRate = rawData.no_of_borewell_rate || rawData.borewell_rate || '';
        const calculatedBorewellAmount = calculateAmount(borewellCount, borewellRate) || parseFloat(rawData.borewell_amount || record.borewellCompensation || 0);

        const homeCount = rawData.no_of_home || record.homeCount || '';
        const homeRate = rawData.no_of_home_rate || rawData.home_rate || '';
        const calculatedHomeAmount = calculateAmount(homeCount, homeRate) || parseFloat(rawData.home_amount || record.homeCompensation || 0);

        const tinshedCount = rawData.no_of_tinshed || record.tinshedCount || '';
        const tinshedRate = rawData.no_of_tinshed_rate || rawData.tinshed_rate || '';
        const calculatedTinshedAmount = calculateAmount(tinshedCount, tinshedRate) || parseFloat(rawData.tinshed_amount || record.tinshedCompensation || 0);

        const pipelineCount = rawData.no_of_pipeline || record.pipelineCount || '';
        const pipelineRate = rawData.no_of_pipeline_rate || rawData.pipeline_rate || '';
        const calculatedPipelineAmount = calculateAmount(pipelineCount, pipelineRate) || parseFloat(rawData.pipeline_amount || record.pipelineCompensation || 0);

        const wireCount = rawData.no_of_wirefencing || record.wireCount || '';
        const wireRate = rawData.no_of_wire_rate || rawData.wire_rate || '';
        const calculatedWireAmount = calculateAmount(wireCount, wireRate) || parseFloat(rawData.wire_amount || record.wireCompensation || 0);

        const otherAssetCount = rawData.no_of_other_asset || record.otherAssetCount || '';
        const otherAssetRate = rawData.no_of_other_asset_rate || rawData.other_asset_rate || '';
        const calculatedOtherAssetAmount = calculateAmount(otherAssetCount, otherAssetRate) || parseFloat(rawData.other_asset_amount || record.otherAssetCompensation || 0);

        // Calculate solatium
        const solatiumPercentage = parseFloat(rawData.solatium_compensation_percentage || rawData.solatium_percentage || 30);
        const baseTotalForSolatium =
            calculatedLandAmount +
            calculatedStructureAmount +
            calculatedTreeAmount +
            calculatedCropAmount +
            calculatedWaterBodyAmount +
            calculatedBorewellAmount +
            calculatedHomeAmount +
            calculatedTinshedAmount +
            calculatedWireAmount +
            calculatedOtherAssetAmount;

        const calculatedSolatiumAmount = baseTotalForSolatium;

        // Calculate interest
        const interestRate = rawData.interest_rate || '12';
        const interestFromDate = collectorSection11Date || formatDate(rawData.intrest_start_dt) || new Date().toISOString().split('T')[0];
        const interestToDate = new Date().toISOString().split('T')[0];

        let calculatedInterestAmount = parseFloat(rawData.interest_amount || record.interestAward || 0);
        let calculatedAdvanceInterestAmount = parseFloat(rawData.advance_payment_interest_amount || record.interestAward || 0);
        let interestDays = rawData.interest_days || 0;

        if (interestFromDate && interestToDate) {
            interestDays = calculateDaysBetweenDates(interestFromDate, interestToDate);
            if (interestDays > 0) {
                const principal = parseFloat(landRateFinalAmount);
                // console.log("-----------------------------Total Amount :", principal);
                if (advanceAmount && parseFloat(advanceAmount) > 0 && advanceDate) {
                    const advAmt = parseFloat(advanceAmount);
                    const remainingAmount = principal - advAmt;
                    // console.log("-----------------------------Advance Amount :", advAmt);
                    // console.log("-----------------------------Remaining Amount :", remainingAmount);
                    // Day before advance payment date
                    const advanceDateObj = new Date(advanceDate);
                    advanceDateObj.setDate(advanceDateObj.getDate() - 1);
                    const beforeAdvanceDate = [
                        advanceDateObj.getFullYear(),
                        String(advanceDateObj.getMonth() + 1).padStart(2, '0'),
                        String(advanceDateObj.getDate()).padStart(2, '0')
                    ].join('-');

                    // Remaining amount: collector date → today
                    calculatedInterestAmount = calculateInterestAmount(
                        remainingAmount,
                        parseFloat(interestRate),
                        interestFromDate,
                        interestToDate
                    );
                    // console.log("-----------------------------If Interest on Remaining Amount :", calculatedInterestAmount);
                    // Advance amount: collector date → day before advance date
                    calculatedAdvanceInterestAmount = calculateInterestAmount(
                        advAmt,
                        parseFloat(interestRate),
                        interestFromDate,
                        beforeAdvanceDate
                    );
                    // console.log("-----------------------------If Interest on Advance Amount :", calculatedAdvanceInterestAmount);
                } else {
                    calculatedInterestAmount = calculateInterestAmount(
                        principal,
                        parseFloat(interestRate),
                        interestFromDate,
                        interestToDate
                    );
                    // console.log("-----------------------------Else Interest on Total Amount :", calculatedInterestAmount);
                    calculatedAdvanceInterestAmount = 0;
                    // console.log("-----------------------------Else Interest on Advance Amount :", calculatedAdvanceInterestAmount);
                }
            }
        }

        // Calculate additional compensation
        const additionalCompensation = parseFloat(rawData.additional_compensation || record.additionalCompensation || 0);

        // Calculate total compensation
        const allTotal =
            Number(calculatedLandAmount || 0).toFixed(2) * 1 +
            Number(calculatedStructureAmount || 0).toFixed(2) * 1 +
            Number(calculatedTreeAmount || 0).toFixed(2) * 1 +
            Number(calculatedCropAmount || 0).toFixed(2) * 1 +
            Number(calculatedWaterBodyAmount || 0).toFixed(2) * 1 +
            Number(calculatedBorewellAmount || 0).toFixed(2) * 1 +
            Number(calculatedHomeAmount || 0).toFixed(2) * 1 +
            Number(calculatedTinshedAmount || 0).toFixed(2) * 1 +
            Number(calculatedWireAmount || 0).toFixed(2) * 1 +
            Number(calculatedOtherAssetAmount || 0).toFixed(2) * 1 +
            Number(calculatedPipelineAmount || 0).toFixed(2) * 1;

        const calculatedTotalCompensation = Number((
            allTotal +
            Number(calculatedInterestAmount || 0).toFixed(2) * 1 +
            Number(calculatedSolatiumAmount || 0).toFixed(2) * 1 +
            Number(calculatedAdvanceInterestAmount || 0).toFixed(2) * 1 -
            Number(govtRecovery || 0).toFixed(2) * 1 -
            Number(advanceAmount || 0).toFixed(2) * 1
        ).toFixed(2));

        const compensationStatus = rawData.COMPENSATION_STATUS || 'Pending';
        console.log("Conpensation status----------------- :", compensationStatus);

        // Populate form with calculated values
        setEditCompensationForm({
            // Land details
            landMultiplied: landMultiplied,
            landRate: landRatePerUnit,
            landRateFinalAmount: landRateFinalAmount,
            landAmount: calculatedLandAmount,

            // Land Calculation Fields
            totalLandArea: totalLandArea,
            acquiredLandArea: acquiredLandArea,
            landRatePerUnit: landRatePerUnit,

            // Advance AMount
            advanceAmount: advanceAmount,
            advanceDate: advanceDate,
            govtRecovery: govtRecovery,

            // Asset details with calculated amounts
            structureCount: structureCount,
            structureRate: structureRate,
            structureAmount: calculatedStructureAmount,

            treeCount: treeCount,
            treeRate: treeRate,
            treeAmount: calculatedTreeAmount,

            tinshedCount: tinshedCount,
            tinshedRate: tinshedRate,
            tinshedAmount: calculatedTinshedAmount,

            cropCount: cropCount,
            cropRate: cropRate,
            cropAmount: calculatedCropAmount,

            waterBodyCount: waterBodyCount,
            waterBodyRate: waterBodyRate,
            waterBodyAmount: calculatedWaterBodyAmount,

            borewellCount: borewellCount,
            borewellRate: borewellRate,
            borewellAmount: calculatedBorewellAmount,

            homeCount: homeCount,
            homeRate: homeRate,
            homeAmount: calculatedHomeAmount,

            pipelineCount: pipelineCount,
            pipelineRate: pipelineRate,
            pipelineAmount: calculatedPipelineAmount,

            wireCount: wireCount,
            wireRate: wireRate,
            wireAmount: calculatedWireAmount,

            otherAssetCount: otherAssetCount,
            otherAssetRate: otherAssetRate,
            otherAssetAmount: calculatedOtherAssetAmount,

            // Compensation calculations
            solatiumPercentage: solatiumPercentage,
            solatiumAmount: calculatedSolatiumAmount,

            interestRate: interestRate,
            interestFromDate: interestFromDate,
            interestToDate: interestToDate,
            interestAmount: calculatedInterestAmount,
            advanceInterestAmount: calculatedAdvanceInterestAmount,
            interestDays: interestDays,

            additionalCompensation: additionalCompensation,
            additionalCompensationReason: rawData.additional_compensation_reason || '',

            allTotal: allTotal,
            totalCompensation: calculatedTotalCompensation,

            // Administrative details
            currency: rawData.currency || 'INR',
            compensationStatus: compensationStatus,
            valuationDate: rawData.valuation_date || new Date().toISOString().split('T')[0],
            compensationApprovalDate: rawData.compensation_approval_date || new Date().toISOString().split('T')[0],
            compensationApprovalAuthority: rawData.compensation_approval_authority || '',
            compensationApprovalReference: rawData.compensation_approval_reference || '',

            image: null
        });

        setEditError(null);
        setEditSuccess(false);
        setShowEditModal(true);
    };

    const handleEditCompensation = async () => {
        try {
            setEditingCompensation(true);
            setEditError(null);

            // Asset Property
            await Promise.all([
                updateAllTrees(),
                updateAllHomes(),
                updateAllTinshed(),
                updateAllWireFencing(),
                updateAllFarmPond(),
                updateAllWell(),
                updateAllPipeline(),
                updateAllBorewell(),
                updateAllOther()
            ]);

            if (!currentEditRecord) {
                setEditError('No compensation record selected for editing');
                return;
            }

            const updateId = currentEditRecord.compId || currentEditRecord.editId;

            if (!updateId || updateId === '' || updateId === 0) {
                setEditError(`❌ Unable to update: No valid compensation ID found.`);
                return;
            }

            const cleanUpdateId = String(updateId).trim().replace(/,+$/, '');

            if (!cleanUpdateId || isNaN(cleanUpdateId)) {
                setEditError(`❌ Invalid compensation ID: "${updateId}". Expected a valid number.`);
                return;
            }

            // Asset Property--
            const treeData = currentEditRecord?.treeData || [];
            const homeData = currentEditRecord?.homeData || [];
            const tinshedData = currentEditRecord?.tinshedData || [];
            const wireFencingData = currentEditRecord?.wireFencingData || [];
            const farmpondData = currentEditRecord?.farmpondData || [];
            const wellData = currentEditRecord?.wellData || [];
            const pipelineData = currentEditRecord?.pipelineData || [];
            const borewellData = currentEditRecord?.borewellData || [];
            const otherData = currentEditRecord?.otherData || [];

            // फळझाडे टोटल
            const fruitTreeTotal = treeData.reduce((sum, tree) => {
                if (tree.tree_type_name1 === "फळझाडे") {
                    const rate = tree.tree_amount_lao ?? tree.tree_amount_valuer ?? 0;
                    return sum + rate;
                }
                return sum;
            }, 0);

            // वनझाडे टोटल
            const forestTreeTotal = treeData.reduce((sum, tree) => {
                if (tree.tree_type_name1 === "वनझाडे") {
                    const rate = tree.tree_amount_lao ?? tree.tree_amount_valuer ?? 0;
                    return sum + rate;
                }
                return sum;
            }, 0);
            const HomeTotal = homeData.reduce((sum, home) => {
                const rate = home.Property_amount_lao ?? home.Property_amount_valuer ?? 0;
                return sum + rate;
            }, 0);
            const tinshedTotal = tinshedData.reduce((sum, tinshed) => {
                const rate = tinshed.Property_amount_lao ?? tinshed.Property_amount_valuer ?? 0;
                return sum + rate;
            }, 0);
            const wireFencingTotal = wireFencingData.reduce((sum, wireFencing) => {
                const rate = wireFencing.Property_amount_lao ?? wireFencing.Property_amount_valuer ?? 0;
                return sum + rate;
            }, 0);
            const farmPondTotal = farmpondData.reduce((sum, farmPond) => {
                const rate = farmPond.Property_amount_lao ?? farmPond.Property_amount_valuer ?? 0;
                return sum + rate;
            }, 0);
            const wellTotal = wellData.reduce((sum, well) => {
                const rate = well.Property_amount_lao ?? well.Property_amount_valuer ?? 0;
                return sum + rate;
            }, 0);
            const pipelineTotal = pipelineData.reduce((sum, pipeline) => {
                const rate = pipeline.Property_amount_lao ?? pipeline.Property_amount_valuer ?? 0;
                return sum + rate;
            }, 0);
            const borewellTotal = borewellData.reduce((sum, borewell) => {
                const rate = borewell.Property_amount_lao ?? borewell.Property_amount_valuer ?? 0;
                return sum + rate;
            }, 0);
            const otherTotal = otherData.reduce((sum, other) => {
                const rate = other.Property_amount_lao ?? other.Property_amount_valuer ?? 0;
                return sum + rate;
            }, 0);

            // Create payload for API
            const payload = {
                // Land details
                land_rate: parseFloat(editCompensationForm.landRate) || 0,
                land_amount_multiplied: parseFloat(editCompensationForm.landMultiplied) || 0,
                land_amount: parseFloat(editCompensationForm.landAmount) || 0,
                govt_recovery: editCompensationForm.govtRecovery || '',

                // Asset details
                structure_rate: parseFloat(editCompensationForm.structureRate) || 0,
                structure_amount: wellTotal || 0,

                tree_rate: parseFloat(editCompensationForm.treeRate) || 0,
                // tree_amount: parseFloat(editCompensationForm.treeAmount) || 0,
                tree_amount: fruitTreeTotal || 0,
                forest_tree_amount: forestTreeTotal || 0,

                // crop_rate: parseFloat(editCompensationForm.cropRate) || 0,
                // crop_amount: parseFloat(editCompensationForm.cropAmount) || 0,

                water_body_rate: parseFloat(editCompensationForm.waterBodyRate) || 0,
                water_body_amount: farmPondTotal || 0,

                borewell_rate: parseFloat(editCompensationForm.borewellRate) || 0,
                borewell_amount: borewellTotal || 0,

                home_rate: parseFloat(editCompensationForm.homeRate) || 0,
                // home_amount: parseFloat(editCompensationForm.homeAmount) || 0,
                home_amount: HomeTotal || 0,

                pipeline_rate: parseFloat(editCompensationForm.pipelineRate) || 0,
                pipeline_amount: pipelineTotal || 0,

                wire_rate: parseFloat(editCompensationForm.wireRate) || 0,
                wire_amount: wireFencingTotal || 0,

                tinshed_rate: parseFloat(editCompensationForm.tinshedRate) || 0,
                tinshed_amount: tinshedTotal || 0,

                other_asset_rate: parseFloat(editCompensationForm.otherAssetRate) || 0,
                other_asset_amount: otherTotal || 0,

                // Compensation calculations
                solatium_compensation_percentage: parseFloat(editCompensationForm.solatiumPercentage) || 30,
                solatium_compensation_amount: parseFloat(editCompensationForm.solatiumAmount) || 0,

                interest_rate: parseFloat(editCompensationForm.interestRate) || 12,
                intrest_start_dt: formatDate(editCompensationForm.interestFromDate) || null,
                intrest_end_dt: formatDate(editCompensationForm.interestToDate) || null,
                interest_days: parseInt(editCompensationForm.interestDays) || 0,
                interest_amount: parseFloat(editCompensationForm.interestAmount) || 0,
                advance_payment_interest_amount: parseFloat(editCompensationForm.advanceInterestAmount) || 0,

                additional_compensation: parseFloat(editCompensationForm.additionalCompensation) || 0,
                additional_compensation_reason: editCompensationForm.additionalCompensationReason || '',

                total_compensation: parseFloat(editCompensationForm.totalCompensation) || 0,

                // Administrative details
                currency: editCompensationForm.currency || 'INR',
                COMPENSATION_STATUS: editCompensationForm.compensationStatus || 'Pending',
                valuation_date: editCompensationForm.valuationDate || null,
                compensation_approval_date: editCompensationForm.compensationApprovalDate || null,
                compensation_approval_authority: editCompensationForm.compensationApprovalAuthority || '',
                compensation_approval_reference: editCompensationForm.compensationApprovalReference || ''
            };

            // Remove empty/null values
            const cleanPayload = Object.fromEntries(
                Object.entries(payload).filter(([_, value]) => value !== null && value !== undefined && value !== '')
            );

            console.log('🚀 Sending payload to API:', JSON.stringify(cleanPayload, null, 2));
            console.log('🔧 Using cleaned updateId:', cleanUpdateId);

            console.log("Paload at edit time :", cleanPayload);

            const response = await apiService.patchUpdateOwnerCompensation(cleanUpdateId, cleanPayload);

            console.log('✅ Update compensation response:', response);

            if (response && (response.status === 200 || response.status === 204)) {
                setEditSuccess(true);
                setShowEditModal(false);
                setEditSuccess(false);
                setCurrentEditRecord(null);

                // Reload data based on current filter mode
                try {
                    if (filterMode === 'all') {
                        await loadCompensationDataForAll();
                    } else {
                        await loadCompensationData();
                    }
                    console.log('✅ Data refreshed successfully');
                } catch (refreshError) {
                    console.error('❌ Error refreshing data:', refreshError);
                }

                // Auto-close modal
                // setTimeout(() => {
                //     setShowEditModal(false);
                //     setEditSuccess(false);
                //     setCurrentEditRecord(null);
                // }, 1500);

            } else {
                throw new Error(`Invalid response from server: ${response?.status || 'Unknown'}`);
            }

        } catch (error) {
            console.error('🔍 Error updating compensation:', error);

            let errorMessage = 'Failed to update compensation record';

            if (error.response && error.response.data) {
                if (typeof error.response.data === 'string') {
                    errorMessage = error.response.data;
                } else if (error.response.data.message) {
                    errorMessage = error.response.data.message;
                } else if (error.response.data.error) {
                    errorMessage = error.response.data.error;
                }
            } else if (error.message) {
                errorMessage = error.message;
            }

            setEditError(`${errorMessage}`);
        } finally {
            setEditingCompensation(false);
        }
    };

    // Add this useEffect after your state declarations
    useEffect(() => {
        if (!currentEditRecord) return;

        // Calculate totals from currentEditRecord asset data
        const treeTotal = (currentEditRecord.treeData || []).reduce((sum, tree) => {
            const amount = tree.tree_amount_lao ?? tree.tree_amount_valuer ?? 0;
            return sum + amount;
        }, 0);

        const wellTotal = (currentEditRecord.wellData || []).reduce((sum, well) => {
            const amount = well.Property_amount_lao ?? well.Property_amount_valuer ?? 0;
            return sum + amount;
        }, 0);

        const borewellTotal = (currentEditRecord.borewellData || []).reduce((sum, borewell) => {
            const amount = borewell.Property_amount_lao ?? borewell.Property_amount_valuer ?? 0;
            return sum + amount;
        }, 0);

        const pipelineTotal = (currentEditRecord.pipelineData || []).reduce((sum, pipeline) => {
            const amount = pipeline.Property_amount_lao ?? pipeline.Property_amount_valuer ?? 0;
            return sum + amount;
        }, 0);

        const homeTotal = (currentEditRecord.homeData || []).reduce((sum, home) => {
            const amount = home.Property_amount_lao ?? home.Property_amount_valuer ?? 0;
            return sum + amount;
        }, 0);

        const tinshedTotal = (currentEditRecord.tinshedData || []).reduce((sum, tinshed) => {
            const amount = tinshed.Property_amount_lao ?? tinshed.Property_amount_valuer ?? 0;
            return sum + amount;
        }, 0);

        const wireFencingTotal = (currentEditRecord.wireFencingData || []).reduce((sum, wire) => {
            const amount = wire.Property_amount_lao ?? wire.Property_amount_valuer ?? 0;
            return sum + amount;
        }, 0);

        const farmpondTotal = (currentEditRecord.farmpondData || []).reduce((sum, pond) => {
            const amount = pond.Property_amount_lao ?? pond.Property_amount_valuer ?? 0;
            return sum + amount;
        }, 0);

        const otherTotal = (currentEditRecord.otherData || []).reduce((sum, other) => {
            const amount = other.Property_amount_lao ?? other.Property_amount_valuer ?? 0;
            return sum + amount;
        }, 0);

        // Update editCompensationForm with recalculated totals
        setEditCompensationForm(prev => {
            const updated = {
                ...prev,
                treeAmount: treeTotal,
                waterBodyAmount: wellTotal,
                borewellAmount: borewellTotal,
                pipelineAmount: pipelineTotal,
                homeAmount: homeTotal,
                tinshedAmount: tinshedTotal,
                wireAmount: wireFencingTotal,
                structureAmount: farmpondTotal, // Assuming structureAmount is farmpondTotal
                otherAssetAmount: otherTotal
            };

            const solatium =
                parseFloat(updated.landAmount || 0) +
                parseFloat(updated.structureAmount || 0) +
                parseFloat(updated.treeAmount || 0) +
                parseFloat(updated.cropAmount || 0) +
                parseFloat(updated.waterBodyAmount || 0) +
                parseFloat(updated.borewellAmount || 0) +
                parseFloat(updated.homeAmount || 0) +
                parseFloat(updated.wireAmount || 0) +
                parseFloat(updated.otherAssetAmount || 0) +
                parseFloat(updated.tinshedAmount || 0);

            updated.solatiumAmount = solatium;

            // Recalculate allTotal
            const allTotal =
                parseFloat(updated.landAmount || 0) +
                parseFloat(updated.structureAmount || 0) +
                parseFloat(updated.treeAmount || 0) +
                parseFloat(updated.cropAmount || 0) +
                parseFloat(updated.waterBodyAmount || 0) +
                parseFloat(updated.borewellAmount || 0) +
                parseFloat(updated.homeAmount || 0) +
                parseFloat(updated.pipelineAmount || 0) +
                parseFloat(updated.wireAmount || 0) +
                parseFloat(updated.otherAssetAmount || 0) +
                parseFloat(updated.tinshedAmount || 0);

            updated.allTotal = allTotal;

            // Recalculate total compensation
            updated.totalCompensation = Number((
                allTotal +
                solatium +
                parseFloat(updated.interestAmount || 0) +
                parseFloat(updated.advanceInterestAmount || 0) -
                parseFloat(updated.govtRecovery || 0) -
                parseFloat(updated.advanceAmount || 0)
            ).toFixed(2));

            return updated;
        });
    }, [currentEditRecord?.treeData, currentEditRecord?.wellData, currentEditRecord?.borewellData,
    currentEditRecord?.pipelineData, currentEditRecord?.homeData, currentEditRecord?.tinshedData,
    currentEditRecord?.wireFencingData, currentEditRecord?.farmpondData, currentEditRecord?.otherData]);

    const fetchStartInterestDate = async () => {
        try {
            if (!currentProjectId || !currentProposalId) return;

            const response = await apiService.getfetchLAOPublishButton(currentProjectId, currentProposalId);

            // Check status and if data exists
            if (response.status === 200 && response.data.length > 0) {
                const startDate = response.data[0].cre_usr_dt; // e.g., "2025-09-13T08:48:47.620Z"

                // Convert to YYYY-MM-DD for <input type="date">
                const formattedDate = new Date(startDate).toISOString().split("T")[0];
                setCollectorSection11Date(formattedDate);
            }
        } catch (error) {
            console.error("Error fetching start date:", error);
        }
    };

    useEffect(() => {
        fetchStartInterestDate();
    }, [currentProjectId, currentProposalId]);

    // NEW: Handle filter mode changes
    const handleDistrictChange = (e) => {
        setSelectedDistrict(e.target.value);
        setSelectedTaluka('');
        setSelectedVillage('');
    };

    const handleTalukaChange = (e) => {
        setSelectedTaluka(e.target.value);
        setSelectedVillage('');
    };

    const handleVillageChange = (e) => {
        setSelectedVillage(e.target.value);
    };

    // Generate Notice using existing compensation data
    const handleGenerateNotice = () => {
        setNoticeTargetId('all');
        setShowNotice(true);
    };

    // For a SINGLE record from the edit modal
    const handleGenerateNoticeForRecord = (record) => {
        setNoticeTargetId(record.landOwnerId); // Pass the specific owner's ID
        setShowNotice(true);
    };

    // Helper functions for display names
    const getDistrictDisplayName = (district) => {
        return district.dist_name || `District ${district.dist_name}`;
    };

    const getTalukaDisplayName = (taluka) => {
        return taluka.taluka_name || `Taluka ${taluka.taluka_name}`;
    };

    const getVillageDisplayName = (village) => {
        return village.village_name || `Village ${village.village_name}`;
    };

    // Helper function to get color classes
    const getColorClasses = (color) => {
        const colorMap = {
            green: {
                button: 'from-green-500 to-green-600 hover:from-green-600 hover:to-green-700',
                text: 'text-green-600'
            },
            emerald: {
                button: 'from-emerald-500 to-emerald-600 hover:from-emerald-600 hover:to-emerald-700',
                text: 'text-emerald-600'
            },
            yellow: {
                button: 'from-yellow-500 to-yellow-600 hover:from-yellow-600 hover:to-yellow-700',
                text: 'text-yellow-600'
            },
            cyan: {
                button: 'from-cyan-500 to-cyan-600 hover:from-cyan-600 hover:to-cyan-700',
                text: 'text-cyan-600'
            },
            indigo: {
                button: 'from-indigo-500 to-indigo-600 hover:from-indigo-600 hover:to-indigo-700',
                text: 'text-indigo-600'
            },
            pink: {
                button: 'from-pink-500 to-pink-600 hover:from-pink-600 hover:to-pink-700',
                text: 'text-pink-600'
            },
            orange: {
                button: 'from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700',
                text: 'text-orange-600'
            },
            red: {
                button: 'from-red-500 to-red-600 hover:from-red-600 hover:to-red-700',
                text: 'text-red-600'
            },
            purple: {
                button: 'from-purple-500 to-purple-600 hover:from-purple-600 hover:to-purple-700',
                text: 'text-purple-600'
            }
        };
        return colorMap[color] || colorMap.green;
    };

    // Render function for each asset type with count, rate, and amount fields
    // Updated renderAssetFields function with conditional disabling
    const renderAssetFields = (assetType, label, color) => {
        const colorClasses = getColorClasses(color);

        // Check if count is empty, null, or 0
        const countValue = editCompensationForm[`${assetType}Count`];
        const isCountEmpty = !countValue || countValue === '' || countValue === '0' || parseFloat(countValue) === 0;

        return (
            <div className="space-y-2">
                <div className="flex items-center justify-between">
                    <label className="block text-xs font-medium text-gray-600 mb-1">{label}</label>
                    <div className="flex space-x-1">
                        <button
                            type="button"
                            onClick={() => {
                                const currentAmount = parseFloat(editCompensationForm[`${assetType}Amount`]) || 0;
                                handleEditFormChange(`${assetType}Amount`, currentAmount * 2);
                            }}
                            disabled={isCountEmpty}
                            className={`px-2 py-1 text-xs font-semibold text-white bg-gradient-to-r ${isCountEmpty
                                ? 'from-gray-300 to-gray-400 cursor-not-allowed'
                                : colorClasses.button
                                } rounded-md shadow-sm transition-all duration-200`}
                        >
                            2×
                        </button>
                        <button
                            type="button"
                            onClick={() => {
                                const multiplier = prompt('Enter multiplier (e.g., 5, 1.5, 10):');
                                if (multiplier && !isNaN(multiplier)) {
                                    const currentAmount = parseFloat(editCompensationForm[`${assetType}Amount`]) || 0;
                                    handleEditFormChange(`${assetType}Amount`, currentAmount * parseFloat(multiplier));
                                }
                            }}
                            disabled={isCountEmpty}
                            className={`px-3 py-1.5 text-xs font-medium rounded-md transition-colors ${isCountEmpty
                                ? 'bg-gray-200 text-gray-400 cursor-not-allowed'
                                : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                                }`}
                        >
                            {translations[language]?.custom}
                        </button>
                    </div>
                </div>

                <div className="flex items-center space-x-2 bg-gray-50 p-3 rounded-lg">
                    {/* Count field */}
                    <input
                        type="number"
                        min="0"
                        value={editCompensationForm[`${assetType}Count`] || ''}
                        onChange={(e) => handleEditFormChange(`${assetType}Count`, e.target.value)}
                        className="w-full px-2 py-2 border border-gray-300 rounded text-xs focus:ring-1 focus:ring-blue-500 focus:border-transparent bg-white font-medium text-center"
                        placeholder={translations[language]?.Count}
                        disabled
                    />

                    <span className="text-gray-500 text-xs">×</span>

                    {/* Rate field - disabled when count is empty */}
                    <input
                        type="number"
                        step="0.01"
                        min="0"
                        value={editCompensationForm[`${assetType}Rate`] || ''}
                        onChange={(e) => handleEditFormChange(`${assetType}Rate`, e.target.value)}
                        disabled={isCountEmpty}
                        className={`w-full px-2 py-2 border border-gray-300 rounded text-xs focus:ring-1 focus:ring-blue-500 focus:border-transparent font-medium text-center ${isCountEmpty
                            ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                            : 'bg-white'
                            }`}
                        placeholder={isCountEmpty ? "No count" : "Rate"}
                    />

                    <span className="text-gray-500 text-xs">=</span>

                    {/* Amount field - disabled when count is empty */}
                    <input
                        type="number"
                        step="0.01"
                        min="0"
                        value={editCompensationForm[`${assetType}Amount`] || ''}
                        onChange={(e) => handleEditFormChange(`${assetType}Amount`, e.target.value)}
                        disabled={isCountEmpty}
                        className={`flex-1 px-2 py-2 border border-gray-300 rounded text-xs focus:ring-2 focus:ring-blue-500 focus:border-transparent font-bold ${isCountEmpty
                            ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                            : colorClasses.text
                            }`}
                        placeholder={isCountEmpty ? "No count" : "Amount"}
                        readOnly
                    />
                </div>

                {/* Helper message when count is empty */}
                {isCountEmpty && (
                    <p className="text-xs text-gray-500 italic flex items-center">
                        <span className="mr-1">ℹ️</span>
                        {translations[language]?.RateAndAmountDisabledBecauseNo} {label.toLowerCase()} {translations[language]?.CountIsAvailable}
                    </p>
                )}
            </div>
        );
    };

    // Asset Property
    // Tree
    const updateAllTrees = async () => {
        try {
            // Mark all trees as updating
            const updatingMap = {};
            currentEditRecord.treeData.forEach(tree => {
                updatingMap[tree.tree_id] = true;
            });

            setUpdatingTrees(updatingMap);
            setTreeUpdateErrors({});

            // Prepare all payloads
            const payloads = currentEditRecord.treeData.map(tree => ({
                tree_amount_valuer: tree.tree_amount_valuer,
                tree_amount_lao: tree.tree_amount_lao
            }));

            console.log("🌳 Bulk updating trees:", payloads);

            // Call API one by one (or you can use Promise.all)
            await Promise.all(
                currentEditRecord.treeData.map((tree, i) =>
                    apiService.patchUpdateTree(tree.tree_id, payloads[i])
                )
            );

            console.log("✅ All trees updated successfully");

            // After successful update, recalc totals
            const newTotalTreeAmount = currentEditRecord.treeData.reduce(
                (sum, t) => sum + ((t.tree_count || 0) * (t.tree_value_lao ?? t.tree_value_valuer ?? 0)),
                0
            );
            handleEditFormChange("treeAmount", newTotalTreeAmount);

        } catch (error) {
            console.error("❌ Error bulk updating trees:", error);
            setTreeUpdateErrors({ global: error.message || "Failed to update trees" });
        } finally {
            setUpdatingTrees({});
        }
    };
    // Home
    const updateAllHomes = async () => {
        try {
            // Mark all trees as updating
            const updatingMap = {};
            currentEditRecord.homeData.forEach(home => {
                updatingMap[home.Property_id] = true;
            });

            setUpdatingHomes(updatingMap);
            setHomeUpdateErrors({});

            // Prepare all payloads
            const payloads = currentEditRecord.homeData.map(home => ({
                // land_owner_id: currentEditRecord.landOwnerId,
                // tree_type_name: home.tree_type_name,
                // tree_count: home.tree_count,
                property_type: "home",
                Property_amount_valuer: home.Property_amount_valuer, // keep valuer
                Property_amount_lao: home.Property_amount_lao        // user updated LAO
            }));

            console.log("🌳 Bulk updating homes:", payloads);

            // Call API one by one (or you can use Promise.all)
            await Promise.all(
                currentEditRecord.homeData.map((home, i) =>
                    apiService.patchUpdateProperty(home.Property_id, payloads[i])
                )
            );

            console.log("✅ All trees updated successfully");

            // After successful update, recalc totals
            // const newTotalTreeAmount = currentEditRecord.homeData.reduce(
            //   (sum, t) => sum + ((t.tree_count || 0) * (t.tree_value_lao ?? t.tree_value_valuer ?? 0)),
            //   0
            // );
            // handleEditFormChange("treeAmount", newTotalTreeAmount);

        } catch (error) {
            console.error("❌ Error bulk updating trees:", error);
            setHomeUpdateErrors({ global: error.message || "Failed to update trees" });
        } finally {
            setUpdatingHomes({});
        }
    };
    // Tinshed
    const updateAllTinshed = async () => {
        try {
            // Mark all trees as updating
            const updatingMap = {};
            currentEditRecord.tinshedData.forEach(tinshed => {
                updatingMap[tinshed.Property_id] = true;
            });

            setUpdatingTinshed(updatingMap);
            setTinshedUpdateErrors({});

            // Prepare all payloads
            const payloads = currentEditRecord.tinshedData.map(tinshed => ({
                // land_owner_id: currentEditRecord.landOwnerId,
                // tree_type_name: home.tree_type_name,
                // tree_count: home.tree_count,
                property_type: "tinshed/godown",
                Property_amount_valuer: tinshed.Property_amount_valuer, // keep valuer
                Property_amount_lao: tinshed.Property_amount_lao        // user updated LAO
            }));

            console.log("🌳 Bulk updating tinshed:", payloads);

            // Call API one by one (or you can use Promise.all)
            await Promise.all(
                currentEditRecord.tinshedData.map((tinshed, i) =>
                    apiService.patchUpdateProperty(tinshed.Property_id, payloads[i])
                )
            );

            console.log("✅ All Tinshed updated successfully");

            // After successful update, recalc totals
            // const newTotalTreeAmount = currentEditRecord.homeData.reduce(
            //   (sum, t) => sum + ((t.tree_count || 0) * (t.tree_value_lao ?? t.tree_value_valuer ?? 0)),
            //   0
            // );
            // handleEditFormChange("treeAmount", newTotalTreeAmount);

        } catch (error) {
            console.error("❌ Error bulk updating Tinshed:", error);
            setTinshedUpdateErrors({ global: error.message || "Failed to update Tinshed" });
        } finally {
            setUpdatingTinshed({});
        }
    };
    // WireFencing
    const updateAllWireFencing = async () => {
        try {
            // Mark all trees as updating
            const updatingMap = {};
            currentEditRecord.wireFencingData.forEach(wireFencing => {
                updatingMap[wireFencing.Property_id] = true;
            });

            setUpdatingWirefencing(updatingMap);
            setWirefencingUpdateErrors({});

            // Prepare all payloads
            const payloads = currentEditRecord.wireFencingData.map(wireFencing => ({
                // land_owner_id: currentEditRecord.landOwnerId,
                // tree_type_name: home.tree_type_name,
                // tree_count: home.tree_count,
                property_type: "wirefencing",
                Property_amount_valuer: wireFencing.Property_amount_valuer, // keep valuer
                Property_amount_lao: wireFencing.Property_amount_lao        // user updated LAO
            }));

            console.log("🌳 Bulk updating wireFencing:", payloads);

            // Call API one by one (or you can use Promise.all)
            await Promise.all(
                currentEditRecord.wireFencingData.map((wireFencing, i) =>
                    apiService.patchUpdateProperty(wireFencing.Property_id, payloads[i])
                )
            );

            console.log("✅ All wireFencing updated successfully");

            // After successful update, recalc totals
            // const newTotalTreeAmount = currentEditRecord.homeData.reduce(
            //   (sum, t) => sum + ((t.tree_count || 0) * (t.tree_value_lao ?? t.tree_value_valuer ?? 0)),
            //   0
            // );
            // handleEditFormChange("treeAmount", newTotalTreeAmount);

        } catch (error) {
            console.error("❌ Error bulk updating Tinshed:", error);
            setWirefencingUpdateErrors({ global: error.message || "Failed to update Tinshed" });
        } finally {
            setUpdatingWirefencing({});
        }
    };
    // FarmPond
    const updateAllFarmPond = async () => {
        try {
            // Mark all trees as updating
            const updatingMap = {};
            currentEditRecord.farmpondData.forEach(farmPond => {
                updatingMap[farmPond.Property_id] = true;
            });

            setUpdatingFarmpond(updatingMap);
            setFarmpondUpdateErrors({});

            // Prepare all payloads
            const payloads = currentEditRecord.farmpondData.map(farmPond => ({
                // land_owner_id: currentEditRecord.landOwnerId,
                // tree_type_name: home.tree_type_name,
                // tree_count: home.tree_count,
                property_type: "farmpond",
                Property_amount_valuer: farmPond.Property_amount_valuer, // keep valuer
                Property_amount_lao: farmPond.Property_amount_lao        // user updated LAO
            }));

            console.log("🌳 Bulk updating farmpond:", payloads);

            // Call API one by one (or you can use Promise.all)
            await Promise.all(
                currentEditRecord.farmpondData.map((farmpond, i) =>
                    apiService.patchUpdateProperty(farmpond.Property_id, payloads[i])
                )
            );

            console.log("✅ All farmpond updated successfully");

            // After successful update, recalc totals
            // const newTotalTreeAmount = currentEditRecord.homeData.reduce(
            //   (sum, t) => sum + ((t.tree_count || 0) * (t.tree_value_lao ?? t.tree_value_valuer ?? 0)),
            //   0
            // );
            // handleEditFormChange("treeAmount", newTotalTreeAmount);

        } catch (error) {
            console.error("❌ Error bulk updating farmpond:", error);
            setFarmpondUpdateErrors({ global: error.message || "Failed to update farmpond" });
        } finally {
            setUpdatingFarmpond({});
        }
    };
    // Well
    const updateAllWell = async () => {
        try {
            // Mark all trees as updating
            const updatingMap = {};
            currentEditRecord.wellData.forEach(well => {
                updatingMap[well.Property_id] = true;
            });

            setUpdatingWell(updatingMap);
            setWellUpdateErrors({});

            // Prepare all payloads
            const payloads = currentEditRecord.wellData.map(well => ({
                // land_owner_id: currentEditRecord.landOwnerId,
                // tree_type_name: home.tree_type_name,
                // tree_count: home.tree_count,
                property_type: "well",      // user updated LAO
                Property_amount_valuer: well.Property_amount_valuer, // keep valuer
                Property_amount_lao: well.Property_amount_lao        // user updated LAO
            }));

            console.log("🌳 Bulk updating well:", payloads);

            // Call API one by one (or you can use Promise.all)
            await Promise.all(
                currentEditRecord.wellData.map((well, i) =>
                    apiService.patchUpdateProperty(well.Property_id, payloads[i])
                )
            );

            console.log("✅ All well updated successfully");

            // After successful update, recalc totals
            // const newTotalTreeAmount = currentEditRecord.homeData.reduce(
            //   (sum, t) => sum + ((t.tree_count || 0) * (t.tree_value_lao ?? t.tree_value_valuer ?? 0)),
            //   0
            // );
            // handleEditFormChange("treeAmount", newTotalTreeAmount);

        } catch (error) {
            console.error("❌ Error bulk updating well:", error);
            setWellUpdateErrors({ global: error.message || "Failed to update well" });
        } finally {
            setUpdatingWell({});
        }
    };
    // pipeline
    const updateAllPipeline = async () => {
        try {
            // Mark all trees as updating
            const updatingMap = {};
            currentEditRecord.pipelineData.forEach(pipeline => {
                updatingMap[pipeline.Property_id] = true;
            });

            setUpdatingPipeline(updatingMap);
            setPipelineUpdateErrors({});

            // Prepare all payloads
            const payloads = currentEditRecord.pipelineData.map(pipeline => ({
                // land_owner_id: currentEditRecord.landOwnerId,
                // tree_type_name: home.tree_type_name,
                // tree_count: home.tree_count,
                property_type: "pipeline",
                Property_amount_valuer: pipeline.Property_amount_valuer, // keep valuer
                Property_amount_lao: pipeline.Property_amount_lao        // user updated LAO
            }));

            console.log("🌳 Bulk updating pipeline:", payloads);

            // Call API one by one (or you can use Promise.all)
            await Promise.all(
                currentEditRecord.pipelineData.map((pipeline, i) =>
                    apiService.patchUpdateProperty(pipeline.Property_id, payloads[i])
                )
            );

            console.log("✅ All pipeline updated successfully");

            // After successful update, recalc totals
            // const newTotalTreeAmount = currentEditRecord.homeData.reduce(
            //   (sum, t) => sum + ((t.tree_count || 0) * (t.tree_value_lao ?? t.tree_value_valuer ?? 0)),
            //   0
            // );
            // handleEditFormChange("treeAmount", newTotalTreeAmount);

        } catch (error) {
            console.error("❌ Error bulk updating pipeline:", error);
            setPipelineUpdateErrors({ global: error.message || "Failed to update pipeline" });
        } finally {
            setUpdatingPipeline({});
        }
    };
    // Borewell
    const updateAllBorewell = async () => {
        try {
            // Mark all trees as updating
            const updatingMap = {};
            currentEditRecord.borewellData.forEach(borewell => {
                updatingMap[borewell.Property_id] = true;
            });

            setUpdatingBoreWell(updatingMap);
            setBoreWellUpdateErrors({});

            // Prepare all payloads
            const payloads = currentEditRecord.borewellData.map(borewell => ({
                // land_owner_id: currentEditRecord.landOwnerId,
                // tree_type_name: home.tree_type_name,
                // tree_count: home.tree_count,
                property_type: "borewell",
                Property_amount_valuer: borewell.Property_amount_valuer, // keep valuer
                Property_amount_lao: borewell.Property_amount_lao        // user updated LAO
            }));

            console.log("🌳 Bulk updating borewell:", payloads);

            // Call API one by one (or you can use Promise.all)
            await Promise.all(
                currentEditRecord.borewellData.map((borewell, i) =>
                    apiService.patchUpdateProperty(borewell.Property_id, payloads[i])
                )
            );

            console.log("✅ All borewell updated successfully");

            // After successful update, recalc totals
            // const newTotalTreeAmount = currentEditRecord.homeData.reduce(
            //   (sum, t) => sum + ((t.tree_count || 0) * (t.tree_value_lao ?? t.tree_value_valuer ?? 0)),
            //   0
            // );
            // handleEditFormChange("treeAmount", newTotalTreeAmount);

        } catch (error) {
            console.error("❌ Error bulk updating borewell:", error);
            setBoreWellUpdateErrors({ global: error.message || "Failed to update borewell" });
        } finally {
            setUpdatingBoreWell({});
        }
    };
    // Others
    const updateAllOther = async () => {
        try {
            // Mark all trees as updating
            const updatingMap = {};
            currentEditRecord.otherData.forEach(other => {
                updatingMap[other.Property_id] = true;
            });

            setUpdatingOther(updatingMap);
            setOtherUpdateErrors({});

            // Prepare all payloads
            const payloads = currentEditRecord.otherData.map(other => ({
                // land_owner_id: currentEditRecord.landOwnerId,
                // tree_type_name: home.tree_type_name,
                // tree_count: home.tree_count,
                property_type: "other",
                Property_amount_valuer: other.Property_amount_valuer, // keep valuer
                Property_amount_lao: other.Property_amount_lao        // user updated LAO
            }));

            console.log("🌳 Bulk updating other:", payloads);

            // Call API one by one (or you can use Promise.all)
            await Promise.all(
                currentEditRecord.otherData.map((other, i) =>
                    apiService.patchUpdateProperty(other.Property_id, payloads[i])
                )
            );

            console.log("✅ All other updated successfully");

            // After successful update, recalc totals
            // const newTotalTreeAmount = currentEditRecord.homeData.reduce(
            //   (sum, t) => sum + ((t.tree_count || 0) * (t.tree_value_lao ?? t.tree_value_valuer ?? 0)),
            //   0
            // );
            // handleEditFormChange("treeAmount", newTotalTreeAmount);

        } catch (error) {
            console.error("❌ Error bulk updating other:", error);
            setOtherUpdateErrors({ global: error.message || "Failed to update other" });
        } finally {
            setUpdatingOther({});
        }
    };

    if (loading && compensationData.length === 0) {
        return (
            <div className="w-full bg-white min-h-screen flex items-center justify-center">
                <div className="flex flex-col items-center space-y-4">
                    <Loader className="h-8 w-8 animate-spin text-blue-500" />
                    <p className="text-gray-600">{translations[language]?.loadingCompensation}</p>
                </div>
            </div>
        );
    }

    // Calculate totals for numeric fields
    const totals = compensationData.reduce(
        (acc, row) => {
            acc.irrigableArea += Number(row.irrigableArea) || 0;
            acc.nonIrrigableArea += Number(row.nonIrrigableArea) || 0;
            acc.landRate += Number(row.landRate) || 0;
            acc.landRateFinalAmount += Number(row.landRateFinalAmount) || 0;
            acc.landAmount += Number(row.landAmount) || 0;
            acc.totalTreeCompensation += Number(row.totalTreeCompensation) || 0;
            acc.constructionValue +=
                (row.homeCompensation || 0) +
                (row.tinshedCompensation || 0) +
                (row.structureCompensation || 0) +
                (row.cropCompensation || 0) +
                (row.wireCompensation || 0) +
                (row.otherAssetCompensation || 0);
            acc.wellBorewell +=
                (row.waterBodyCompensation || 0) +
                (row.borewellCompensation || 0);
            acc.bothInterestTotal += Number(row.bothInterestTotal) || 0;
            acc.pipelineCompensation += Number(row.pipelineCompensation) || 0;
            acc.firstTotal += Number(row.firstTotal) || 0;
            acc.secondTotal += Number(row.secondTotal) || 0;
            acc.govtRecovery += Number(row.govtRecovery) || 0;
            acc.advanceAmount += Number(row.advanceAmount) || 0;
            acc.thirdTotal += Number(row.thirdTotal) || 0;

            return acc;
        },

        
        {
            irrigableArea: 0,
            nonIrrigableArea: 0,
            landRate: 0,
            landRateFinalAmount: 0,
            landAmount: 0,
            totalTreeCompensation: 0,
            constructionValue: 0,
            wellBorewell: 0,
            firstTotal: 0,
            secondTotal: 0,
            govtRecovery: 0,
            advanceAmount: 0,
            thirdTotal: 0,
            bothInterestTotal: 0,
            pipelineCompensation: 0,
        }
    );
    // 👇 ADD THIS NEW GROUPING LOGIC HERE 👇
    const groupedCompensationData = compensationData.reduce((acc, row) => {
        const village = row.village_name || 'Unknown Village';
        if (!acc[village]) acc[village] = [];
        acc[village].push(row);
        return acc;
    }, {});

    let globalSrNo = 0; // Initialize global serial number counter for the table

    return (
        <div className="w-full bg-white min-h-screen">
            {/* Header */}
            <div className="bg-gradient-to-r from-gray-50 to-gray-100 border-b border-gray-200 shadow-sm">
                <div className="p-6">
                    <div className="flex items-center justify-between">

                        <div className="flex items-center space-x-3">
                            {/* Filter Button */}
                            {/* <button
                                onClick={() => setShowFilterPanel(!showFilterPanel)}
                                className={`flex items-center space-x-2 px-4 py-2.5 rounded-lg font-medium transition-all duration-200 shadow-sm hover:shadow-md ${showFilterPanel
                                    ? 'bg-orange-600 text-white'
                                    : 'bg-orange-600 text-white '
                                    }`}
                            >
                                <Filter className="h-4 w-4" />
                                <span>{translations[language]?.filters}</span>
                                {showFilterPanel ?
                                    <ChevronUp className="h-4 w-4" /> :
                                    <ChevronDown className="h-4 w-4" />
                                }
                            </button> */}

                            {/* <button
                                onClick={handleGenerateNotice}
                                disabled={compensationData.length === 0}
                                className="flex items-center space-x-2 px-4 py-2.5 bg-blue-600 hover:bg-blue-700 disabled:bg-gray-400 text-white rounded-lg font-medium transition-all duration-200 shadow-sm hover:shadow-md disabled:cursor-not-allowed"
                            >
                                <FileText className="h-4 w-4" />
                                <span>{translations[language]?.generateNotice}</span>
                            </button> */}

                            {/* <button className="relative">
                                <label className="flex items-center space-x-2 px-4 py-2 bg-yellow-600 text-white rounded-md hover:bg-yellow-700 cursor-pointer">
                                    <Upload size={18} />
                                    <span>Upload Signature</span>
                                    <input
                                        type="file"
                                        accept="application/pdf,image/*"
                                        className="hidden"
                                        onChange={handleUploadedFile}
                                    />
                                </label>
                            </button> */}

                            <button
                                onClick={handlePrint} // MODIFIED: Changed onClick handler
                                disabled={downloading || compensationData.length === 0}
                                className="flex items-center space-x-2 px-4 py-2.5 bg-green-600 hover:bg-green-700 disabled:bg-gray-400 text-white rounded-lg font-medium transition-all duration-200 shadow-sm hover:shadow-md disabled:cursor-not-allowed"
                            >
                                {downloading ? (
                                    <>
                                        <Loader className="h-4 w-4 animate-spin" />
                                        <span>{translations[language]?.downloading}</span>
                                    </>
                                ) : (
                                    <>
                                        <Printer className="h-4 w-4" />
                                        <span>{translations[language]?.Print}</span>
                                    </>
                                )}
                            </button>

                            {/* send to final award  */}
                            {/* {userRole === 3 && (

                                <button
                                    onClick={handleSendToFinalAwards}
                                    disabled={sendingToCoordination}
                                    className={`px-4 py-2 rounded-xl shadow-md font-semibold transition-all duration-200 
    ${sendingToCoordination
                                            ? 'bg-gray-400 text-gray-600 cursor-not-allowed'
                                            : isFinalAwardButtonDisabled
                                                ? 'bg-red-600 text-white'
                                                : 'bg-blue-600 text-white hover:bg-blue-700'
                                        }`}
                                >
                                    {sendingToCoordination ? (
                                        <>
                                            <div className="inline-block w-4 h-4 mr-2 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                                            {translations[language]?.sending}
                                        </>
                                    ) : (
                                        `${translations[language]?.sendToFinalAward} (${compensationData.length})`
                                    )}
                                </button>
                            )} */}
                        </div>
                    </div>
                </div>
            </div>

            {/* Collapsible Filter Panel */}
            {showFilterPanel && (
                <div className="bg-white border-b border-gray-200 shadow-sm">
                    <div className="p-6">
                        <div className="space-y-6">
                            <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
                                {/* Filter Mode Selection */}
                                <div className="flex items-center justify-between">
                                    <div className="flex items-center space-x-1 bg-gray-100 rounded-xl p-1.5 shadow-inner">
                                        <button
                                            onClick={() => setFilterMode('location')}
                                            className={`px-4 py-2.5 rounded-lg text-sm font-medium transition-all duration-200 flex items-center space-x-2 ${filterMode === 'location'
                                                ? 'bg-white text-blue-600 shadow-sm'
                                                : 'text-gray-600 hover:text-gray-800 hover:bg-gray-50'
                                                }`}
                                        >
                                            <MapPin className="h-4 w-4" />
                                            <span>{translations[language]?.filterByLocation}</span>
                                        </button>
                                        <button
                                            onClick={() => setFilterMode('all')}
                                            className={`px-4 py-2.5 rounded-lg text-sm font-medium transition-all duration-200 flex items-center space-x-2 ${filterMode === 'all'
                                                ? 'bg-white text-blue-600 shadow-sm'
                                                : 'text-gray-600 hover:text-gray-800 hover:bg-gray-50'
                                                }`}
                                        >
                                            <Globe className="h-4 w-4" />
                                            <span>{translations[language]?.allRecords}</span>
                                        </button>
                                    </div>
                                </div>
                            </div>

                            {/* Location Filters - Only show when location mode is selected */}
                            {filterMode === 'location' && (
                                <div className="bg-gray-50 rounded-xl p-6 border border-gray-200">
                                    <div className="space-y-4">
                                        <div className="flex items-center">
                                            <MapPin className="h-5 w-5 text-blue-600 mr-2" />
                                            <h3 className="text-lg font-semibold text-gray-800">{translations[language]?.selectLocation}</h3>
                                        </div>
                                        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                                            <div>
                                                <label className="block text-sm font-medium text-gray-700 mb-2">
                                                    {translations[language]?.district} <span className="text-red-500">*</span>
                                                </label>
                                                <select
                                                    value={selectedDistrict}
                                                    onChange={handleDistrictChange}
                                                    disabled={loadingDistricts}
                                                    className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:bg-gray-100 disabled:cursor-not-allowed transition-all duration-200 shadow-sm"
                                                >
                                                    <option value="">
                                                        {loadingDistricts ? <span>{translations[language]?.loadingDistricts}</span> : <span>{translations[language]?.selectDistrict}</span>}
                                                    </option>
                                                    {districts.map((district, index) => (
                                                        <option key={district.dist_name || index} value={district.dist_name}>
                                                            {getDistrictDisplayName(district)}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>

                                            <div>
                                                <label className="block text-sm font-medium text-gray-700 mb-2">
                                                    {translations[language]?.taluka} <span className="text-red-500">*</span>
                                                </label>
                                                <select
                                                    value={selectedTaluka}
                                                    onChange={handleTalukaChange}
                                                    disabled={!selectedDistrict || loadingTalukas}
                                                    className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:bg-gray-100 disabled:cursor-not-allowed transition-all duration-200 shadow-sm"
                                                >
                                                    <option value="">
                                                        {loadingTalukas ? <span>{translations[language]?.loadingTalukas}</span> : <span>{translations[language]?.selectTaluka}</span>}
                                                    </option>
                                                    {availableTalukas.map((taluka, index) => (
                                                        <option key={taluka.taluka_name || index} value={getTalukaDisplayName(taluka)}>
                                                            {getTalukaDisplayName(taluka)}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>

                                            <div>
                                                <label className="block text-sm font-medium text-gray-700 mb-2">
                                                    {translations[language]?.village} <span className="text-red-500">*</span>
                                                </label>
                                                <select
                                                    value={selectedVillage}
                                                    onChange={handleVillageChange}
                                                    disabled={!selectedTaluka || loadingVillages}
                                                    className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:bg-gray-100 disabled:cursor-not-allowed transition-all duration-200 shadow-sm"
                                                >
                                                    <option value="">
                                                        {loadingVillages ? <span>{translations[language]?.loadingVillages}</span> : <span>{translations[language]?.selectVillage}</span>}
                                                    </option>
                                                    {availableVillages.map((village, index) => (
                                                        <option key={village.village_name || index} value={getVillageDisplayName(village)}>
                                                            {getVillageDisplayName(village)}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                        {/* Show helpful message about progressive filtering */}
                                        {filterMode === 'location' && !hasValidLocationSelection && (
                                            <div className="bg-amber-50 border border-amber-200 rounded-lg p-3">
                                                <p className="text-sm text-amber-700">
                                                    {translations[language]?.selectLocationNotice}
                                                </p>
                                            </div>
                                        )}
                                        {filterMode === 'location' && hasValidLocationSelection && (
                                            <div className="bg-green-50 border border-green-200 rounded-lg p-3">
                                                <p className="text-sm text-green-700 flex items-center">
                                                    <span className="mr-2">✓</span>
                                                    {translations[language]?.showingDataFor}: {getCurrentLocationDescription()}
                                                </p>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}

            {/* Error Message */}
            {error && (
                <div className="mx-6 mb-4">
                    <div className="bg-red-50 border border-red-200 rounded-lg p-4 shadow-sm">
                        <div className="flex items-center justify-between">
                            <div className="flex items-center">
                                <div className="flex-shrink-0">
                                    <X className="h-5 w-5 text-red-400" />
                                </div>
                                <div className="ml-3">
                                    <p className="text-sm text-red-700">{error}</p>
                                </div>
                            </div>
                            <button
                                onClick={() => setError(null)}
                                className="text-red-400 hover:text-red-600 transition-colors"
                            >
                                <X className="h-4 w-4" />
                            </button>
                        </div>
                        <div className="mt-3">
                            <button
                                onClick={filterMode === 'all' ? loadCompensationDataForAll : loadCompensationData}
                                className="px-3 py-1.5 bg-red-600 hover:bg-red-700 text-white text-sm rounded-lg transition-colors shadow-sm"
                            >
                                {translations[language]?.retry}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Main Table - Only show when data can be displayed */}
            {canShowData && (
                <div className="px-6 pb-6 my-5">
                    <div className="bg-white rounded-xl shadow-lg border border-gray-200 overflow-hidden">
                        <div className="overflow-x-auto" ref={tableRef}>
                            <table className="min-w-full text-xs">
                                <thead className="bg-gradient-to-r from-gray-100 to-gray-200">
                                    {/* First Header Row */}
                                    <tr>
                                        {/* {userRole === 3 && (
                    <th className="px-3 py-3 border border-gray-300 text-center font-bold text-gray-700" rowSpan="2">
                      <div className="flex items-center justify-center gap-2">
                        <input
                          type="checkbox"
                          checked={compensationData.length > 0 && selectedOwners.length === compensationData.length}
                          onChange={handleSelectAll}
                          className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 focus:ring-2"
                        />
                        <span>Select</span>
                      </div>
                    </th>
              )} */}

                                        <th className="no-print px-3 py-3 border border-gray-300 text-center font-bold text-gray-700" rowSpan="2">
                                            {translations[language]?.Actions}
                                        </th>
                                        {/* 1 */}
                                        <th className="px-3 py-3 border border-gray-300 text-center font-bold text-gray-700" rowSpan="2">
                                            {translations[language]?.SrNo}
                                        </th>
                                        {/* <th className="px-3 py-3 border border-gray-300 text-center font-bold text-gray-700" rowSpan="2">
                      Land Owner ID
                    </th> */}
                                        {/* 2 */}
                                        <th className="px-3 py-3 border border-gray-300 text-center font-bold text-gray-700" rowSpan="2">
                                            {translations[language]?.OccupantName}
                                        </th>
                                        {/* 3 */}
                                        <th className="px-3 py-3 border border-gray-300 text-center font-bold text-gray-700" rowSpan="2">
                                            {translations[language]?.GatNumber}
                                        </th>
                                        {/* 4 */}
                                        <th className="px-3 py-3 border border-gray-300 text-center font-bold text-gray-700" colSpan="3">
                                            {translations[language]?.areaAcquired}
                                        </th>
                                        {/* <th className="px-3 py-3 border border-gray-300 text-center font-bold text-gray-700 " colSpan="3">
                      Total Area of Survey Number
                    </th> */}
                                        {/* 5 */}
                                        <th className="px-3 py-3 border border-gray-300 text-center font-bold text-gray-700" rowSpan="2">
                                            {translations[language]?.RecordedValuePartialRate}
                                        </th>
                                        {/* 6 */}
                                        <th className="px-3 py-3 border border-gray-300 text-center font-bold text-gray-700" rowSpan="2">
                                            {translations[language]?.RecordedValuePartialMarket}
                                        </th>
                                        {/* <th className="px-3 py-3 border border-gray-300 text-center font-bold text-gray-700 bg-yellow-50" colSpan="5">
                      Compensation Count
                    </th> */}
                                        {/* 7 */}
                                        <th className="px-3 py-3 border border-gray-300 text-center font-bold text-gray-700" rowSpan="2">
                                            {translations[language]?.MarketValueDoubleFactor}
                                        </th>
                                        {/* 8 */}
                                        <th className="px-3 py-3 border border-gray-300 text-center font-bold text-gray-700" rowSpan="2">
                                            {translations[language]?.TreeValuation}/{translations[language]?.ForestTreeValuation}
                                        </th>
                                        {/* 9 */}
                                        <th className="px-3 py-3 border border-gray-300 text-center font-bold text-gray-700" rowSpan="2">
                                            {translations[language]?.ConstructionValue}
                                        </th>
                                        {/* 10 */}
                                        <th className="px-3 py-3 border border-gray-300 text-center font-bold text-gray-700" rowSpan="2">
                                            {translations[language]?.WellBorewell}
                                        </th>
                                        {/* 11 */}
                                        <th className="px-3 py-3 border border-gray-300 text-center font-bold text-gray-700" rowSpan="2">
                                            {translations[language]?.TotalAmount}
                                        </th>
                                        {/* 12 */}
                                        <th className="px-3 py-3 border border-gray-300 text-center font-bold text-gray-700" rowSpan="2">
                                            {/* {translations[language]?.ReliefAmount100} */}
                                            {translations[language]?.ReliefAmount100}
                                        </th>
                                        <th className="px-3 py-3 border border-gray-300 text-center font-bold text-gray-700" rowSpan="2">
                                            12% {translations[language]?.InterestAmountFrom}
                                        </th>
                                        <th className="px-3 py-3 border border-gray-300 text-center font-bold text-gray-700" rowSpan="2">
                                            {translations[language]?.Pipeline}
                                        </th>
                                        <th className="px-3 py-3 border border-gray-300 text-center font-bold text-gray-700" rowSpan="2">
                                            {translations[language]?.TotalSecondAmount}
                                        </th>
                                        <th className="px-3 py-3 border border-gray-300 text-center font-bold text-gray-700" rowSpan="2">
                                            शासकीय वसुली
                                        </th>
                                        <th className="px-3 py-3 border border-gray-300 text-center font-bold text-gray-700" rowSpan="2">
                                            {translations[language]?.AdvanceCompDeduction}
                                        </th>
                                        {/* <th className="px-3 py-3 border border-gray-300 text-center font-bold text-gray-700" rowSpan="2">
                                            {translations[language]?.AdvanceInterestDeduction}
                                        </th> */}
                                        <th className="px-3 py-3 border border-gray-300 text-center font-bold text-gray-700" rowSpan="2">
                                            {translations[language]?.NetPayableAmount}
                                        </th>
                                        <th className="no-print px-3 py-3 border border-gray-300 text-center font-bold text-gray-700" rowSpan="2">
                                            {translations[language]?.Status}
                                        </th>
                                    </tr>

                                    {/* Second Header Row */}
                                    <tr>
                                        <th className="px-3 py-2 border border-gray-300 text-center font-bold text-gray-700 bg-blue-50">{translations[language]?.RecordedAreaIrrigable}</th>
                                        <th className="px-3 py-2 border border-gray-300 text-center font-bold text-gray-700 bg-blue-50">{translations[language]?.NonIrrigable}</th>
                                        <th className="px-3 py-2 border border-gray-300 text-center font-bold text-gray-700 bg-blue-50">{translations[language]?.TotalAquare}</th>
                                        {/* <th className="px-3 py-2 border border-gray-300 text-center font-bold text-gray-700 ">Ha</th>
                    <th className="px-3 py-2 border border-gray-300 text-center font-bold text-gray-700 ">Are</th>
                    <th className="px-3 py-2 border border-gray-300 text-center font-bold text-gray-700 ">Sq.M</th>
                    <th className="px-3 py-2 border border-gray-300 text-center font-bold text-gray-700 bg-yellow-50">Land</th>
                    <th className="px-3 py-2 border border-gray-300 text-center font-bold text-gray-700 bg-yellow-50">Structure</th>
                    <th className="px-3 py-2 border border-gray-300 text-center font-bold text-gray-700 bg-yellow-50">Tree</th>
                    <th className="px-3 py-2 border border-gray-300 text-center font-bold text-gray-700 bg-yellow-50">Others</th>
                    <th className="px-3 py-2 border border-gray-300 text-center font-bold text-gray-700 bg-yellow-50">Total (₹)</th> */}
                                    </tr>

                                </thead>
<tbody className="bg-white">

                                    <tr>
                                        <th className="no-print px-3 py-3 border border-gray-300 text-center font-bold text-gray-700"></th>
                                        <th className="px-3 py-3 border border-gray-300 text-center font-bold text-gray-700">1</th>
                                        <th className="px-3 py-3 border border-gray-300 text-center font-bold text-gray-700">2</th>
                                        <th className="px-3 py-3 border border-gray-300 text-center font-bold text-gray-700">3</th>
                                        <th className="px-3 py-3 border border-gray-300 text-center font-bold text-gray-700 bg-blue-50">4</th>
                                        <th className="px-3 py-3 border border-gray-300 text-center font-bold text-gray-700 bg-blue-50">5</th>
                                        <th className="px-3 py-3 border border-gray-300 text-center font-bold text-gray-700 bg-blue-50">6</th>
                                        <th className="px-3 py-3 border border-gray-300 text-center font-bold text-gray-700">7</th>
                                        <th className="px-3 py-3 border border-gray-300 text-center font-bold text-gray-700">8</th>
                                        <th className="px-3 py-3 border border-gray-300 text-center font-bold text-gray-700">9</th>
                                        <th className="px-3 py-3 border border-gray-300 text-center font-bold text-gray-700">10</th>
                                        <th className="px-3 py-3 border border-gray-300 text-center font-bold text-gray-700">11</th>
                                        <th className="px-3 py-3 border border-gray-300 text-center font-bold text-gray-700">12</th>
                                        <th className="px-3 py-3 border border-gray-300 text-center font-bold text-gray-700 bg-green-100">13</th>
                                        <th className="px-3 py-3 border border-gray-300 text-center font-bold text-gray-700">14</th>
                                        <th className="px-3 py-3 border border-gray-300 text-center font-bold text-gray-700">15</th>
                                        <th className="px-3 py-3 border border-gray-300 text-center font-bold text-gray-700">16</th>
                                        <th className="px-3 py-3 border border-gray-300 text-center font-bold text-gray-700 bg-green-100">17</th>
                                        <th className="px-3 py-3 border border-gray-300 text-center font-bold text-gray-700">18</th>
                                        <th className="px-3 py-3 border border-gray-300 text-center font-bold text-gray-700">19</th>
                                        <th className="px-3 py-3 border border-gray-300 text-center font-bold text-gray-700">20</th>
                                    </tr>
                                    {loading ? (
                                        <tr>
                                            <td colSpan="21" className="px-6 py-12 text-center">
                                                <div className="flex flex-col items-center justify-center space-y-3">
                                                    <Loader className="w-8 h-8 animate-spin text-blue-500" />
                                                    <div className="text-gray-500 font-medium">{translations[language]?.loadingCompensation}</div>
                                                </div>
                                            </td>
                                        </tr>
                                    ) : compensationData.length === 0 ? (
                                        <tr>
                                            <td colSpan="21" className="px-6 py-12 text-center">
                                                <div className="flex flex-col items-center justify-center space-y-3">
                                                    <div className="w-16 h-16 rounded-full bg-gray-100 flex items-center justify-center">
                                                        <FileText className="w-8 h-8 text-gray-400" />
                                                    </div>
                                                    <div className="text-gray-500 font-medium">
                                                        {filterMode === 'location' && !hasValidLocationSelection
                                                            ? 'Please select District, Taluka, and Village to load compensation data'
                                                            : 'No compensation records found'
                                                        }
                                                    </div>
                                                    {filterMode === 'location' && hasValidLocationSelection && currentProjectId && (
                                                        <div className="text-xs text-gray-400">
                                                            {translations[language]?.projectId}: {currentProjectId}
                                                            {currentProposalId && ` | Proposal ID: ${currentProposalId}`}
                                                            <br />
                                                            {translations[language]?.location}: {getCurrentLocationDescription()}
                                                        </div>
                                                    )}
                                                </div>
                                            </td>
                                        </tr>
                                    ) : (
                                        <>
                                            {/* 👇 NEW VILLAGE GROUPING RENDER 👇 */}
                                            {Object.entries(groupedCompensationData).map(([villageName, villageRows]) => (
                                                <React.Fragment key={villageName}>
                                                    {/* Village Header Row */}
                                                    <tr className="bg-indigo-50/70 border-y-2 border-indigo-200">
                                                        <td colSpan="21" className="px-4 py-3 text-left font-bold text-indigo-900 shadow-inner">
                                                            <div className="flex items-center text-sm">
                                                                <MapPin className="w-5 h-5 mr-2 text-indigo-600" />
                                                                {translations[language]?.village || 'Village'}: {villageName} 
                                                                <span className="ml-2 px-2 py-0.5 bg-indigo-100 text-indigo-700 rounded-full text-xs">
                                                                    {villageRows.length} Records
                                                                </span>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    
                                                    {/* Original Rows inside the Village */}
                                                    {villageRows.map((row) => {
                                                        globalSrNo++; // Increment the global serial number
                                                        return (
                                                            <tr
                                                                key={row.landOwnerId}
                                                                className="hover:bg-blue-50/50 transition-colors duration-150"
                                                            >
                                                                <td className="no-print px-3 py-3 border border-gray-300 text-center">
                                                                    <button
                                                                        onClick={() => handleEditClick(row)}
                                                                        className="inline-flex items-center px-3 py-1.5 bg-orange-500 hover:bg-orange-600 text-white text-xs rounded-lg transition-colors font-medium shadow-sm"
                                                                        title={`Edit compensation for ${row.owner_name} (Land Owner ID: ${row.landOwnerId})`}
                                                                    >
                                                                        <Edit2 className="h-3 w-3 mr-1" />
                                                                        {translations[language]?.edit}
                                                                    </button>
                                                                </td>
                                                                <td className="px-3 py-3 border border-gray-300 text-center font-medium">
                                                                    {globalSrNo} {row.owner_aqr_area}
                                                                </td>
                                                                <td className="px-3 py-3 border border-gray-300 text-left">
                                                                    {row.owner_name || 'N/A'}
                                                                </td>
                                                                <td className="px-3 py-3 border border-gray-300 text-center font-medium text-blue-600">
                                                                    {row.surveyNo || 'N/A'}
                                                                </td>
                                                                <td className="px-3 py-3 border border-gray-300 text-center bg-blue-50">
                                                                    {(row.irrigableArea || 0).toFixed(2)}
                                                                </td>
                                                                <td className="px-3 py-3 border border-gray-300 text-center bg-blue-50">
                                                                    {(row.nonIrrigableArea || 0).toFixed(2)}
                                                                </td>
                                                                <td className="px-3 py-3 border border-gray-300 text-center bg-blue-50">
                                                                    {((row.irrigableArea || 0) + (row.nonIrrigableArea || 0)).toFixed(2)}
                                                                </td>
                                                                <td className="px-3 py-3 border border-gray-300 text-center ">
                                                                    {row.landRate || 0}
                                                                </td>
                                                                <td className="px-3 py-3 border border-gray-300 text-center ">
                                                                    {row.landRateFinalAmount || 0}
                                                                </td>
                                                                <td className="px-3 py-3 border border-gray-300 text-center ">
                                                                    {row.landAmount || 0}
                                                                </td>
                                                                <td className="px-3 py-3 border border-gray-300 text-center">
                                                                    {row.totalTreeCompensation || 0}
                                                                </td>
                                                                <td className="px-3 py-3 border border-gray-300 text-center">
                                                                    {row.homeCompensation + row.tinshedCompensation + row.structureCompensation + row.cropCompensation + row.wireCompensation + row.otherAssetCompensation || 0}
                                                                </td>
                                                                <td className="px-3 py-3 border border-gray-300 text-center">
                                                                    {row.waterBodyCompensation + row.borewellCompensation || 0}
                                                                </td>
                                                                <td className="px-3 py-3 border border-gray-300 text-center bg-green-100">
                                                                    {row.firstTotal || 0}
                                                                </td>
                                                                <td className="px-3 py-3 border border-gray-300 text-center">
                                                                    {row.firstTotal || 0}
                                                                </td>
                                                                <td className="px-3 py-3 border border-gray-300 text-center">
                                                                    {row.bothInterestTotal || 0}
                                                                    <div className='no-print text-[10px] text-gray-500 mt-1'>
                                                                        (Final: {row.interestAward || 0} + Advan.: {row.advanceInterestAmount || 0})
                                                                    </div>
                                                                </td>
                                                                <td className="px-3 py-3 border border-gray-300 text-center">
                                                                    {row.pipelineCompensation}
                                                                </td>
                                                                <td className="px-3 py-3 border border-gray-300 text-center bg-green-100">
                                                                    {row.secondTotal || 0}
                                                                </td>
                                                                <td className="px-3 py-3 border border-gray-300 text-center">
                                                                    {row.govtRecovery || 0}
                                                                </td>
                                                                <td className="px-3 py-3 border border-gray-300 text-center">
                                                                    {row.advanceAmount || 0}
                                                                </td>
                                                                <td className="px-3 py-3 border border-gray-300 text-center font-bold bg-green-100">
                                                                    {row.thirdTotal || 0}
                                                                </td>
                                                                <td className="no-print px-3 py-3 border border-gray-300 text-center">
                                                                    <span
                                                                        className={`inline-block px-2 py-1 text-xs font-semibold rounded-full
                                  ${row.compensationStatus === 'Completed'
                                                                                ? 'bg-green-100 text-green-700'
                                                                                : 'bg-red-100 text-red-700'}`}
                                                                    >
                                                                        {row.compensationStatus || 'Pending'}
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        );
                                                    })}
                                                </React.Fragment>
                                            ))}
                                            {/* 👆 END OF NEW VILLAGE GROUPING RENDER 👆 */}

                                            {compensationData.length > 0 && (
                                                <tr className="bg-gradient-to-r from-gray-100 to-gray-200 font-bold border-t-2 border-gray-400">
                                                    <td className="no-print px-3 py-3 border border-gray-300 text-center"></td>

                                                    <td className="px-3 py-3 border border-gray-300 text-center" colSpan="3">
                                                        GRAND TOTAL
                                                    </td>

                                                    {/* Irrigable / Non-Irrigable / Total Area */}
                                                    <td className="px-3 py-3 border border-gray-300 text-center bg-blue-50">
                                                        {totals.irrigableArea.toFixed(2)}
                                                    </td>
                                                    <td className="px-3 py-3 border border-gray-300 text-center bg-blue-50">
                                                        {totals.nonIrrigableArea.toFixed(2)}
                                                    </td>
                                                    <td className="px-3 py-3 border border-gray-300 text-center bg-blue-50">
                                                        {(totals.irrigableArea + totals.nonIrrigableArea).toFixed(2)}
                                                    </td>

                                                    {/* Rate / Value */}
                                                    <td className="px-3 py-3 border border-gray-300 text-center">
                                                        {totals.landRate.toFixed(2)}
                                                    </td>
                                                    <td className="px-3 py-3 border border-gray-300 text-center">
                                                        {totals.landRateFinalAmount.toFixed(2)}
                                                    </td>
                                                    <td className="px-3 py-3 border border-gray-300 text-center">
                                                        {totals.landAmount.toFixed(2)}
                                                    </td>

                                                    {/* Tree / Construction / Well */}
                                                    <td className="px-3 py-3 border border-gray-300 text-center">
                                                        {totals.totalTreeCompensation.toFixed(2)}
                                                    </td>
                                                    <td className="px-3 py-3 border border-gray-300 text-center">
                                                        {totals.constructionValue.toFixed(2)}
                                                    </td>
                                                    <td className="px-3 py-3 border border-gray-300 text-center">
                                                        {totals.wellBorewell.toFixed(2)}
                                                    </td>

                                                    {/* Totals */}
                                                    <td className="px-3 py-3 border border-gray-300 text-center bg-green-100">
                                                        {totals.firstTotal.toFixed(2)}
                                                    </td>
                                                    <td className="px-3 py-3 border border-gray-300 text-center">
                                                        {totals.firstTotal.toFixed(2)}
                                                    </td>
                                                    <td className="px-3 py-3 border border-gray-300 text-center">
                                                        {totals.bothInterestTotal.toFixed(2)}
                                                    </td>
                                                    <td className="px-3 py-3 border border-gray-300 text-center">
                                                        {totals.pipelineCompensation.toFixed(2)}
                                                    </td>
                                                    <td className="px-3 py-3 border border-gray-300 text-center bg-green-100">
                                                        {totals.secondTotal.toFixed(2)}
                                                    </td>
                                                    <td className="px-3 py-3 border border-gray-300 text-center">
                                                        {totals.govtRecovery.toFixed(2)}
                                                    </td>
                                                    <td className="px-3 py-3 border border-gray-300 text-center">
                                                        {totals.advanceAmount.toFixed(2)}
                                                    </td>
                                                    <td className="px-3 py-3 border border-gray-300 text-center font-bold bg-green-100 text-green-800">
                                                        {totals.thirdTotal.toFixed(2)}
                                                    </td>

                                                    {/* Status & Actions columns */}
                                                    <td className="no-print px-3 py-3 border border-gray-300 text-center">-</td>
                                                </tr>
                                            )}
                                        </>
                                    )}
                                </tbody>
                               
                            </table>
                        </div>
                    </div>
                </div>
            )}

            {/* Show message when filter mode is location but selection is incomplete */}
            {filterMode === 'location' && !hasValidLocationSelection && (
                <div className="mt-6 text-center py-12">
                    <div className="max-w-md mx-auto">
                        <MapPin className="h-16 w-16 text-gray-300 mx-auto mb-4" />
                        <p className="text-gray-500 text-lg font-medium mb-2">{translations[language]?.locationSelectionRequired}</p>
                        <p className="text-gray-400 text-sm">{translations[language]?.selectFromFilter}</p>
                    </div>
                </div>
            )}

            {/* Edit Compensation Modal */}
            {showEditModal && currentEditRecord && (
                <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 p-4">
                    <div className="bg-white rounded-2xl shadow-2xl max-w-5xl w-full max-h-[95vh] overflow-hidden border border-gray-200">
                        {/* Modal Header */}
                        <div className="sticky top-0 bg-gradient-to-r from-blue-500 to-blue-600 px-4 py-3 flex justify-between items-center shadow-lg">
                            <div>
                                <h2 className="text-lg font-bold text-white mb-1">
                                    {translations[language]?.editCompensationRecord}
                                </h2>
                            </div>
                            <button
                                onClick={() => {
                                    setShowEditModal(false);
                                    setEditError(null);
                                    setEditSuccess(false);
                                    setCurrentEditRecord(null);
                                }}
                                className="p-2 hover:bg-white/20 rounded-lg transition-all duration-200 text-white hover:rotate-90"
                            >
                                <X className="h-4 w-4" />
                            </button>
                        </div>

                        {/* Modal Content */}
                        <div className="p-4 overflow-auto max-h-[calc(95vh-80px)]">
                            {/* Success Message */}
                            {editSuccess && (
                                <div className="mb-4 p-3 bg-gradient-to-r from-green-50 to-emerald-50 border border-green-200 text-green-800 rounded-lg shadow-sm">
                                    <div className="flex items-center space-x-2">
                                        <div className="flex-shrink-0 w-6 h-6 bg-green-100 rounded-full flex items-center justify-center">
                                            <span className="text-green-600 text-sm">✅</span>
                                        </div>
                                        <span className="font-medium text-sm"> {translations[language]?.updateSuccess}</span>
                                    </div>
                                </div>
                            )}

                            {/* Error Message */}
                            {editError && (
                                <div className="mb-4 p-3 bg-gradient-to-r from-red-50 to-rose-50 border border-red-200 text-red-800 rounded-lg shadow-sm">
                                    <div className="flex items-center justify-between">
                                        <div className="flex items-start space-x-2">
                                            <div className="flex-shrink-0 w-6 h-6 bg-red-100 rounded-full flex items-center justify-center mt-0.5">
                                                <span className="text-red-600 text-sm">⚠️</span>
                                            </div>
                                            <pre className="whitespace-pre-wrap text-xs font-medium">{editError}</pre>
                                        </div>
                                        <button
                                            onClick={() => setEditError(null)}
                                            className="text-red-600 hover:text-red-800 p-1 hover:bg-red-100 rounded-lg transition-colors"
                                        >
                                            <X className="h-4 w-4" />
                                        </button>
                                    </div>
                                </div>
                            )}

                            {/* Current Record Info */}
                            <div className="mb-4 p-4 bg-gradient-to-r from-orange-50 to-amber-50 rounded-lg border border-orange-200 shadow-sm">
                                <div className="flex items-center space-x-2 mb-3">
                                    <div className="w-6 h-6 bg-orange-100 rounded-lg flex items-center justify-center">
                                        <span className="text-orange-600 text-sm">📋</span>
                                    </div>
                                    <h3 className="text-base font-bold text-orange-900">{translations[language]?.currentRecordInfo}</h3>
                                </div>

                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-xs">
                                    <div className="space-y-2">
                                        <div className="flex justify-between py-1 border-b border-orange-200">
                                            <span className="font-medium text-orange-800">{translations[language]?.ownerId}:</span>
                                            <span className="text-orange-700 font-bold">{currentEditRecord.landOwnerId}</span>
                                        </div>
                                        <div className="flex justify-between py-1 border-b border-orange-200">
                                            <span className="font-medium text-orange-800">{translations[language]?.OwnerName}:</span>
                                            <span className="text-orange-700">{currentEditRecord.owner_name}</span>
                                        </div>
                                        <div className="flex justify-between py-1 border-b border-orange-200">
                                            <span className="font-medium text-orange-800">{translations[language]?.location}:</span>
                                            <span className="text-orange-700">{filterMode === 'location' ? `${selectedVillage}, ${selectedTaluka}, ${selectedDistrict}` : `${currentEditRecord.village || '-'}, ${currentEditRecord.taluka || '-'}, ${currentEditRecord.district || '-'}`}</span>
                                        </div>
                                        <div className="flex justify-between py-1">
                                            <span className="font-medium text-orange-800">{translations[language]?.NatureOfOwner}:</span>
                                            <span className="text-orange-700">{currentEditRecord.natureOfOwner || ''}</span>
                                        </div>
                                    </div>
                                    <div className="space-y-2">
                                        <div className="flex justify-between py-1 border-b border-orange-200">
                                            <span className="font-medium text-orange-800">{translations[language]?.totalLand}:</span>
                                            <span className="text-orange-700 font-bold"> {(editCompensationForm.totalLandArea || 0).toLocaleString()}</span>
                                        </div>
                                        <div className="flex justify-between py-1 border-b border-orange-200">
                                            <span className="font-medium text-orange-800">{translations[language]?.acquireLand}:</span>
                                            <span className="text-orange-700">{editCompensationForm.acquiredLandArea || 0}</span>
                                        </div>
                                        <div className="flex justify-between py-1 border-b border-orange-200">
                                            <span className="font-medium text-orange-800">{translations[language]?.SurveyNo}:</span>
                                            <span className="text-orange-700">{currentEditRecord.surveyNo}</span>
                                        </div>
                                        <div className="flex justify-between py-1">
                                            <span className="font-medium text-orange-800">{translations[language]?.ActualOccupant}:</span>
                                            <span className="text-orange-700">{currentEditRecord.actualOccupant}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Form */}
                            <form onSubmit={(e) => e.preventDefault()} className="space-y-2">
                                {/* Asset Details */}
                                <div className="">
                                    {/* Land and Primary Assets */}
                                    <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden">

                                        <div className="p-3 space-y-2">
                                            {/* Land Compensation Amount */}
                                            <div className="space-y-3">
                                                <label className="block text-sm font-medium text-gray-700">
                                                    {translations[language]?.landCompensationAmount} <span className="text-red-500">*</span>
                                                </label>

                                                <div className="bg-blue-50 p-3 rounded-lg border border-blue-200">
                                                    <div className="grid grid-cols-6 gap-2 items-end">
                                                        {/* total area */}
                                                        <div>
                                                            <label className="block text-xs font-medium text-gray-600 mb-1">{translations[language]?.totalLandArea}</label>
                                                            <input
                                                                type="number"
                                                                step="0.01"
                                                                min="0"
                                                                value={editCompensationForm.totalLandArea || ''}
                                                                onChange={(e) => handleEditFormChange('totalLandArea', e.target.value)}
                                                                className="w-full px-2 py-2 border border-gray-300 rounded text-xs focus:ring-1 focus:ring-blue-500 focus:border-transparent bg-white font-medium text-center"
                                                                placeholder="Total"
                                                                disabled
                                                            />
                                                        </div>
                                                        {/* aquire area */}
                                                        <div>
                                                            <label className="block text-xs font-medium text-gray-600 mb-1">{translations[language]?.LandToBeAcquire}</label>
                                                            <input
                                                                type="number"
                                                                step="0.01"
                                                                min="0"
                                                                value={editCompensationForm.acquiredLandArea || ''}
                                                                onChange={(e) => handleEditFormChange('acquiredLandArea', e.target.value)}
                                                                className="w-full px-2 py-2 border border-gray-300 rounded text-xs focus:ring-1 focus:ring-blue-500 focus:border-transparent bg-white font-medium text-center"
                                                                placeholder="Acquired"
                                                                disabled
                                                            />
                                                        </div>
                                                        {/* rate */}
                                                        <div>
                                                            <label className="block text-xs font-medium text-gray-600 mb-1">land rate</label>
                                                            <input
                                                                type="number"
                                                                step="0.01"
                                                                min="0"
                                                                value={editCompensationForm.landRatePerUnit || ''}
                                                                onChange={(e) => handleEditFormChange('landRatePerUnit', e.target.value)}
                                                                className="w-full px-2 py-2 border border-gray-300 rounded text-xs focus:ring-1 focus:ring-blue-500 focus:border-transparent bg-white font-medium text-center"
                                                                placeholder="Rate"
                                                                disabled
                                                            />
                                                        </div>
                                                        {/* rate amount = LandToBeAcquire*landRatePerUnit*/}
                                                        <div>
                                                            <label className="block text-xs font-medium text-gray-600 mb-1">जमीनीचे बाजारमुल्य (₹)</label>
                                                            <input
                                                                type="number"
                                                                step="0.01"
                                                                min="0"
                                                                value={editCompensationForm.landRateFinalAmount || ''}
                                                                onChange={(e) => handleEditFormChange('landRateFinalAmount', e.target.value)}
                                                                className="w-full px-2 py-2 border border-gray-300 rounded text-xs focus:ring-1 focus:ring-blue-500 focus:border-transparent bg-white font-medium text-center"
                                                                placeholder="Rate"
                                                                disabled
                                                            />
                                                        </div>
                                                        {/* land amount multiplied */}
                                                        <div>
                                                            <label className="block text-xs font-medium text-gray-600 mb-1">गुणक</label>
                                                            <input
                                                                type="text"
                                                                value={editCompensationForm.landMultiplied || ''}
                                                                onChange={(e) => handleEditFormChange('landMultiplied', e.target.value)}
                                                                className="w-full px-2 py-2 border border-gray-300 rounded text-xs focus:ring-1 focus:ring-blue-500 focus:border-transparent bg-white font-medium text-center"
                                                                placeholder="Multipiled"
                                                            />
                                                        </div>
                                                        {/* <div>
                                                            <span className="text-gray-500 text-sm font-bold">=</span>
                                                        </div> */}
                                                        {/* amount */}
                                                        <div>
                                                            <label className="block text-xs font-medium text-gray-600 mb-1">{translations[language]?.amount} (₹)</label>
                                                            <input
                                                                type="number"
                                                                step="0.01"
                                                                min="0"
                                                                value={editCompensationForm.landAmount}
                                                                onChange={(e) => handleEditFormChange('landAmount', e.target.value)}
                                                                className="w-full px-2 py-2 border border-gray-300 rounded text-xs focus:ring-1 focus:ring-blue-500 focus:border-transparent font-bold text-blue-600 text-center"
                                                                placeholder="Amount"
                                                                required
                                                                disabled
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <p className="text-xs text-blue-600 font-medium">
                                                    {/* 💡 {translations[language]?.autoCalculatedAmount} */}
                                                </p>
                                            </div>

                                            {/* Asset Property */}
                                            {/* Tree */}
                                            <div className="space-y-2">

                                                {/* Header with Total */}
                                                <div className="flex items-center justify-between mb-2">
                                                    <label className="block text-sm font-medium text-gray-700">
                                                        Trees <span className="text-red-500">*</span>
                                                    </label>
                                                    <div className="text-xs bg-white px-2 py-1 rounded border border-green-300">
                                                        <span className="font-medium text-green-700">Total: ₹</span>
                                                        <span className="font-bold text-green-600">
                                                            {(currentEditRecord?.treeData || [])
                                                                .reduce((sum, tree) => {
                                                                    const value = tree.tree_amount_lao && tree.tree_amount_lao > 0
                                                                        ? tree.tree_amount_lao
                                                                        : (tree.tree_amount_valuer || 0);

                                                                    return sum + value;
                                                                }, 0)
                                                                .toLocaleString()}
                                                        </span>
                                                    </div>
                                                </div>

                                                <div className="mb-3 p-2 bg-green-50 rounded-lg border border-green-200 max-h-40 overflow-y-auto">
                                                    {currentEditRecord.treeData && currentEditRecord.treeData.length > 0 ? (
                                                        <div>
                                                            {/* Tree List */}
                                                            <div className="space-y-2">
                                                                {currentEditRecord.treeData.map((tree, index) => {
                                                                    const amount =
                                                                        tree.tree_amount_lao !== undefined && tree.tree_amount_lao !== null
                                                                            ? tree.tree_amount_lao
                                                                            : (tree.tree_amount_valuer || 0);

                                                                    const isUpdating = updatingTrees[tree.tree_id];
                                                                    const updateError = treeUpdateErrors[tree.tree_id];

                                                                    return (
                                                                        <div
                                                                            key={tree.tree_id || index}
                                                                            className="bg-white rounded border border-green-200 p-2"
                                                                        >
                                                                            {/* Row */}
                                                                            <div className="flex items-center justify-between">
                                                                                {/* Left Side: Tree Info */}
                                                                                <div className="flex items-center gap-3">
                                                                                    {/* Tree Name */}
                                                                                    <span className="font-medium text-green-800 text-xs w-40">
                                                                                        {tree.tree_type_name}
                                                                                    </span>

                                                                                    {/* Count */}
                                                                                    {/* <label className="text-xs text-gray-500">{translations[language]?.Compositenumber}</label>
                                                                                    <input
                                                                                        type="number"
                                                                                        value={tree.tree_count || 0}
                                                                                        readOnly
                                                                                        className="w-14 px-1 py-1 border border-gray-300 rounded text-xs bg-gray-100 text-center"
                                                                                    /> */}

                                                                                    {/* Value */}
                                                                                    <label className="text-xs text-gray-500">{translations[language]?.Numberofactuals}</label>
                                                                                    <input
                                                                                        type="number"
                                                                                        value={tree.tree_value_valuer || 0}
                                                                                        readOnly
                                                                                        className="w-14 px-1 py-1 border border-gray-300 rounded text-xs bg-gray-100 text-center"
                                                                                    />

                                                                                    {/* Agency */}
                                                                                    <label className="text-xs text-gray-500">{translations[language]?.Paymentdue}</label>
                                                                                    <input
                                                                                        type="number"
                                                                                        value={tree.tree_amount_valuer || 0}
                                                                                        readOnly
                                                                                        className="w-14 px-1 py-1 border border-gray-300 rounded text-xs bg-gray-100 text-center"
                                                                                    />

                                                                                    {/* Right Side: Total */}
                                                                                    <div className="flex items-center gap-2">
                                                                                        <span className="text-xs text-gray-500">{translations[language]?.amount}</span>
                                                                                        <input
                                                                                            type="text"
                                                                                            step="0.01"
                                                                                            min="0"
                                                                                            value={amount}
                                                                                            onChange={(e) => {
                                                                                                const newLAOValue = parseFloat(e.target.value) || 0;
                                                                                                const newTreeData = [...currentEditRecord.treeData];
                                                                                                newTreeData[index] = {
                                                                                                    ...tree,
                                                                                                    tree_amount_lao: newLAOValue,
                                                                                                };
                                                                                                setCurrentEditRecord({
                                                                                                    ...currentEditRecord,
                                                                                                    treeData: newTreeData,
                                                                                                });
                                                                                            }}
                                                                                            disabled={isUpdating}
                                                                                            className="w-20 px-1 py-1 border border-gray-300 rounded text-xs text-center focus:ring-1 focus:ring-yellow-500"
                                                                                        />
                                                                                    </div>
                                                                                </div>

                                                                            </div>

                                                                            {/* Error */}
                                                                            {updateError && (
                                                                                <div className="mt-1 text-xs text-red-600 bg-red-50 px-2 py-1 rounded">
                                                                                    {updateError}
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    );
                                                                })}
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div className="text-center text-sm text-gray-500">
                                                            Tree data not available.
                                                        </div>
                                                    )}
                                                </div>

                                            </div>

                                            {/* Well */}
                                            <div className="space-y-2">

                                                {/* Header with Total */}
                                                <div className="flex items-center justify-between mb-2">
                                                    <label className="block text-sm font-medium text-gray-700">
                                                        Well <span className="text-red-500">*</span>
                                                    </label>
                                                    <div className="text-xs bg-white px-2 py-1 rounded border border-yellow-300">
                                                        <span className="font-medium text-yellow-700">Total: ₹</span>
                                                        <span className="font-bold text-yellow-600">
                                                            {(currentEditRecord?.wellData || [])
                                                                .reduce((sum, well) => {
                                                                    // Prefer LAO, fallback to valuer
                                                                    const amount = well.Property_amount_lao && well.Property_amount_lao > 0
                                                                        ? well.Property_amount_lao
                                                                        : (well.Property_amount_valuer || 0);
                                                                    return sum + amount;
                                                                }, 0)
                                                                .toLocaleString()}
                                                        </span>
                                                    </div>
                                                </div>

                                                <div className="mb-3 p-2 bg-yellow-50 rounded-lg border border-yellow-200 max-h-40 overflow-y-auto">
                                                    {currentEditRecord.wellData && currentEditRecord.wellData.length > 0 ? (
                                                        <div>
                                                            {/* Well List */}
                                                            <div className="space-y-2">
                                                                {currentEditRecord.wellData.map((well, index) => {
                                                                    const amount =
                                                                        well.Property_amount_lao !== undefined && well.Property_amount_lao !== null
                                                                            ? well.Property_amount_lao
                                                                            : (well.Property_amount_valuer || 0);

                                                                    const isUpdating = updatingWell[well.Property_id];
                                                                    const updateError = wellUpdateErrors[well.Property_id];

                                                                    return (
                                                                        <div
                                                                            key={well.Property_id || index}
                                                                            className="bg-white rounded border border-yellow-200 p-2"
                                                                        >
                                                                            {/* Row */}
                                                                            <div className="flex items-center justify-between">
                                                                                {/* Left Side: Well Info */}
                                                                                <div className="flex items-center gap-3">
                                                                                    {/* Well Dimensions */}
                                                                                    <span className="font-medium text-yellow-800 text-xs w-40">
                                                                                        {well.Property_length || 0}(l) × {well.Property_depth || 0}(d)
                                                                                    </span>

                                                                                    {/* Total */}
                                                                                    {/* <label className="text-xs text-gray-500">{translations[language]?.Compositenumber}</label>
                                                                                    <input
                                                                                        type="number"
                                                                                        value={well.total || 0}
                                                                                        readOnly
                                                                                        className="w-14 px-1 py-1 border border-gray-300 rounded text-xs bg-gray-100 text-center"
                                                                                    /> */}

                                                                                    {/* Value */}
                                                                                    <label className="text-xs text-gray-500">{translations[language]?.Numberofactuals}</label>
                                                                                    <input
                                                                                        type="number"
                                                                                        value={well.actual_area || 0}
                                                                                        readOnly
                                                                                        className="w-14 px-1 py-1 border border-gray-300 rounded text-xs bg-gray-100 text-center"
                                                                                    />

                                                                                    {/* Agency */}
                                                                                    <label className="text-xs text-gray-500">{translations[language]?.Paymentdue}</label>
                                                                                    <input
                                                                                        type="number"
                                                                                        value={well.Property_amount_valuer || 0}
                                                                                        readOnly
                                                                                        className="w-14 px-1 py-1 border border-gray-300 rounded text-xs bg-gray-100 text-center"
                                                                                    />

                                                                                    {/* Payment Due */}
                                                                                    <div className="flex items-center gap-2">
                                                                                        <span className="text-xs text-gray-500">{translations[language]?.amount}</span>
                                                                                        <input
                                                                                            type="text"
                                                                                            step="0.01"
                                                                                            min="0"
                                                                                            value={amount}
                                                                                            onChange={(e) => {
                                                                                                const newLAOValue = parseFloat(e.target.value) || 0;
                                                                                                const newWellData = [...currentEditRecord.wellData];
                                                                                                newWellData[index] = {
                                                                                                    ...well,
                                                                                                    Property_amount_lao: newLAOValue,
                                                                                                };
                                                                                                setCurrentEditRecord({
                                                                                                    ...currentEditRecord,
                                                                                                    wellData: newWellData,
                                                                                                });
                                                                                            }}
                                                                                            disabled={isUpdating}
                                                                                            className="w-20 px-1 py-1 border border-gray-300 rounded text-xs text-center focus:ring-1 focus:ring-yellow-500"
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                            </div>

                                                                            {/* Error */}
                                                                            {updateError && (
                                                                                <div className="mt-1 text-xs text-red-600 bg-red-50 px-2 py-1 rounded">
                                                                                    {updateError}
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    );
                                                                })}
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div className="text-center text-sm text-gray-500">
                                                            Well data not available.
                                                        </div>
                                                    )}
                                                </div>
                                            </div>

                                            {/* BoreWell */}
                                            <div className="space-y-2">

                                                {/* Header with Total */}
                                                <div className="flex items-center justify-between mb-2">
                                                    <label className="block text-sm font-medium text-gray-700">
                                                        BoreWell <span className="text-red-500">*</span>
                                                    </label>
                                                    <div className="text-xs bg-white px-2 py-1 rounded border border-purple-300">
                                                        <span className="font-medium text-purple-700">Total: ₹</span>
                                                        <span className="font-bold text-purple-600">
                                                            {(currentEditRecord?.borewellData || [])
                                                                .reduce((sum, borewell) => {
                                                                    // Prefer LAO, fallback to valuer
                                                                    const amount = borewell.Property_amount_lao && borewell.Property_amount_lao > 0
                                                                        ? borewell.Property_amount_lao
                                                                        : (borewell.Property_amount_valuer || 0);
                                                                    return sum + amount;
                                                                }, 0)
                                                                .toLocaleString()}
                                                        </span>
                                                    </div>
                                                </div>

                                                <div className="mb-3 p-2 bg-purple-50 rounded-lg border border-purple-200 max-h-40 overflow-y-auto">
                                                    {currentEditRecord.borewellData && currentEditRecord.borewellData.length > 0 ? (
                                                        <div>
                                                            {/* BoreWell List */}
                                                            <div className="space-y-2">
                                                                {currentEditRecord.borewellData.map((borewell, index) => {
                                                                    const amount =
                                                                        borewell.Property_amount_lao !== undefined && borewell.Property_amount_lao !== null
                                                                            ? borewell.Property_amount_lao
                                                                            : (borewell.Property_amount_valuer || 0);

                                                                    const isUpdating = updatingBoreWell[borewell.Property_id];
                                                                    const updateError = boreWellUpdateErrors[borewell.Property_id];

                                                                    return (
                                                                        <div
                                                                            key={borewell.Property_id || index}
                                                                            className="bg-white rounded border border-purple-200 p-2"
                                                                        >
                                                                            {/* Row */}
                                                                            <div className="flex items-center justify-between">
                                                                                {/* Left Side: BoreWell Info */}
                                                                                <div className="flex items-center gap-3">
                                                                                    {/* Borewell Dimensions */}
                                                                                    <span className="font-medium text-purple-800 text-xs w-40">
                                                                                        {borewell.Property_depth || 0}(d)
                                                                                    </span>

                                                                                    {/* Total */}
                                                                                    {/* <label className="text-xs text-gray-500">{translations[language]?.Compositenumber}</label>
                                                                                    <input
                                                                                        type="number"
                                                                                        value={borewell.total || 0}
                                                                                        readOnly
                                                                                        className="w-14 px-1 py-1 border border-gray-300 rounded text-xs bg-gray-100 text-center"
                                                                                    /> */}

                                                                                    {/* Value */}
                                                                                    <label className="text-xs text-gray-500">{translations[language]?.Numberofactuals}</label>
                                                                                    <input
                                                                                        type="number"
                                                                                        value={borewell.actual_area}
                                                                                        readOnly
                                                                                        className="w-14 px-1 py-1 border border-gray-300 rounded text-xs bg-gray-100 text-center"
                                                                                    />

                                                                                    {/* Agency */}
                                                                                    <label className="text-xs text-gray-500">{translations[language]?.Paymentdue}</label>
                                                                                    <input
                                                                                        type="number"
                                                                                        value={borewell.Property_amount_valuer || 0}
                                                                                        readOnly
                                                                                        className="w-14 px-1 py-1 border border-gray-300 rounded text-xs bg-gray-100 text-center"
                                                                                    />

                                                                                    {/* Payment Due */}
                                                                                    <div className="flex items-center gap-2">
                                                                                        <span className="text-xs text-gray-500">{translations[language]?.amount}</span>
                                                                                        <input
                                                                                            type="text"
                                                                                            step="0.01"
                                                                                            min="0"
                                                                                            value={amount}
                                                                                            onChange={(e) => {
                                                                                                const newLAOValue = parseFloat(e.target.value) || 0;
                                                                                                const newBorewellData = [...currentEditRecord.borewellData];
                                                                                                newBorewellData[index] = {
                                                                                                    ...borewell,
                                                                                                    Property_amount_lao: newLAOValue,
                                                                                                };
                                                                                                setCurrentEditRecord({
                                                                                                    ...currentEditRecord,
                                                                                                    borewellData: newBorewellData,
                                                                                                });
                                                                                            }}
                                                                                            disabled={isUpdating}
                                                                                            className="w-20 px-1 py-1 border border-gray-300 rounded text-xs text-center focus:ring-1 focus:ring-purple-500"
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                            </div>

                                                                            {/* Error */}
                                                                            {updateError && (
                                                                                <div className="mt-1 text-xs text-red-600 bg-red-50 px-2 py-1 rounded">
                                                                                    {updateError}
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    );
                                                                })}
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div className="text-center text-sm text-gray-500">
                                                            Borewell data not available.
                                                        </div>
                                                    )}
                                                </div>
                                            </div>

                                            {/* Pipeline */}
                                            <div className="space-y-2">
                                                {/* Header with Total */}
                                                <div className="flex items-center justify-between mb-2">
                                                    <label className="block text-sm font-medium text-gray-700">
                                                        Pipeline <span className="text-red-500">*</span>
                                                    </label>
                                                    <div className="text-xs bg-white px-2 py-1 rounded border border-red-300">
                                                        <span className="font-medium text-red-700">Total: ₹</span>
                                                        <span className="font-bold text-red-600">
                                                            {(currentEditRecord?.pipelineData || [])
                                                                .reduce((sum, pipeline) => {
                                                                    // Prefer LAO, fallback to valuer
                                                                    const amount =
                                                                        pipeline.Property_amount_lao && pipeline.Property_amount_lao > 0
                                                                            ? pipeline.Property_amount_lao
                                                                            : (pipeline.Property_amount_valuer || 0);
                                                                    return sum + amount;
                                                                }, 0)
                                                                .toLocaleString()}
                                                        </span>
                                                    </div>
                                                </div>

                                                <div className="mb-3 p-2 bg-red-50 rounded-lg border border-red-200 max-h-40 overflow-y-auto">
                                                    {currentEditRecord.pipelineData && currentEditRecord.pipelineData.length > 0 ? (
                                                        <div>
                                                            {/* Pipeline List */}
                                                            <div className="space-y-2">
                                                                {currentEditRecord.pipelineData.map((pipeline, index) => {
                                                                    const amount =
                                                                        pipeline.Property_amount_lao !== undefined && pipeline.Property_amount_lao !== null
                                                                            ? pipeline.Property_amount_lao
                                                                            : (pipeline.Property_amount_valuer || 0);

                                                                    const isUpdating = updatingPipeline[pipeline.Property_id];
                                                                    const updateError = pipelineUpdateErrors[pipeline.Property_id];

                                                                    return (
                                                                        <div
                                                                            key={pipeline.Property_id || index}
                                                                            className="bg-white rounded border border-red-200 p-2"
                                                                        >
                                                                            {/* Row */}
                                                                            <div className="flex items-center justify-between">
                                                                                {/* Left Side: Pipeline Info */}
                                                                                <div className="flex items-center gap-3">
                                                                                    {/* Pipeline Length */}
                                                                                    <span className="font-medium text-red-800 text-xs w-40">
                                                                                        {pipeline.Property_length || 0}(l)
                                                                                    </span>

                                                                                    {/* Composite Number */}
                                                                                    {/* <label className="text-xs text-gray-500">
                                                                                        {translations[language]?.Compositenumber}
                                                                                    </label>
                                                                                    <input
                                                                                        type="number"
                                                                                        value={pipeline.total || 0}
                                                                                        readOnly
                                                                                        className="w-14 px-1 py-1 border border-gray-300 rounded text-xs bg-gray-100 text-center"
                                                                                    /> */}

                                                                                    {/* Value (Valuer) */}
                                                                                    <label className="text-xs text-gray-500">
                                                                                        {translations[language]?.Numberofactuals}
                                                                                    </label>
                                                                                    <input
                                                                                        type="number"
                                                                                        value={pipeline.actual_area}
                                                                                        readOnly
                                                                                        className="w-14 px-1 py-1 border border-gray-300 rounded text-xs bg-gray-100 text-center"
                                                                                    />

                                                                                    {/* Agency */}
                                                                                    <label className="text-xs text-gray-500">{translations[language]?.Paymentdue}</label>
                                                                                    <input
                                                                                        type="number"
                                                                                        value={pipeline.Property_amount_valuer || 0}
                                                                                        readOnly
                                                                                        className="w-14 px-1 py-1 border border-gray-300 rounded text-xs bg-gray-100 text-center"
                                                                                    />

                                                                                    {/* Payment Due (Editable LAO Amount) */}
                                                                                    <div className="flex items-center gap-2">
                                                                                        <span className="text-xs text-gray-500">
                                                                                            {translations[language]?.amount}
                                                                                        </span>
                                                                                        <input
                                                                                            type="text"
                                                                                            step="0.01"
                                                                                            min="0"
                                                                                            value={amount}
                                                                                            onChange={(e) => {
                                                                                                const newLAOValue = parseFloat(e.target.value) || 0;
                                                                                                const newPipelineData = [...currentEditRecord.pipelineData];
                                                                                                newPipelineData[index] = {
                                                                                                    ...pipeline,
                                                                                                    Property_amount_lao: newLAOValue,
                                                                                                };
                                                                                                setCurrentEditRecord({
                                                                                                    ...currentEditRecord,
                                                                                                    pipelineData: newPipelineData,
                                                                                                });
                                                                                            }}
                                                                                            disabled={isUpdating}
                                                                                            className="w-20 px-1 py-1 border border-gray-300 rounded text-xs text-center focus:ring-1 focus:ring-red-500"
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                            </div>

                                                                            {/* Error */}
                                                                            {updateError && (
                                                                                <div className="mt-1 text-xs text-red-600 bg-red-50 px-2 py-1 rounded">
                                                                                    {updateError}
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    );
                                                                })}
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div className="text-center text-sm text-gray-500">
                                                            Pipeline data not available.
                                                        </div>
                                                    )}
                                                </div>
                                            </div>

                                            {/* Home */}
                                            <div className="space-y-2">
                                                {/* Header with Total */}
                                                <div className="flex items-center justify-between mb-2">
                                                    <label className="block text-sm font-medium text-gray-700">
                                                        Homes <span className="text-red-500">*</span>
                                                    </label>
                                                    <div className="text-xs bg-white px-2 py-1 rounded border border-pink-300">
                                                        <span className="font-medium text-pink-700">Total: ₹</span>
                                                        <span className="font-bold text-pink-600">
                                                            {(currentEditRecord?.homeData || [])
                                                                .reduce((sum, home) => {
                                                                    const amount =
                                                                        home.Property_amount_lao && home.Property_amount_lao > 0
                                                                            ? home.Property_amount_lao
                                                                            : (home.Property_amount_valuer || 0);
                                                                    return sum + amount;
                                                                }, 0)
                                                                .toLocaleString()}
                                                        </span>
                                                    </div>
                                                </div>

                                                <div className="mb-3 p-2 bg-green-50 rounded-lg border border-green-200 max-h-40 overflow-y-auto">
                                                    {currentEditRecord.homeData && currentEditRecord.homeData.length > 0 ? (
                                                        <div>
                                                            {/* Home List */}
                                                            <div className="space-y-2">
                                                                {currentEditRecord.homeData.map((home, index) => {
                                                                    const amount =
                                                                        home.Property_amount_lao !== undefined && home.Property_amount_lao !== null
                                                                            ? home.Property_amount_lao
                                                                            : (home.Property_amount_valuer || 0);

                                                                    const isUpdating = updatingHomes[home.Property_id];
                                                                    const updateError = homeUpdateErrors[home.Property_id];

                                                                    return (
                                                                        <div
                                                                            key={home.Property_id || index}
                                                                            className="bg-white rounded border border-pink-200 p-2"
                                                                        >
                                                                            {/* Row */}
                                                                            <div className="flex items-center justify-between">
                                                                                {/* Left Side: Home Info */}
                                                                                <div className="flex items-center gap-3">
                                                                                    {/* Home Floor */}
                                                                                    <span className="font-medium text-pink-800 text-xs w-45">
                                                                                        Floor : {home.house_floor_no}[{home.Property_width || 0}(w) × {home.Property_length || 0}(l)]
                                                                                    </span>

                                                                                    {/* Total */}
                                                                                    {/* <label className="text-xs text-gray-500">{translations[language]?.Compositenumber}</label>
                                                                                    <input
                                                                                        type="number"
                                                                                        value={home.total || 0}
                                                                                        readOnly
                                                                                        className="w-14 px-1 py-1 border border-gray-300 rounded text-xs bg-gray-100 text-center"
                                                                                    /> */}

                                                                                    {/* Value */}
                                                                                    <label className="text-xs text-gray-500">{translations[language]?.Numberofactuals}</label>
                                                                                    <input
                                                                                        type="number"
                                                                                        value={home.actual_area}
                                                                                        readOnly
                                                                                        className="w-14 px-1 py-1 border border-gray-300 rounded text-xs bg-gray-100 text-center"
                                                                                    />

                                                                                    {/* Agency */}
                                                                                    <label className="text-xs text-gray-500">{translations[language]?.Paymentdue}</label>
                                                                                    <input
                                                                                        type="number"
                                                                                        value={home.Property_amount_valuer || 0}
                                                                                        readOnly
                                                                                        className="w-14 px-1 py-1 border border-gray-300 rounded text-xs bg-gray-100 text-center"
                                                                                    />

                                                                                    {/* Payment Due (Editable) */}
                                                                                    <div className="flex items-center gap-2">
                                                                                        <span className="text-xs text-gray-500">
                                                                                            {translations[language]?.amount}
                                                                                        </span>
                                                                                        <input
                                                                                            type="text"
                                                                                            step="0.01"
                                                                                            min="0"
                                                                                            value={amount}
                                                                                            onChange={(e) => {
                                                                                                const newLAOValue = parseFloat(e.target.value) || 0;
                                                                                                const newHomeData = [...currentEditRecord.homeData];
                                                                                                newHomeData[index] = {
                                                                                                    ...home,
                                                                                                    Property_amount_lao: newLAOValue,
                                                                                                };
                                                                                                setCurrentEditRecord({
                                                                                                    ...currentEditRecord,
                                                                                                    homeData: newHomeData,
                                                                                                });
                                                                                            }}
                                                                                            disabled={isUpdating}
                                                                                            className="w-20 px-1 py-1 border border-gray-300 rounded text-xs text-center focus:ring-1 focus:ring-pink-500"
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                            </div>

                                                                            {/* Error */}
                                                                            {updateError && (
                                                                                <div className="mt-1 text-xs text-red-600 bg-red-50 px-2 py-1 rounded">
                                                                                    {updateError}
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    );
                                                                })}
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div className="text-center text-sm text-gray-500">
                                                            Home data not available.
                                                        </div>
                                                    )}
                                                </div>
                                            </div>

                                            {/* Tinshed */}
                                            <div className="space-y-2">
                                                {/* Header with Total */}
                                                <div className="flex items-center justify-between mb-2">
                                                    <label className="block text-sm font-medium text-gray-700">
                                                        Tinshed <span className="text-red-500">*</span>
                                                    </label>
                                                    <div className="text-xs bg-white px-2 py-1 rounded border border-cyan-300">
                                                        <span className="font-medium text-cyan-700">Total: ₹</span>
                                                        <span className="font-bold text-cyan-600">
                                                            {(currentEditRecord?.tinshedData || [])
                                                                .reduce((sum, tinshed) => {
                                                                    const amount =
                                                                        tinshed.Property_amount_lao && tinshed.Property_amount_lao > 0
                                                                            ? tinshed.Property_amount_lao
                                                                            : (tinshed.Property_amount_valuer || 0);
                                                                    return sum + amount;
                                                                }, 0)
                                                                .toLocaleString()}
                                                        </span>
                                                    </div>
                                                </div>

                                                <div className="mb-3 p-2 bg-cyan-50 rounded-lg border border-cyan-200 max-h-40 overflow-y-auto">
                                                    {currentEditRecord.tinshedData && currentEditRecord.tinshedData.length > 0 ? (
                                                        <div>
                                                            {/* Tinshed List */}
                                                            <div className="space-y-2">
                                                                {currentEditRecord.tinshedData.map((tinshed, index) => {
                                                                    const amount =
                                                                        tinshed.Property_amount_lao !== undefined && tinshed.Property_amount_lao !== null
                                                                            ? tinshed.Property_amount_lao
                                                                            : (tinshed.Property_amount_valuer || 0);

                                                                    const isUpdating = updatingTinshed[tinshed.Property_id];
                                                                    const updateError = TinshedUpdateErrors[tinshed.Property_id];

                                                                    return (
                                                                        <div
                                                                            key={tinshed.Property_id || index}
                                                                            className="bg-white rounded border border-cyan-200 p-2"
                                                                        >
                                                                            {/* Row */}
                                                                            <div className="flex items-center justify-between">
                                                                                {/* Left Side: Tinshed Info */}
                                                                                <div className="flex items-center gap-3">
                                                                                    {/* Size */}
                                                                                    <span className="font-medium text-cyan-800 text-xs w-40">
                                                                                        {tinshed.Property_width || 0}(w) × {tinshed.Property_length || 0}(l)
                                                                                    </span>

                                                                                    {/* Total */}
                                                                                    {/* <label className="text-xs text-gray-500">{translations[language]?.Compositenumber}</label>
                                                                                    <input
                                                                                        type="number"
                                                                                        value={tinshed.total || 0}
                                                                                        readOnly
                                                                                        className="w-14 px-1 py-1 border border-gray-300 rounded text-xs bg-gray-100 text-center"
                                                                                    /> */}

                                                                                    {/* Value */}
                                                                                    <label className="text-xs text-gray-500">{translations[language]?.Numberofactuals}</label>
                                                                                    <input
                                                                                        type="number"
                                                                                        value={tinshed.actual_area}
                                                                                        readOnly
                                                                                        className="w-14 px-1 py-1 border border-gray-300 rounded text-xs bg-gray-100 text-center"
                                                                                    />

                                                                                    {/* Agency */}
                                                                                    <label className="text-xs text-gray-500">{translations[language]?.Paymentdue}</label>
                                                                                    <input
                                                                                        type="number"
                                                                                        value={tinshed.Property_amount_valuer || 0}
                                                                                        readOnly
                                                                                        className="w-14 px-1 py-1 border border-gray-300 rounded text-xs bg-gray-100 text-center"
                                                                                    />

                                                                                    {/* Payment Due (Editable) */}
                                                                                    <div className="flex items-center gap-2">
                                                                                        <span className="text-xs text-gray-500">
                                                                                            {translations[language]?.amount}
                                                                                        </span>
                                                                                        <input
                                                                                            type="text"
                                                                                            step="0.01"
                                                                                            min="0"
                                                                                            value={amount}
                                                                                            onChange={(e) => {
                                                                                                const newLAOValue = parseFloat(e.target.value) || 0;
                                                                                                const newTinshedData = [...currentEditRecord.tinshedData];
                                                                                                newTinshedData[index] = {
                                                                                                    ...tinshed,
                                                                                                    Property_amount_lao: newLAOValue,
                                                                                                };
                                                                                                setCurrentEditRecord({
                                                                                                    ...currentEditRecord,
                                                                                                    tinshedData: newTinshedData,
                                                                                                });
                                                                                            }}
                                                                                            disabled={isUpdating}
                                                                                            className="w-20 px-1 py-1 border border-gray-300 rounded text-xs text-center focus:ring-1 focus:ring-cyan-500"
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                            </div>

                                                                            {/* Error */}
                                                                            {updateError && (
                                                                                <div className="mt-1 text-xs text-red-600 bg-red-50 px-2 py-1 rounded">
                                                                                    {updateError}
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    );
                                                                })}
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div className="text-center text-sm text-gray-500">
                                                            Tinshed data not available.
                                                        </div>
                                                    )}
                                                </div>
                                            </div>

                                            {/* WireFencing */}
                                            <div className="space-y-2">
                                                {/* Header with Total */}
                                                <div className="flex items-center justify-between mb-2">
                                                    <label className="block text-sm font-medium text-gray-700">
                                                        WireFencing <span className="text-red-500">*</span>
                                                    </label>
                                                    <div className="text-xs bg-white px-2 py-1 rounded border border-orange-300">
                                                        <span className="font-medium text-orange-700">Total: ₹</span>
                                                        <span className="font-bold text-orange-600">
                                                            {(currentEditRecord?.wireFencingData || [])
                                                                .reduce((sum, wireFencing) => {
                                                                    const amount =
                                                                        wireFencing.Property_amount_lao && wireFencing.Property_amount_lao > 0
                                                                            ? wireFencing.Property_amount_lao
                                                                            : (wireFencing.Property_amount_valuer || 0);
                                                                    return sum + amount;
                                                                }, 0)
                                                                .toLocaleString()}
                                                        </span>
                                                    </div>
                                                </div>

                                                <div className="mb-3 p-2 bg-orange-50 rounded-lg border border-orange-200 max-h-40 overflow-y-auto">
                                                    {currentEditRecord.wireFencingData && currentEditRecord.wireFencingData.length > 0 ? (
                                                        <div>
                                                            {/* WireFencing List */}
                                                            <div className="space-y-2">
                                                                {currentEditRecord.wireFencingData.map((wireFencing, index) => {
                                                                    const amount =
                                                                        wireFencing.Property_amount_lao !== undefined && wireFencing.Property_amount_lao !== null
                                                                            ? wireFencing.Property_amount_lao
                                                                            : (wireFencing.Property_amount_valuer || 0);

                                                                    const isUpdating = updatingWirefencing[wireFencing.Property_id];
                                                                    const updateError = wirefencingUpdateErrors[wireFencing.Property_id];

                                                                    return (
                                                                        <div
                                                                            key={wireFencing.Property_id || index}
                                                                            className="bg-white rounded border border-orange-200 p-2"
                                                                        >
                                                                            {/* Row */}
                                                                            <div className="flex items-center justify-between">
                                                                                {/* Left Side: WireFencing Info */}
                                                                                <div className="flex items-center gap-3">
                                                                                    <span className="font-medium text-orange-800 text-xs w-40">
                                                                                        {wireFencing.Property_length}(l)
                                                                                    </span>

                                                                                    {/* Total */}
                                                                                    {/* <label className="text-xs text-gray-500">{translations[language]?.Compositenumber}</label>
                                                                                    <input
                                                                                        type="number"
                                                                                        value={wireFencing.total || 0}
                                                                                        readOnly
                                                                                        className="w-14 px-1 py-1 border border-gray-300 rounded text-xs bg-gray-100 text-center"
                                                                                    /> */}

                                                                                    {/* Value */}
                                                                                    <label className="text-xs text-gray-500">{translations[language]?.Numberofactuals}</label>
                                                                                    <input
                                                                                        type="number"
                                                                                        value={wireFencing.actual_area}
                                                                                        readOnly
                                                                                        className="w-14 px-1 py-1 border border-gray-300 rounded text-xs bg-gray-100 text-center"
                                                                                    />

                                                                                    {/* Agency */}
                                                                                    <label className="text-xs text-gray-500">{translations[language]?.Paymentdue}</label>
                                                                                    <input
                                                                                        type="number"
                                                                                        value={wireFencing.Property_amount_valuer || 0}
                                                                                        readOnly
                                                                                        className="w-14 px-1 py-1 border border-gray-300 rounded text-xs bg-gray-100 text-center"
                                                                                    />

                                                                                    {/* Payment Due (Editable) */}
                                                                                    <div className="flex items-center gap-2">
                                                                                        <span className="text-xs text-gray-500">
                                                                                            {translations[language]?.amount}
                                                                                        </span>
                                                                                        <input
                                                                                            type="text"
                                                                                            step="0.01"
                                                                                            min="0"
                                                                                            value={amount}
                                                                                            onChange={(e) => {
                                                                                                const newLAOValue = parseFloat(e.target.value) || 0;
                                                                                                const newWireFencingData = [...currentEditRecord.wireFencingData];
                                                                                                newWireFencingData[index] = {
                                                                                                    ...wireFencing,
                                                                                                    Property_amount_lao: newLAOValue,
                                                                                                };
                                                                                                setCurrentEditRecord({
                                                                                                    ...currentEditRecord,
                                                                                                    wireFencingData: newWireFencingData,
                                                                                                });
                                                                                            }}
                                                                                            disabled={isUpdating}
                                                                                            className="w-20 px-1 py-1 border border-gray-300 rounded text-xs text-center focus:ring-1 focus:ring-orange-500"
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                            </div>

                                                                            {/* Error */}
                                                                            {updateError && (
                                                                                <div className="mt-1 text-xs text-red-600 bg-red-50 px-2 py-1 rounded">
                                                                                    {updateError}
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    );
                                                                })}
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div className="text-center text-sm text-gray-500">
                                                            WireFencing data not available.
                                                        </div>
                                                    )}
                                                </div>
                                            </div>

                                            {/* Farm-Pond */}
                                            <div className="space-y-2">
                                                {/* Header with Total */}
                                                <div className="flex items-center justify-between mb-2">
                                                    <label className="block text-sm font-medium text-gray-700">
                                                        Farm-Pond <span className="text-red-500">*</span>
                                                    </label>
                                                    <div className="text-xs bg-white px-2 py-1 rounded border border-blue-300">
                                                        <span className="font-medium text-blue-700">Total: ₹</span>
                                                        <span className="font-bold text-blue-600">
                                                            {(currentEditRecord?.farmpondData || [])
                                                                .reduce((sum, farmPond) => {
                                                                    const amount =
                                                                        farmPond.Property_amount_lao && farmPond.Property_amount_lao > 0
                                                                            ? farmPond.Property_amount_lao
                                                                            : (farmPond.Property_amount_valuer || 0);
                                                                    return sum + amount;
                                                                }, 0)
                                                                .toLocaleString()}
                                                        </span>
                                                    </div>
                                                </div>

                                                <div className="mb-3 p-2 bg-blue-50 rounded-lg border border-blue-200 max-h-40 overflow-y-auto">
                                                    {currentEditRecord.farmpondData && currentEditRecord.farmpondData.length > 0 ? (
                                                        <div>
                                                            {/* Farm-Pond List */}
                                                            <div className="space-y-2">
                                                                {currentEditRecord.farmpondData.map((farmPond, index) => {
                                                                    const amount =
                                                                        farmPond.Property_amount_lao !== undefined && farmPond.Property_amount_lao !== null
                                                                            ? farmPond.Property_amount_lao
                                                                            : (farmPond.Property_amount_valuer || 0);

                                                                    const isUpdating = updatingFarmpond[farmPond.Property_id];
                                                                    const updateError = farmpondUpdateErrors[farmPond.Property_id];

                                                                    return (
                                                                        <div
                                                                            key={farmPond.Property_id || index}
                                                                            className="bg-white rounded border border-blue-200 p-2"
                                                                        >
                                                                            {/* Row */}
                                                                            <div className="flex items-center justify-between">
                                                                                {/* Left Side: Farm-Pond Info */}
                                                                                <div className="flex items-center gap-3">
                                                                                    <span className="font-medium text-blue-800 text-xs w-40">
                                                                                        {farmPond.Property_width || 0}(w) × {farmPond.Property_length || 0}(l) × {farmPond.Property_depth || 0}(d)
                                                                                    </span>

                                                                                    {/* Total */}
                                                                                    {/* <label className="text-xs text-gray-500">{translations[language]?.Compositenumber}</label>
                                                                                    <input
                                                                                        type="number"
                                                                                        value={farmPond.total || 0}
                                                                                        readOnly
                                                                                        className="w-14 px-1 py-1 border border-gray-300 rounded text-xs bg-gray-100 text-center"
                                                                                    /> */}

                                                                                    {/* Value */}
                                                                                    <label className="text-xs text-gray-500">{translations[language]?.Numberofactuals}</label>
                                                                                    <input
                                                                                        type="number"
                                                                                        value={farmPond.actual_area}
                                                                                        readOnly
                                                                                        className="w-14 px-1 py-1 border border-gray-300 rounded text-xs bg-gray-100 text-center"
                                                                                    />

                                                                                    {/* Agency */}
                                                                                    <label className="text-xs text-gray-500">{translations[language]?.Paymentdue}</label>
                                                                                    <input
                                                                                        type="number"
                                                                                        value={farmPond.Property_amount_valuer || 0}
                                                                                        readOnly
                                                                                        className="w-14 px-1 py-1 border border-gray-300 rounded text-xs bg-gray-100 text-center"
                                                                                    />

                                                                                    {/* Payment Due (Editable) */}
                                                                                    <div className="flex items-center gap-2">
                                                                                        <span className="text-xs text-gray-500">
                                                                                            {translations[language]?.amount}
                                                                                        </span>
                                                                                        <input
                                                                                            type="text"
                                                                                            step="0.01"
                                                                                            min="0"
                                                                                            value={amount}
                                                                                            onChange={(e) => {
                                                                                                const newLAOValue = parseFloat(e.target.value) || 0;
                                                                                                const newFarmPondData = [...currentEditRecord.farmpondData];
                                                                                                newFarmPondData[index] = {
                                                                                                    ...farmPond,
                                                                                                    Property_amount_lao: newLAOValue,
                                                                                                };
                                                                                                setCurrentEditRecord({
                                                                                                    ...currentEditRecord,
                                                                                                    farmpondData: newFarmPondData,
                                                                                                });
                                                                                            }}
                                                                                            disabled={isUpdating}
                                                                                            className="w-20 px-1 py-1 border border-gray-300 rounded text-xs text-center focus:ring-1 focus:ring-blue-500"
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                            </div>

                                                                            {/* Error */}
                                                                            {updateError && (
                                                                                <div className="mt-1 text-xs text-red-600 bg-red-50 px-2 py-1 rounded">
                                                                                    {updateError}
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    );
                                                                })}
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div className="text-center text-sm text-gray-500">
                                                            Farm-Pond data not available.
                                                        </div>
                                                    )}
                                                </div>
                                            </div>

                                            {/* Other */}
                                            <div className="space-y-2">
                                                {/* Header with Total */}
                                                <div className="flex items-center justify-between mb-2">
                                                    <label className="block text-sm font-medium text-gray-700">
                                                        Others <span className="text-red-500">*</span>
                                                    </label>
                                                    <div className="text-xs bg-white px-2 py-1 rounded border border-emerald-300">
                                                        <span className="font-medium text-emerald-700">Total: ₹</span>
                                                        <span className="font-bold text-emerald-600">
                                                            {(currentEditRecord?.otherData || [])
                                                                .reduce((sum, other) => {
                                                                    const amount =
                                                                        other.Property_amount_lao && other.Property_amount_lao > 0
                                                                            ? other.Property_amount_lao
                                                                            : (other.Property_amount_valuer || 0);
                                                                    return sum + amount;
                                                                }, 0)
                                                                .toLocaleString()}
                                                        </span>
                                                    </div>
                                                </div>

                                                <div className="mb-3 p-2 bg-emerald-50 rounded-lg border border-emerald-200 max-h-40 overflow-y-auto">
                                                    {currentEditRecord.otherData && currentEditRecord.otherData.length > 0 ? (
                                                        <div>
                                                            {/* Other List */}
                                                            <div className="space-y-2">
                                                                {currentEditRecord.otherData.map((other, index) => {
                                                                    const amount =
                                                                        other.Property_amount_lao !== undefined && other.Property_amount_lao !== null
                                                                            ? other.Property_amount_lao
                                                                            : (other.Property_amount_valuer || 0);

                                                                    const isUpdating = updatingOther[other.Property_id];
                                                                    const updateError = otherUpdateErrors[other.Property_id];

                                                                    return (
                                                                        <div
                                                                            key={other.Property_id || index}
                                                                            className="bg-white rounded border border-emerald-200 p-2"
                                                                        >
                                                                            {/* Row */}
                                                                            <div className="flex items-center justify-between">
                                                                                {/* Left Side: Other Info */}
                                                                                <div className="flex items-center gap-3">
                                                                                    <span className="font-medium text-emerald-800 text-xs w-40">
                                                                                        {other.construction_type} : {other.Property_count || 0}
                                                                                    </span>

                                                                                    {/* Total */}
                                                                                    {/* <label className="text-xs text-gray-500">{translations[language]?.Compositenumber}</label>
                                                                                    <input
                                                                                        type="number"
                                                                                        value={other.Property_count || 0}
                                                                                        readOnly
                                                                                        className="w-14 px-1 py-1 border border-gray-300 rounded text-xs bg-gray-100 text-center"
                                                                                    /> */}

                                                                                    {/* Value */}
                                                                                    <label className="text-xs text-gray-500">{translations[language]?.Numberofactuals}</label>
                                                                                    <input
                                                                                        type="number"
                                                                                        value={other.actual_area}
                                                                                        readOnly
                                                                                        className="w-14 px-1 py-1 border border-gray-300 rounded text-xs bg-gray-100 text-center"
                                                                                    />

                                                                                    {/* Agency */}
                                                                                    <label className="text-xs text-gray-500">{translations[language]?.Paymentdue}</label>
                                                                                    <input
                                                                                        type="number"
                                                                                        value={other.Property_amount_valuer || 0}
                                                                                        readOnly
                                                                                        className="w-14 px-1 py-1 border border-gray-300 rounded text-xs bg-gray-100 text-center"
                                                                                    />

                                                                                    {/* Payment Due (Editable) */}
                                                                                    <div className="flex items-center gap-2">
                                                                                        <span className="text-xs text-gray-500">
                                                                                            {translations[language]?.amount}
                                                                                        </span>
                                                                                        <input
                                                                                            type="text`"
                                                                                            step="0.01"
                                                                                            min="0"
                                                                                            value={amount}
                                                                                            onChange={(e) => {
                                                                                                const newLAOValue = parseFloat(e.target.value) || 0;
                                                                                                const newOtherData = [...currentEditRecord.otherData];
                                                                                                newOtherData[index] = {
                                                                                                    ...other,
                                                                                                    Property_amount_lao: newLAOValue,
                                                                                                };
                                                                                                setCurrentEditRecord({
                                                                                                    ...currentEditRecord,
                                                                                                    otherData: newOtherData,
                                                                                                });
                                                                                            }}
                                                                                            disabled={isUpdating}
                                                                                            className="w-20 px-1 py-1 border border-gray-300 rounded text-xs text-center focus:ring-1 focus:ring-blue-500"
                                                                                        />
                                                                                    </div>

                                                                                </div>
                                                                            </div>

                                                                            {/* Error */}
                                                                            {updateError && (
                                                                                <div className="mt-1 text-xs text-red-600 bg-red-50 px-2 py-1 rounded">
                                                                                    {updateError}
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    );
                                                                })}
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div className="text-center text-sm text-gray-500">
                                                            Other data not available.
                                                        </div>
                                                    )}
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>

                                {/* Advance Payment Section */}
                                <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden">
                                    <div className="bg-gradient-to-r from-yellow-50 to-amber-50 px-4 py-2 border-b border-gray-200">
                                        <div className="flex items-center space-x-2">
                                            <div className="w-6 h-6 bg-yellow-100 rounded-lg flex items-center justify-center">
                                                <Wallet className="w-4 h-4 text-yellow-600" />
                                            </div>
                                            <h3 className="text-base font-bold text-yellow-900">आगाऊ भरपाई</h3>
                                        </div>
                                    </div>

                                    <div className="p-3">
                                        <div className="grid grid-cols-1 md:grid-cols-3 gap-2">
                                            {/* Amount */}
                                            <div>
                                                <label className="block text-xs font-medium text-gray-700 mb-1">
                                                    {translations[language]?.amount}<span className="text-red-500">*</span>
                                                </label>
                                                <input
                                                    type="number"
                                                    step="0.01"
                                                    min="0"
                                                    value={editCompensationForm.advanceAmount}
                                                    onChange={(e) => handleEditFormChange('advanceAmount', e.target.value)}
                                                    className="w-full px-2 py-2 border border-gray-300 rounded text-xs focus:ring-1 focus:ring-yellow-500 focus:border-transparent bg-gray-50 font-medium"
                                                    placeholder="Enter advance amount"
                                                />
                                            </div>

                                            {/* Date */}
                                            <div>
                                                <label className="block text-xs font-medium text-gray-700 mb-1">
                                                    {translations[language]?.Date}<span className="text-red-500">*</span>
                                                </label>
                                                <input
                                                    type="date"
                                                    value={editCompensationForm.advanceDate ? editCompensationForm.advanceDate.split("T")[0] : ""}
                                                    onChange={(e) => handleEditFormChange('advanceDate', e.target.value)}
                                                    className="w-full px-2 py-2 border border-gray-300 rounded text-xs focus:ring-1 focus:ring-yellow-500 focus:border-transparent bg-gray-50 font-medium"
                                                />
                                            </div>

                                            {/* शासकीय वसुली */}
                                            <div>
                                                <label className="block text-xs font-medium text-gray-700 mb-1">
                                                    शासकीय वसुली<span className="text-red-500">*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    value={editCompensationForm.govtRecovery}
                                                    onChange={(e) => handleEditFormChange('govtRecovery', e.target.value)}
                                                    className="w-full px-2 py-2 border border-gray-300 rounded text-xs focus:ring-1 focus:ring-yellow-500 focus:border-transparent bg-gray-50 font-medium"
                                                    placeholder="Enter govt recovery"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Interest Calculation Section with Date Range */}
                                <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden">
                                    <div className="bg-gradient-to-r from-orange-50 to-amber-50 px-4 py-2 border-b border-gray-200">
                                        <div className="flex items-center space-x-2">
                                            <div className="w-6 h-6 bg-orange-100 rounded-lg flex items-center justify-center">
                                                <span className="text-orange-600 text-xs">📅</span>
                                            </div>
                                            <h3 className="text-base font-bold text-orange-900">{translations[language]?.interestCalculation}</h3>
                                        </div>
                                    </div>

                                    <div className="p-3">
                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                                            {/* Interest Rate */}
                                            <div>
                                                <label className="block text-xs font-medium text-gray-700 mb-1">
                                                    {translations[language]?.interestRate}<span className="text-red-500">*</span>
                                                </label>
                                                <input
                                                    type="number"
                                                    step="0.01"
                                                    min="0"
                                                    max="100"
                                                    value={editCompensationForm.interestRate}
                                                    onChange={(e) => handleEditFormChange('interestRate', e.target.value)}
                                                    className="w-full px-2 py-2 border border-gray-300 rounded text-xs focus:ring-1 focus:ring-orange-500 focus:border-transparent bg-gray-50 font-medium"
                                                />
                                            </div>

                                            {/* Interest Days (Read-only) */}
                                            <div>
                                                <label className="block text-xs font-medium text-gray-700 mb-1">
                                                    {translations[language]?.interestPeriodDays}
                                                </label>
                                                <input
                                                    type="number"
                                                    value={editCompensationForm.interestDays || 0}
                                                    readOnly
                                                    className="w-full px-2 py-2 border border-gray-300 rounded bg-orange-50 font-medium text-orange-700 text-xs"
                                                    placeholder="Auto-calculated"
                                                />
                                                <p className="text-xs text-orange-600 mt-1">
                                                    📊 {translations[language]?.autoInterestCalc}
                                                </p>
                                            </div>

                                            {/* From Date */}
                                            <div>
                                                <label className="block text-xs font-medium text-gray-700 mb-1">
                                                    {translations[language]?.interestFromDate} <span className="text-red-500">*</span>
                                                </label>
                                                <input
                                                    type="date"
                                                    value={editCompensationForm.interestFromDate}
                                                    onChange={(e) => handleEditFormChange('interestFromDate', e.target.value)}
                                                    className="w-full px-2 py-2 border border-gray-300 rounded text-xs focus:ring-1 focus:ring-orange-500 focus:border-transparent bg-gray-50 font-medium"
                                                />
                                            </div>

                                            {/* To Date */}
                                            <div>
                                                <label className="block text-xs font-medium text-gray-700 mb-1">
                                                    {translations[language]?.interestToDate} <span className="text-red-500">*</span>
                                                </label>
                                                <input
                                                    type="date"
                                                    value={editCompensationForm.interestToDate}
                                                    onChange={(e) => handleEditFormChange('interestToDate', e.target.value)}
                                                    className="w-full px-2 py-2 border border-gray-300 rounded text-xs focus:ring-1 focus:ring-orange-500 focus:border-transparent bg-gray-50 font-medium"
                                                />
                                            </div>
                                        </div>

                                        {/* Interest Amount Display */}
                                        <div className="mt-2">
                                            <label className="block text-xs font-medium text-gray-700 mb-1">
                                                {translations[language]?.calculatedInterestAmount} (₹)
                                            </label>
                                            <div className="bg-gradient-to-r from-orange-50 to-amber-50 p-3 rounded-lg border border-orange-200">
                                                <div className="flex items-center justify-between">
                                                    <div>
                                                        <p className="text-base font-bold text-orange-700">
                                                            ₹ {parseFloat(editCompensationForm.interestAmount || 0).toLocaleString()}
                                                        </p>
                                                        <p className="text-xs text-orange-600">
                                                            {editCompensationForm.interestFromDate && editCompensationForm.interestToDate
                                                                ? `${editCompensationForm.interestRate}% per annum for ${editCompensationForm.interestDays} days`
                                                                : 'Please select both dates to calculate interest'
                                                            }
                                                        </p>
                                                        {editCompensationForm.advanceAmount && parseFloat(editCompensationForm.advanceAmount) > 0 && editCompensationForm.advanceDate && (
                                                            <p className="text-xs text-orange-500 mt-1">
                                                                ⚡ Split calculation applied (with advance payment)
                                                            </p>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Calculation Details */}
                                        {editCompensationForm.interestFromDate && editCompensationForm.interestToDate && editCompensationForm.interestDays > 0 && (
                                            <div className="mt-2 p-3 bg-blue-50 rounded-lg border border-blue-200">
                                                <h4 className="text-xs font-medium text-blue-800 mb-1">{translations[language]?.calcDetails}:</h4>
                                                <div className="text-xs text-blue-700 space-y-1">
                                                    {(() => {
                                                        const principal = (
                                                            parseFloat(editCompensationForm.landRateFinalAmount || 0)
                                                        );
                                                        const advanceAmount = parseFloat(editCompensationForm.advanceAmount || 0);
                                                        const advanceDate = editCompensationForm.advanceDate;

                                                        if (advanceAmount > 0 && advanceDate) {
                                                            const remainingAmount = principal - advanceAmount;

                                                            const advanceDateFormatted = advanceDate.split("T")[0]; // "2025-09-19"
                                                            const [year, month, day] = advanceDateFormatted.split("-").map(Number);

                                                            const advanceDt = new Date(year, month - 1, day);
                                                            advanceDt.setDate(advanceDt.getDate() - 1);

                                                            // Format as YYYY-MM-DD in local timezone
                                                            const beforeOneDateAdvanceDate = [
                                                                advanceDt.getFullYear(),
                                                                String(advanceDt.getMonth() + 1).padStart(2, "0"),
                                                                String(advanceDt.getDate()).padStart(2, "0")
                                                            ].join("-");

                                                            const advanceDays = calculateDaysBetweenDates(
                                                                editCompensationForm.interestFromDate,
                                                                beforeOneDateAdvanceDate
                                                            );

                                                            const displayDate = `${day}-${month}-${year}`;

                                                            return (
                                                                <div className="flex flex-wrap gap-4 mt-4">
                                                                    {/* Principal Info */}
                                                                    <div className="flex-1 min-w-[220px] p-3 border-l-4 border-blue-300 bg-blue-50 rounded">
                                                                        <p className="font-medium text-blue-800">🔹 Amount Details</p>
                                                                        <p>• Total Amount: ₹ {principal.toLocaleString()}</p>
                                                                        <p>• Advance Payment: ₹ {advanceAmount.toLocaleString()}</p>
                                                                        <p>• Remaining Amount: ₹ {remainingAmount.toLocaleString()}</p>
                                                                    </div>

                                                                    {/* Full Period Interest */}
                                                                    <div className="flex-1 min-w-[220px] p-3 border-l-4 border-green-300 bg-green-50 rounded">
                                                                        <p className="font-medium text-green-900">🔹 Full Period Interest</p>
                                                                        <p>• Amount: ₹{remainingAmount.toLocaleString()}</p>
                                                                        <p>• Period: {editCompensationForm.interestFromDate} to {editCompensationForm.interestToDate}</p>
                                                                        <p>• Days: {editCompensationForm.interestDays} ({(editCompensationForm.interestDays / 365).toFixed(3)} yrs)</p>
                                                                        <p>• Rate: {editCompensationForm.interestRate}% p.a.</p>
                                                                        <p>• Interest: ₹{editCompensationForm.interestAmount.toLocaleString()}</p>
                                                                    </div>

                                                                    {/* Advance Period Interest */}
                                                                    <div className="flex-1 min-w-[220px] p-3 border-l-4 border-purple-300 bg-purple-50 rounded">
                                                                        <p className="font-medium text-purple-900">🔹 Advance Period Interest</p>
                                                                        <p>• Amount: ₹{advanceAmount.toLocaleString()}</p>
                                                                        <p>• Period:{beforeOneDateAdvanceDate} to {editCompensationForm.interestFromDate} </p>
                                                                        <p>• Days: {advanceDays} ({(advanceDays / 365).toFixed(3)} yrs)</p>
                                                                        <p>• Rate: {editCompensationForm.interestRate}% p.a.</p>
                                                                        <p>• Interest: ₹{editCompensationForm.advanceInterestAmount.toLocaleString()}</p>
                                                                    </div>
                                                                </div>

                                                            );
                                                        } else {
                                                            return (
                                                                <>
                                                                    <p>• Principal Amount: ₹ {principal.toLocaleString()}</p>
                                                                    <p>• {translations[language]?.InterestRate}: {editCompensationForm.interestRate}% {translations[language]?.interestPerAnnum}</p>
                                                                    <p>• {translations[language]?.timeperiod}: {editCompensationForm.interestDays} {translations[language]?.Days} ({(editCompensationForm.interestDays / 365).toFixed(3)} years)</p>
                                                                    <p>• {translations[language]?.from}: {editCompensationForm.interestFromDate} {translations[language]?.to}: {editCompensationForm.interestToDate}</p>
                                                                </>
                                                            );
                                                        }
                                                    })()}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>

                                {/* Calculated Values Preview */}
                                {(editCompensationForm.landAmount || editCompensationForm.landRateFinalAmount) ? (
                                    <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden">
                                        <div className="bg-gradient-to-r from-blue-50 to-cyan-50 px-4 py-2 border-b border-gray-200">
                                            <div className="flex items-center space-x-2">
                                                <div className="w-6 h-6 bg-blue-100 rounded-lg flex items-center justify-center">
                                                    <span className="text-blue-600 text-xs">📊</span>
                                                </div>
                                                <h3 className="text-base font-bold text-blue-900">{translations[language]?.liveCalcPreview}</h3>
                                            </div>
                                        </div>

                                        <div className="p-3">
                                            <div className="grid grid-cols-1 md:grid-cols-5 gap-2">
                                                <div className="bg-gradient-to-br from-blue-50 to-blue-100 p-3 rounded-lg border border-blue-200">
                                                    <div className="text-center">
                                                        <p className="text-xs text-blue-600 font-medium mb-1">{translations[language]?.baseAmount}</p>
                                                        <p className="text-sm font-bold text-blue-700">
                                                            ₹ {editCompensationForm.allTotal}
                                                        </p>

                                                        {/* Debug */}
                                                        <div className="mt-3 overflow-x-auto">
                                                            <table className="w-full text-[11px] text-left border border-gray-200 rounded-md">
                                                                <tbody className="divide-y divide-gray-200">
                                                                    <tr>
                                                                        <td className="px-2 py-1 text-gray-600">Land</td>
                                                                        <td className="px-2 py-1 text-right font-medium text-gray-800">
                                                                            {parseFloat(Number(editCompensationForm.landAmount || 0).toFixed(2))}
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="px-2 py-1 text-gray-600">Farmpond</td>
                                                                        <td className="px-2 py-1 text-right font-medium text-gray-800">
                                                                            {parseFloat(Number(editCompensationForm.structureAmount || 0).toFixed(2))}
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="px-2 py-1 text-gray-600">Tree</td>
                                                                        <td className="px-2 py-1 text-right font-medium text-gray-800">
                                                                            {parseFloat(Number(editCompensationForm.treeAmount || 0).toFixed(2))}
                                                                        </td>
                                                                    </tr>
                                                                    {/* <tr>
                                                                        <td className="px-2 py-1 text-gray-600">Crop</td>
                                                                        <td className="px-2 py-1 text-right font-medium text-gray-800">
                                                                            {parseFloat(Number(editCompensationForm.cropAmount || 0).toFixed(2))}
                                                                        </td>
                                                                    </tr> */}
                                                                    <tr>
                                                                        <td className="px-2 py-1 text-gray-600">Well</td>
                                                                        <td className="px-2 py-1 text-right font-medium text-gray-800">
                                                                            {parseFloat(Number(editCompensationForm.waterBodyAmount || 0).toFixed(2))}
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="px-2 py-1 text-gray-600">Borewell</td>
                                                                        <td className="px-2 py-1 text-right font-medium text-gray-800">
                                                                            {parseFloat(Number(editCompensationForm.borewellAmount || 0).toFixed(2))}
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="px-2 py-1 text-gray-600">Home</td>
                                                                        <td className="px-2 py-1 text-right font-medium text-gray-800">
                                                                            {parseFloat(Number(editCompensationForm.homeAmount || 0).toFixed(2))}
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="px-2 py-1 text-gray-600">Tin Shed</td>
                                                                        <td className="px-2 py-1 text-right font-medium text-gray-800">
                                                                            {parseFloat(Number(editCompensationForm.tinshedAmount || 0).toFixed(2))}
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="px-2 py-1 text-gray-600">Wire</td>
                                                                        <td className="px-2 py-1 text-right font-medium text-gray-800">
                                                                            {parseFloat(Number(editCompensationForm.wireAmount || 0).toFixed(2))}
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="px-2 py-1 text-gray-600">Other Asset</td>
                                                                        <td className="px-2 py-1 text-right font-medium text-gray-800">
                                                                            {parseFloat(Number(editCompensationForm.otherAssetAmount || 0).toFixed(2))}
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="px-2 py-1 text-gray-600">Pipeline</td>
                                                                        <td className="px-2 py-1 text-right font-medium text-gray-800">
                                                                            {parseFloat(Number(editCompensationForm.pipelineAmount || 0).toFixed(2))}
                                                                        </td>
                                                                    </tr>

                                                                    {/* Final Row */}
                                                                    <tr className="bg-gray-100 font-semibold">
                                                                        <td className="px-2 py-1 text-gray-900">Total (Assets + Land)</td>
                                                                        <td className="px-2 py-1 text-right text-gray-900">
                                                                            {parseFloat(
                                                                                (
                                                                                    Number(editCompensationForm.landAmount || 0) +
                                                                                    Number(editCompensationForm.structureAmount || 0) +
                                                                                    Number(editCompensationForm.treeAmount || 0) +
                                                                                    Number(editCompensationForm.cropAmount || 0) +
                                                                                    Number(editCompensationForm.waterBodyAmount || 0) +
                                                                                    Number(editCompensationForm.borewellAmount || 0) +
                                                                                    Number(editCompensationForm.homeAmount || 0) +
                                                                                    Number(editCompensationForm.tinshedAmount || 0) +
                                                                                    Number(editCompensationForm.wireAmount || 0) +
                                                                                    Number(editCompensationForm.otherAssetAmount || 0) +
                                                                                    Number(editCompensationForm.pipelineAmount || 0)
                                                                                ).toFixed(2)
                                                                            )}
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>

                                                    </div>
                                                </div>

                                                {/* Solatium */}
                                                <div className="bg-gradient-to-br from-green-50 to-green-100 p-3 rounded-lg border border-green-200">
                                                    <div className="text-center">
                                                        <p className="text-xs text-green-600 font-medium mb-1">दिलासा रक्कम</p>
                                                        <p className="text-sm font-bold text-green-700">
                                                            ₹ {editCompensationForm.solatiumAmount}
                                                        </p>
                                                        {/* Debug */}
                                                        <div className="mt-3 overflow-x-auto">
                                                            <table className="w-full text-[11px] text-left border border-gray-200 rounded-md">
                                                                <tbody className="divide-y divide-gray-200">
                                                                    <tr>
                                                                        <td className="px-2 py-1 text-gray-600">Land</td>
                                                                        <td className="px-2 py-1 text-right font-medium text-gray-800">
                                                                            {parseFloat(Number(editCompensationForm.landAmount || 0).toFixed(2))}
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="px-2 py-1 text-gray-600">Farmpond</td>
                                                                        <td className="px-2 py-1 text-right font-medium text-gray-800">
                                                                            {parseFloat(Number(editCompensationForm.structureAmount || 0).toFixed(2))}
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="px-2 py-1 text-gray-600">Tree</td>
                                                                        <td className="px-2 py-1 text-right font-medium text-gray-800">
                                                                            {parseFloat(Number(editCompensationForm.treeAmount || 0).toFixed(2))}
                                                                        </td>
                                                                    </tr>
                                                                    {/* <tr>
                                                                        <td className="px-2 py-1 text-gray-600">Crop</td>
                                                                        <td className="px-2 py-1 text-right font-medium text-gray-800">
                                                                            {parseFloat(Number(editCompensationForm.cropAmount || 0).toFixed(2))}
                                                                        </td>
                                                                    </tr> */}
                                                                    <tr>
                                                                        <td className="px-2 py-1 text-gray-600">Well</td>
                                                                        <td className="px-2 py-1 text-right font-medium text-gray-800">
                                                                            {parseFloat(Number(editCompensationForm.waterBodyAmount || 0).toFixed(2))}
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="px-2 py-1 text-gray-600">Borewell</td>
                                                                        <td className="px-2 py-1 text-right font-medium text-gray-800">
                                                                            {parseFloat(Number(editCompensationForm.borewellAmount || 0).toFixed(2))}
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="px-2 py-1 text-gray-600">Home</td>
                                                                        <td className="px-2 py-1 text-right font-medium text-gray-800">
                                                                            {parseFloat(Number(editCompensationForm.homeAmount || 0).toFixed(2))}
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="px-2 py-1 text-gray-600">Tin Shed</td>
                                                                        <td className="px-2 py-1 text-right font-medium text-gray-800">
                                                                            {parseFloat(Number(editCompensationForm.tinshedAmount || 0).toFixed(2))}
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="px-2 py-1 text-gray-600">Wire</td>
                                                                        <td className="px-2 py-1 text-right font-medium text-gray-800">
                                                                            {parseFloat(Number(editCompensationForm.wireAmount || 0).toFixed(2))}
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="px-2 py-1 text-gray-600">Other Asset</td>
                                                                        <td className="px-2 py-1 text-right font-medium text-gray-800">
                                                                            {parseFloat(Number(editCompensationForm.otherAssetAmount || 0).toFixed(2))}
                                                                        </td>
                                                                    </tr>

                                                                    {/* Final Row */}
                                                                    <tr className="bg-gray-100 font-semibold">
                                                                        <td className="px-2 py-1 text-gray-900">Total (Assets + Land)</td>
                                                                        <td className="px-2 py-1 text-right text-gray-900">
                                                                            {parseFloat(
                                                                                (
                                                                                    Number(editCompensationForm.landAmount || 0) +
                                                                                    Number(editCompensationForm.structureAmount || 0) +
                                                                                    Number(editCompensationForm.treeAmount || 0) +
                                                                                    Number(editCompensationForm.cropAmount || 0) +
                                                                                    Number(editCompensationForm.waterBodyAmount || 0) +
                                                                                    Number(editCompensationForm.borewellAmount || 0) +
                                                                                    Number(editCompensationForm.homeAmount || 0) +
                                                                                    Number(editCompensationForm.tinshedAmount || 0) +
                                                                                    Number(editCompensationForm.wireAmount || 0) +
                                                                                    Number(editCompensationForm.otherAssetAmount || 0)
                                                                                ).toFixed(2)
                                                                            )}
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="bg-gradient-to-br from-green-50 to-green-100 p-3 rounded-lg border border-green-200">
                                                    <div className="text-center">
                                                        <p className="text-xs text-green-600 font-medium mb-1">आगाऊ भरपाई रक्कम</p>
                                                        <p className="text-sm font-bold text-green-700">
                                                            ₹ {parseFloat(editCompensationForm.advanceAmount || 0).toLocaleString()}
                                                        </p>
                                                    </div>
                                                </div>

                                                {/* <div className="bg-gradient-to-br from-orange-50 to-orange-100 p-3 rounded-lg border border-orange-200">
                                                    <div className="text-center">
                                                        <p className="text-xs text-orange-600 font-medium mb-1">आगाऊ व्याज</p>
                                                        <p className="text-sm font-bold text-orange-700">
                                                            ₹ {parseFloat(editCompensationForm.advanceInterestAmount || 0).toLocaleString()}
                                                        </p>
                                                    </div>
                                                </div> */}

                                                {/* Interest */}
                                                <div className="bg-gradient-to-br from-orange-50 to-orange-100 p-3 rounded-lg border border-orange-200">
                                                    <div className="text-center">
                                                        <p className="text-xs text-orange-600 font-medium mb-1">{translations[language]?.interest}</p>
                                                        <p className="text-sm font-bold text-orange-700">
                                                            ₹ {parseFloat(
                                                                (
                                                                    Number(editCompensationForm.interestAmount || 0) +
                                                                    Number(editCompensationForm.advanceInterestAmount || 0)
                                                                ).toFixed(2)
                                                            )}
                                                        </p>
                                                        {/* Debug */}
                                                        <div className="mt-3 overflow-x-auto">
                                                            <table className="w-full text-[11px] text-left border border-gray-200 rounded-md">
                                                                <tbody className="divide-y divide-gray-200">
                                                                    <tr>
                                                                        <td className="px-2 py-1 text-gray-600">Full Interest</td>
                                                                        <td className="px-2 py-1 text-right font-medium text-gray-800">
                                                                            {parseFloat(Number(editCompensationForm.interestAmount || 0).toFixed(2))}
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="px-2 py-1 text-gray-600">Advance Interest</td>
                                                                        <td className="px-2 py-1 text-right font-medium text-gray-800">
                                                                            {parseFloat(Number(editCompensationForm.advanceInterestAmount || 0).toFixed(2))}
                                                                        </td>
                                                                    </tr>

                                                                    {/* Final Row */}
                                                                    <tr className="bg-gray-100 font-semibold">
                                                                        <td className="px-2 py-1 text-gray-900">Total</td>
                                                                        <td className="px-2 py-1 text-right text-gray-900">
                                                                            {parseFloat(
                                                                                (
                                                                                    Number(editCompensationForm.interestAmount || 0) +
                                                                                    Number(editCompensationForm.advanceInterestAmount || 0)
                                                                                ).toFixed(2)
                                                                            )}
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="bg-gradient-to-br from-red-50 to-red-100 p-3 rounded-lg border border-red-200">
                                                    <div className="text-center">
                                                        <p className="text-xs text-red-600 font-medium mb-1">{translations[language]?.totalCompensation}</p>
                                                        <p className="text-base font-bold text-red-700">
                                                            ₹ {parseFloat(editCompensationForm.totalCompensation || 0).toLocaleString()}
                                                        </p>

                                                        {/* Debug */}
                                                        <div className="mt-2 overflow-x-auto">
                                                            <table className="w-full text-[11px] text-left border border-red-200 rounded-md">
                                                                <tbody className="divide-y divide-red-200">
                                                                    <tr>
                                                                        <td className="px-2 py-1 text-red-600">Assets & Land Final</td>
                                                                        <td className="px-2 py-1 font-medium text-red-700 text-right">
                                                                            {parseFloat(editCompensationForm.allTotal || 0).toFixed(2)}
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="px-2 py-1 text-red-600">Solatium Amount</td>
                                                                        <td className="px-2 py-1 font-medium text-red-700 text-right">
                                                                            {parseFloat(editCompensationForm.solatiumAmount || 0).toFixed(2)}
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="px-2 py-1 text-red-600">+ Interest</td>
                                                                        <td className="px-2 py-1 font-medium text-red-700 text-right">
                                                                            {parseFloat(
                                                                                (
                                                                                    Number(editCompensationForm.interestAmount || 0) +
                                                                                    Number(editCompensationForm.advanceInterestAmount || 0)
                                                                                ).toFixed(2)
                                                                            )}
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="px-2 py-1 text-red-600">- Advance Payment</td>
                                                                        <td className="px-2 py-1 font-medium text-red-700 text-right">
                                                                            {parseFloat(editCompensationForm.advanceAmount || 0).toFixed(2)}
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="px-2 py-1 text-red-600">- Govt. Recovery</td>
                                                                        <td className="px-2 py-1 font-medium text-red-700 text-right">
                                                                            {parseFloat(editCompensationForm.govtRecovery || 0).toFixed(2)}
                                                                        </td>
                                                                    </tr>
                                                                    <tr className="bg-red-100 font-semibold">
                                                                        <td className="px-2 py-1 text-red-700">Total</td>
                                                                        <td className="px-2 py-1 text-red-700 text-right">
                                                                            {(
                                                                                (parseFloat(editCompensationForm.allTotal || 0)) +
                                                                                (parseFloat(editCompensationForm.solatiumAmount || 0)) +
                                                                                (parseFloat(editCompensationForm.interestAmount || 0)) +
                                                                                (parseFloat(editCompensationForm.advanceInterestAmount || 0)) -
                                                                                (parseFloat(editCompensationForm.advanceAmount || 0)) -
                                                                                (parseFloat(editCompensationForm.govtRecovery || 0))
                                                                            ).toFixed(2)}
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ) : ('')}

                                {/* Administrative Details */}
                                <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden">
                                    <div className="bg-gradient-to-r from-gray-50 to-emerald-50 px-4 py-2 border-b border-gray-200">
                                        <div className="flex items-center space-x-2">
                                            <div className="w-6 h-6 bg-gray-100 rounded-lg flex items-center justify-center">
                                                <span className="text-gray-600 text-xs">⚙️</span>
                                            </div>
                                            <h3 className="text-base font-bold text-gray-900">{translations[language]?.adminDetails}</h3>
                                        </div>
                                    </div>

                                    <div className="p-3">
                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                                            <div>
                                                <label className="block text-xs font-medium text-gray-700 mb-1">{translations[language]?.compStatus}</label>
                                                <select
                                                    value={editCompensationForm.compensationStatus}
                                                    onChange={(e) => handleEditFormChange('compensationStatus', e.target.value)}
                                                    className="w-full px-2 py-2 border border-gray-300 rounded text-xs focus:ring-1 focus:ring-gray-500 focus:border-transparent bg-gray-50 font-medium"
                                                >
                                                    <option value="Pending">{translations[language]?.pending}</option>
                                                    <option value="Completed">{translations[language]?.completed}</option>
                                                    {/* <option value="Paid">Paid</option>
                          <option value="On Hold">On Hold</option> */}
                                                </select>
                                            </div>

                                            <div>
                                                <label className="block text-xs font-medium text-gray-700 mb-1">{translations[language]?.valuationDate}</label>
                                                <input
                                                    type="date"
                                                    value={editCompensationForm.valuationDate}
                                                    onChange={(e) => handleEditFormChange('valuationDate', e.target.value)}
                                                    className="w-full px-2 py-2 border border-gray-300 rounded text-xs focus:ring-1 focus:ring-gray-500 focus:border-transparent bg-gray-50 font-medium"
                                                />
                                            </div>

                                            <div>
                                                <label className="block text-xs font-medium text-gray-700 mb-1">{translations[language]?.approvalDate}</label>
                                                <input
                                                    type="date"
                                                    value={editCompensationForm.compensationApprovalDate}
                                                    onChange={(e) => handleEditFormChange('compensationApprovalDate', e.target.value)}
                                                    className="w-full px-2 py-2 border border-gray-300 rounded text-xs focus:ring-1 focus:ring-gray-500 focus:border-transparent bg-gray-50 font-medium"
                                                />
                                            </div>

                                            <div>
                                                <label className="block text-xs font-medium text-gray-700 mb-1">{translations[language]?.approvalAuthority}</label>
                                                <input
                                                    type="text"
                                                    value={editCompensationForm.compensationApprovalAuthority}
                                                    onChange={(e) => handleEditFormChange('compensationApprovalAuthority', e.target.value)}
                                                    className="w-full px-2 py-2 border border-gray-300 rounded text-xs focus:ring-1 focus:ring-gray-500 focus:border-transparent bg-gray-50 font-medium"
                                                    placeholder="Enter approval authority"
                                                />
                                            </div>

                                            <div className="md:col-span-2">
                                                <label className="block text-xs font-medium text-gray-700 mb-1">{translations[language]?.approvalReference}</label>
                                                <input
                                                    type="text"
                                                    value={editCompensationForm.compensationApprovalReference}
                                                    onChange={(e) => handleEditFormChange('compensationApprovalReference', e.target.value)}
                                                    className="w-full px-2 py-2 border border-gray-300 rounded text-xs focus:ring-1 focus:ring-gray-500 focus:border-transparent bg-gray-50 font-medium"
                                                    placeholder="Enter approval reference"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Action Buttons */}
                                <div className="flex justify-end space-x-2 pt-2 border-t border-gray-200">
                                    <button
                                        type="button"
                                        onClick={() => {
                                            setShowEditModal(false);
                                            setEditError(null);
                                            setEditSuccess(false);
                                            setCurrentEditRecord(null);
                                        }}
                                        disabled={editingCompensation}
                                        className="px-2 py-2 bg-gray-100 hover:bg-gray-200 disabled:bg-gray-50 text-gray-700 rounded-lg transition-all duration-200 font-medium border border-gray-300 text-xs"
                                    >
                                        {translations[language]?.Cancel}
                                    </button>

                                    <button
                                        onClick={() => handleGenerateNoticeForRecord(currentEditRecord)}
                                        className="flex items-center gap-2 px-4 py-2 bg-blue-700 hover:bg-blue-600 text-white rounded-lg text-xs"
                                    >
                                        <FileText className="h-4 w-4" />
                                        <span>
                                            {translations[language]?.generateNoticeForThisOwner || "Generate Notice"} (कलम 37(2))
                                        </span>
                                    </button>

                                    <button
                                        type="button"
                                        onClick={handleEditCompensation}
                                        disabled={editingCompensation || editSuccess}
                                        className="flex items-center space-x-2 px-2 py-2 bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 disabled:from-orange-300 disabled:to-orange-400 text-white rounded-lg transition-all duration-200 font-medium shadow-lg text-xs"
                                    >
                                        {editingCompensation ? (
                                            <>
                                                <Loader className="h-4 w-4 animate-spin" />
                                                <span>{translations[language]?.updating}</span>
                                            </>
                                        ) : editSuccess ? (
                                            <>
                                                <span className="text-xs">✅</span>
                                                <span>{translations[language]?.updateSuccessShort}</span>
                                            </>
                                        ) : (
                                            <>
                                                <Save className="h-4 w-4" />
                                                <span>{translations[language]?.updateCompensation}</span>
                                            </>
                                        )}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div >
            )}

            {/* Download Confirmation Dialog */}
            {/* {
        showConfirm && (
          <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50">
            <div className="bg-white p-8 rounded-2xl shadow-2xl max-w-md w-full mx-4 border border-gray-200">
              <div className="text-center mb-6">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Download className="w-8 h-8 text-blue-600" />
                </div>
                <h3 className="text-xl font-semibold text-gray-800 mb-2">{translations[language]?.downloadReport}</h3>
                <p className="text-gray-600">
                  {translations[language]?.downloadCSV} <span className="font-medium text-blue-600">{getCurrentLocationDescription()}</span>?
                </p>
              </div>

              <div className="flex space-x-3">
                <button
                  onClick={handleDownload}
                  disabled={downloading}
                  className="flex-1 flex items-center justify-center space-x-2 px-6 py-3 bg-blue-600 hover:bg-blue-700 disabled:bg-gray-400 text-white rounded-xl font-medium transition-all duration-200 shadow-lg hover:shadow-xl disabled:cursor-not-allowed"
                >
                  {downloading ? (
                    <Loader className="h-5 w-5 animate-spin" />
                  ) : (
                    <Download className="h-5 w-5" />
                  )}
                  <span>{downloading ? 'Downloading...' : 'Download CSV'}</span>
                </button>

                <button
                  onClick={() => setShowConfirm(false)}
                  disabled={downloading}
                  className="px-6 py-3 bg-gray-100 hover:bg-gray-200 disabled:bg-gray-100 text-gray-700 rounded-xl font-medium transition-all duration-200 disabled:cursor-not-allowed"
                >
                  {translations[language]?.cancel}
                </button>
              </div>
            </div>
          </div>
        )
      } */}

            {/* Land Acquisition Notice Component */}
            <LandAcquisitionNotice
                // compensationData prop is now removed
                selectedDistrict={selectedDistrict}
                selectedTaluka={selectedTaluka}
                selectedVillage={selectedVillage}
                currentProjectName={currentProjectName}
                currentProjectId={currentProjectId}
                currentProposalId={currentProposalId}
                isVisible={showNotice}
                proposalData={proposalData}
                ownerId={noticeTargetId} // This will be 'all' or a specific ID
                onClose={() => {
                    setShowNotice(false);
                    setNoticeTargetId(null); // Reset the target ID
                }}
            />

            {/* {showConfirmationModal && (
        <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center">
          <div className="bg-white rounded-xl shadow-lg p-6 w-full max-w-md">
            <div className="flex items-center mb-4">
              <div className="bg-red-100 p-2 rounded-full mr-3">
                <svg className="w-6 h-6 text-red-600" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M18 10c0 4.418-3.582 8-8 8s-8-3.582-8-8 3.582-8 8-8 8 3.582 8 8zm-8 3a1 1 0 100-2 1 1 0 000 2zm1-7H9v4h2V6z" />
                </svg>
              </div>
              <h3 className="text-lg font-semibold text-gray-800">You are about to proceed</h3>
            </div>
            <p className="text-sm text-gray-600 mb-6">
              Do you really want to continue? There are still some surveys left to be verified.
            </p>
            <div className="flex justify-end gap-3">
              <button
                className="px-4 py-2 bg-gray-100 text-gray-700 rounded hover:bg-gray-200"
                onClick={() => setShowConfirmationModal(false)}
              >
                No
              </button>
              <button
                className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
                onClick={() => {
                  setShowConfirmationModal(false);
                  if (onConfirmAction) onConfirmAction();
                }}
              >
                Yes, Continue
              </button>
            </div>
          </div>
        </div>
      )} */}

            {showSignaturePad && pdfForSigning && (
                <SignaturePad
                    pdfFile={pdfForSigning}
                    onSign={(signaturesArray) => {
                        setShowSignaturePad(false);

                        signDocument(pdfForSigning, signaturesArray).then(async (signedPdf) => {
                            const selectedProject = JSON.parse(localStorage.getItem("selectedProject") || "{}");
                            const projectId = selectedProject?.id || selectedProject?.project_id;
                            const proposalId = localStorage.getItem("currentProposalId");

                            await apiService.postAddSignaturePDF(
                                projectId,
                                proposalId,
                                "parishisht1",
                                signedPdf
                            );

                            const sectionRes = await apiService.getSectionFile(
                                projectId,
                                proposalId,
                                "parishisht1"
                            );

                            if (sectionRes?.isSignAvailable) {
                                setPreviewUrl(sectionRes.data[0].file_path);
                            }

                            setPdfForSigning(null);
                        });
                    }}
                    onCancel={() => {
                        setShowSignaturePad(false);
                        setPdfForSigning(null);
                    }}
                />
            )}

        </div>
    );
};

export default CompensationTable;